(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/app-detail/app-detail.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/app-detail/app-detail.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n     <div style=\"padding: 5px;\" class=\"content\">\n      <div class=\"mymenu\">\n        <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n        </p-menubar>\n      </div>\n      <div class='card'>\n\n        <label class=\"secondary\">{{ 'MANAGE.APPS' | translate }}</label>\n        /\n       <label class=\"primary\">{{ 'GENERAL.EDITAPPLICATION' | translate }}</label>\n            <div class=\"card-body\">\n                <div class=\"example-container\">\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appname\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"AppName\"> \n                    <label for=\"appname\">{{ 'GENERAL.APPNAME' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appurl\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"AppUrl\"> \n                    <label for=\"appurl\">{{ 'GENERAL.APPURL' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appconfig\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"AppConfig\"> \n                    <label for=\"appconfig\">{{ 'GENERAL.APPCONFIG' | translate }}</label>\n                  </span>\n                  <br>\n              </div>\n            </div>\n      \n        <div class='card-footer'>\n          <div class=\"form-group\">\n              <p class=\"alert\" *ngIf=\"isAlert\" id=\"alert\">{{ alertMessage }}</p>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n                (click)=\"onCancel()\"\n                [disabled]=\"loading\"\n                id=\"cancel\">\n              </button>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                (click)=\"Save()\"\n                [disabled]=\"loading\"\n                id=\"save\">\n              </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-password/change-password.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-password/change-password.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">          \n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <label style=\"color: transparent;\" *ngIf=\"!isManage\">no</label>\n\n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\" *ngIf=\"isManage\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item *ngIf=\"isLanguage\" (click)=\"gotoLanguage()\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n     <div style=\"padding: 5px;\" class=\"content\">\n      <div class='card'>\n      \n       <label class=\"primary\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</label>\n            <div class=\"card-body\">\n                <div class=\"example-container\">\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <!--<input id=\"curpass\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"OldPass\">-->\n                    <input id=\"curpass\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"OldPass\">\n                    <label for=\"curpass\">{{ 'GENERAL.CURRENTPASSWORD' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"newpass\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"NewPass\"> \n                    <label for=\"newpass\">{{ 'GENERAL.NEWPASSWORD' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"confpass\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"ConfirmPass\"> \n                    <label for=\"confpass\">{{ 'GENERAL.CONFIRMNEWPASSWORD' | translate }} (*)</label>\n                  </span>\n                  <br>\n              </div>\n            </div>\n      \n        <div class='card-footer'>\n          <div class=\"form-group\">\n              <p class=\"alert\" *ngIf=\"isAlert\" id=\"alert\">{{ alertMessage }}</p>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n                (click)=\"onCancel()\"\n                [disabled]=\"loading\"\n                id=\"cancel\">\n              </button>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                (click)=\"Save()\"\n                [disabled]=\"loading\"\n                id=\"save\">\n              </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n[closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n<p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-pin/change-pin.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-pin/change-pin.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <label style=\"color: transparent;\" *ngIf=\"!isManage\">no</label>\n\n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\" *ngIf=\"isManage\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item *ngIf=\"isLanguage\" (click)=\"gotoLanguage()\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n     <div style=\"padding: 5px;\" class=\"content\">\n      <div class='card'>\n      \n       <label class=\"primary\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</label>\n            <div class=\"card-body\">\n                <div class=\"example-container\">\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"curpin\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"OldPin\"> \n                    <label for=\"curpin\">{{ 'GENERAL.CURRENTPIN' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"newpin\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"NewPin\"> \n                    <label for=\"newpin\">{{ 'GENERAL.NEWPIN' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"confpin\" type=\"password\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"ConfirmPin\"> \n                    <label for=\"confpin\">{{ 'GENERAL.CONFIRMNEWPIN' | translate }} (*)</label>\n                  </span>\n                  <br>\n              </div>\n            </div>\n      \n        <div class='card-footer'>\n          <div class=\"form-group\">\n              <p class=\"alert\" *ngIf=\"isAlert\" id=\"alert\">{{ alertMessage }}</p>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n                (click)=\"onCancel()\"\n                [disabled]=\"loading\"\n                id=\"cancel\">\n              </button>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                (click)=\"Save()\"\n                [disabled]=\"loading\"\n                id=\"save\">\n              </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n[closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n<p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-app/create-app.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-app/create-app.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"content\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='card'>\n        <label class=\"secondary\">{{ 'MANAGE.APPS' | translate }}</label>\n        /\n       <label class=\"primary\">{{ 'CREATEAPP.TITLE' | translate }}</label>\n            <div class=\"card-body\">\n                <div class=\"example-container\">\n                  <!--<div style=\"float: left; padding: 0px; margin: 0px; width: 40%;\">-->\n                  <div>\n                    <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appname\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"AppName\"> \n                    <label for=\"appname\">{{ 'GENERAL.APPNAME' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appurl\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"AppUrl\"> \n                    <label for=\"appurl\">{{ 'GENERAL.APPURL' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"appconfig\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"AppConfig\"> \n                    <label for=\"appconfig\">{{ 'GENERAL.APPCONFIG' | translate }}</label>\n                  </span>\n                  <br>\n                  </div>\n                </div>\n            </div>\n      \n        <div class='card-footer'>\n          <div class=\"form-group\">\n            <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n              style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n              (click)=\"onCancel()\"\n              [disabled]=\"loading\"\n              id=\"cancel\">\n            </button>\n            <button pButton type=\"button\" label=\"{{ 'GENERAL.CREATE' | translate }}\"\n              style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n              (click)=\"onCreate()\"\n              [disabled]=\"loading\"\n              id=\"create\">\n            </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n     \n\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-instance/create-instance.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-instance/create-instance.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"hicon\" *ngIf=\"hicon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"content\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='card'>\n        <label class=\"secondary\">{{ 'MANAGE.INSTANCES' | translate }}</label>\n        /\n       <label class=\"primary\">{{ 'CREATEINSTANCE.TITLE' | translate }}</label>\n      \n<!-- <div style=\"text-align: center; margin-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div> -->\n\n        <div class=\"card-body\">\n          <div class=\"example-container\" *ngIf=\"apps && apps.length\">\n            <br>\n            <div class=\"example-containerx\" style=\"float: left; padding: 0px; margin: 0px; width: 40%;\">\n              <span class=\"ui-float-label\">\n                <p-dropdown [options]=\"apps\"\n                            [(ngModel)]=\"app\"\n                            id=\"selectapp\"\n                            [style]=\"{'width':'80%', 'height': '35px'}\"\n                            placeholder=\" \"></p-dropdown>\n                      <label for=\"selectapp\">{{ 'GENERAL.SELECTAPP' | translate }} (*)</label>\n              </span>\n              <br>\n              <span class=\"ui-float-label\">\n                <input id=\"instancename\" type=\"text\" size=\"30\" \n                        pInputText style=\"width: 80%;\"\n                        [(ngModel)]=\"InstanceName\"> \n                <label for=\"instancename\">{{ 'GENERAL.INSTANCENAME' | translate }} (*)</label>\n              </span>\n              <br>\n              <span class=\"ui-float-label\">\n                <input id=\"instancedesc\" type=\"text\" size=\"30\" \n                        pInputText style=\"width: 80%;\"\n                        [(ngModel)]=\"InstanceDescription\"> \n                <label for=\"instancedesc\">{{ 'GENERAL.INSTANCEDESC' | translate }} (*)</label>\n              </span>\n              <br>\n              <span class=\"ui-float-label\">\n                <input id=\"instanceparams\" type=\"text\" size=\"30\" \n                        pInputText style=\"width: 80%;\"\n                        [(ngModel)]=\"InstanceParameters\"> \n                <label for=\"instanceparams\">{{ 'GENERAL.INSTANCEPARAMS' | translate }}</label>\n              </span>\n              <br>\n              <span class=\"ui-float-label\">\n                <p-dropdown [options]=\"targets\"\n                            [(ngModel)]=\"target\"\n                            id=\"selecttarget\"\n                            [style]=\"{'width':'80%', 'height':'35px'}\"\n                            placeholder=\" \"></p-dropdown>\n                    <label for=\"selecttarget\">{{ 'GENERAL.SELECTTARGET' | translate }} (*)</label>\n              </span>\n  \n              <p style=\"margin-top: 30px; margin-bottom: 25px;\">\n                {{ 'GENERAL.INSTANCEICON' | translate }}\n                <img [src]=\"icon\" style=\"width: 25px; height: 25px; margin-right: 15px; margin-left: 10px; margin-bottom: -5px;\"\n                      *ngIf=\"icon\"/>\n                <!--<button type=\"button\" mat-raised-button (click)=\"fileInput.click()\" style=\"margin-top: -15px;\">-->\n                <button type=\"button\" mat-raised-button (click)=\"showIcons()\" style=\"margin-top: -15px;\"\n                        id=\"selecticon\">\n                  {{ 'GENERAL.SELECTICON' | translate }}\n                </button>\n                <input type=\"file\" hidden (change)=\"onFileSelected()\" #fileInput id=\"file\" accept=\"image/*\">\n                {{ filename }}\n              </p>\n            </div>\n            <div class=\"example-container\" id=\"orgsec\" \n                  style=\"float: right; margin-bottom: 25px; width: 60%;\">\n              <span class=\"ui-float-label\">\n                <p-dropdown [options]=\"organisations\"\n                            [(ngModel)]=\"org\"\n                            id=\"selectorg\" (onChange)=\"get()\"\n                            [style]=\"{'width':'565px', 'height': '35px'}\"\n                            ></p-dropdown>\n                      <label for=\"selectorg\">{{ 'GENERAL.SELECTORGANISATION' | translate }} (*)</label>\n              </span>\n              <p-pickList [source]=\"groups1\" [target]=\"groups2\" \n                          sourceHeader=\"{{ 'GENERAL.ALLGROUPS' | translate}}\" \n                          targetHeader=\"{{ 'GENERAL.GROUPSININSTANCE' | translate}}\"\n                          filterBy=\"groupName\"\n                          dragdrop=\"true\"\n                          sourceFilterPlaceholder=\"{{ 'GENERAL.FILTERBYGROUPNAME' | translate }}\"\n                          targetFilterPlaceholder=\"{{ 'GENERAL.FILTERBYGROUPNAME' | translate }}\"\n                          [style]=\"{'width':'250px', 'height': '250'}\"\n                          [sourceStyle]=\"{'width':'250px', 'height': '250px'}\"\n                          [targetStyle]=\"{'width':'250px', 'height': '250px'}\"\n                          [showSourceControls]=\"false\"\n                          [showTargetControls]=\"false\">\n                <ng-template let-group pTemplate=\"item\">\n                    <div class=\"ui-helper-clearfix\">\n                        <div style=\"font-size:14px; float:center;\">\n                          {{ group.groupName }}\n                        </div>\n                    </div>\n                </ng-template>\n              </p-pickList>\n            </div>\n            <br>\n          </div>\n         </div>\n         <br>\n        <div class='card-footers' *ngIf=\"apps && apps.length\" style=\"margin-top: 5px;\">\n          <div class=\"form-groups\">\n              <p class=\"alert\" *ngIf=\"isAlert\" id=\"alert\">{{ alertMessage }}</p>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n                (click)=\"onCancel()\"\n                [disabled]=\"loading\"\n                id=\"cancel\">\n              </button>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CREATE' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                (click)=\"onCreate()\"\n                [disabled]=\"loading\"\n                id=\"create\">\n              </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n\n<p-dialog header=\"{{ 'GENERAL.SELECTICON' | translate }}\" [(visible)]=\"display\"\n                      modal=\"true\"\n                      [style]=\"{padding: '25px'}\">\n                      <p-scrollPanel [style]=\"{width: '100%', height: '300px'}\">\n                        <p-card [style]=\"{width: '110px', margin: '0px', padding: '0px'}\" styleClass=\"ui-card-shadow\"\n                                *ngFor=\"let icon of icons\"\n                                class=\"icon-card\"\n                                (click)=\"select(icon)\"\n                                id=\"{{ icon.iconName }}\">\n                          <div style=\"text-align: center;\">\n                            <img [src]=\"icon.saveicon\" style=\"width: 50px; height: 50px;\">\n                          </div>\n                          <p-footer>\n                            <p style=\"text-align: center; font-size: small;\" class=\"over\">{{ icon.iconName }}</p>\n                            <p style=\"text-align: center; font-size: smaller;\" class=\"over\">{{ 'GENERAL.INSTANCES' | translate}} ({{ icon.count }})</p>\n                          </p-footer>\n                        </p-card>\n                    </p-scrollPanel>\n    \n    <p-footer>\n      <button type=\"button\" pButton (click)=\"display=false\" label=\"{{ 'GENERAL.CLOSE' | translate }}\"></button>\n  </p-footer>\n  </p-dialog>\n     \n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading || load\" [modal]=\"true\" [showHeader]=\"false\"\n[closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n<p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/home1/home1.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/home1/home1.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n  <div class=\"cont\" *ngIf=\"browser\">\n    <div class=\"header\" [style.background]=\"portalHeaderColor\">\n      <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n        <button id=\"home\" (click)=\"showHome()\">\n          <a class=\"nav-link\" mat-list-item>\n            <img id=\"homeicon\" src=\"assets/home.png\" (click)=\"showHome()\"/>\n          </a>\n      </button>\n      <!--<img id=\"homeicon\" src=\"assets/home.png\" (click)=\"showHome()\"/>-->\n      <!--<button id=\"home\">\n        <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n          <img id=\"homeicon\" src=\"assets/home.png\"/>\n        </a>\n    </button>-->\n          <!--<span id=\"Title\">{{ 'TOOLBAR.TITLE' | translate }}</span>-->\n          <span id=\"Title\">{{ title }}</span>\n          <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n                style=\"max-width: 100px; max-height: 100px; min-width: 25px; min-height: 25px;\n                 margin-left: 5px; margin-bottom: 3px;\"/>\n          <div class=\"spacer\"></div>\n          <label style=\"font-style: normal; font-size: 15px; font-weight: normal;\"\n                  id=\"org\">{{ organisation }}</label>\n          <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n            {{ fullName }}\n            <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n          </button>\n\n          <!-- <button type=\"button\" pButton pRipple [matMenuTriggerFor]=\"accountMenu\"\n                  label=\"{{ fullName }}\" iconPos=\"right\" icon=\"pi pi-user\" id=\"accountbutton\"\n                  style=\"background-color: transparent; border: none; font-size: 15px;\">\n          </button> -->\n\n          <mat-menu #accountMenu=\"matMenu\">\n            <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                    >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n            <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n            <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n            <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n          </mat-menu>\n        \n          <label style=\"color: transparent;\" *ngIf=\"!isManage\">no</label>\n\n          <button id=\"settingsbutton\" *ngIf=\"isManage\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n            <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n          </button>\n          <mat-menu #settingsMenu=\"matMenu\">\n            <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                    id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n            <button mat-menu-item *ngIf=\"isLanguage\" (click)=\"gotoLanguage()\"\n                    id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n          </mat-menu>\n        </div>\n    </div>\n  \n    <!-- <div class=\"appmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n      <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n             label=\"{{ 'GENERAL.APPS' | translate }}\" id=\"appsmenu\"\n             style=\"background-color: transparent; border: none; color: black; font-size: 20px;\"\n             (click)=\"menu.toggle($event)\"></button>\n      <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\">\n      </p-menu> -->\n      \n    <div class=\"appmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n      <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n              label=\"{{ 'GENERAL.APPS' | translate }}\" id=\"appsmenu\"\n              style=\"background-color: transparent; border: none; color: black; font-size: 20px;\"\n              (click)=\"menuClicked()\"></button>\n      <ul *ngIf=\"issmallmenu\" style=\"position: absolute; z-index: 10; list-style-type: none;\n                  background-color: white; width: 100%; margin-top: -5px; color: black;\">\n        <li style=\"padding: 10px; width: 100%; margin-left: -25px; color: black;\"\n            *ngFor=\"let item of instances2\" class=\"hover\"\n            (click)=\"show(item)\" [routerLink]=\"['/home', item.instanceName]\">\n          <a [routerLink]=\"['/home', item.instanceName]\" style=\"color: black;\"\n              (click)=\"show(item)\" class=\"hover\">\n            <div style=\"display: flex;\">\n              <img [src]=\"item.IIcon\"\n                  style=\"max-width: 40px; max-height: 40px; margin-right: 5px;\"/>\n              <div style=\"margin-top: 3px;\">\n                <label class=\"hover\" style=\"font-size: 16px; font-weight: bold;\">{{ item.instanceName }}</label>\n                <br>\n                <label class=\"hover\" style=\"font-size: 15px;\">{{ item.instanceDescription }}</label>\n              </div>\n            </div>\n          </a>\n        </li>\n      </ul>\n\n    </div>\n\n    <div class=\"content\">\n      \n      <mat-drawer-container style=\"position: relative; height: 100%;\">\n        <mat-drawer mode=\"side\" opened class=\"app-sidenav\"\n                    style=\"margin-top: 42px; position: fixed; margin-bottom: 50px; width: 250px; border: none;\"\n                   *ngIf=\"drawer\" id=\"drawer\">\n          <!--<p style=\"color: gray; font-size: medium; font-weight: bolder; margin-top: 15px; text-align: center;\">Loading...</p>-->\n            <mat-nav-list *ngFor=\"let instance of instances2\">\n              <a class=\"nav-link\" [routerLink]=\"['/home', instance.instanceName]\" \n                  routerLinkActive='active' mat-list-item (click)=\"show(instance)\"\n                  style=\"height: 50px; margin-bottom: -10px; font-size: small; color: black;\"\n                  id=\"{{ instance.instanceName }}\">\n                  <img [src]=\"instance.IIcon\" id=\"{{ instance.instanceId }}\"\n                        style=\"height: 25px; width: 25px; margin-right: 10px; margin-left: -5px;\"/>\n                      {{ instance.instanceName }}\n                    </a>\n              </mat-nav-list>\n              <a style=\"position: fixed; bottom: 0; height: 50px; background-color: white; text-align: end;\n                        width: 250px;\">\n                <!--<hr style=\"margin-top: -2px; margin-bottom: -1px; border-color: lightgray;\">-->\n                <button pButton type=\"button\"\n                        style=\"float: right; background-color: transparent; font-size: x-large; color: black;\n                                border: none;\" (click)=\"minimize()\"\n                        icon=\"pi pi-angle-double-left\" iconPos=\"center\"\n                        id=\"minimize\">\n                        <div style=\"float: right; border-right: thin solid white; height: 50px;\"></div>\n            </button>\n              </a>\n        </mat-drawer>\n\n        <mat-drawer mode=\"side\" opened class=\"app-sidenav\"\n                    style=\"margin-top: 42px; position: fixed; margin-bottom: 50px;\n                           width: 65x; min-width: 65px; max-width: 65px; border: none;\"\n                   *ngIf=\"drawer2\" id=\"drawer2\">\n          <!--<p style=\"color: gray; font-size: medium; font-weight: bolder; margin-top: 15px; text-align: center;\">Loading...</p>-->\n            <mat-nav-list *ngFor=\"let instance of instances2\">\n              <a class=\"nav-link\" [routerLink]=\"['/home', instance.instanceName]\" \n                  routerLinkActive='active' mat-list-item (click)=\"show(instance)\"\n                  style=\"height: 50px; margin-bottom: -10px; font-size: small; color: black;\"\n                  id=\"{{ instance.instanceName }}\">\n                  <img [src]=\"instance.IIcon\" id=\"{{ instance.instanceId }} {{ instance.instanceId }}\"\n                        style=\"height: 35px; width: 35px; margin-right: 10px; margin-left: -5px;\"/>\n                    </a>\n              </mat-nav-list>\n              <a style=\"position: fixed; bottom: 0; height: 50px; background-color: white;\n                        text-align: end; width: 65px;\">\n                <!--<hr style=\"margin-top: -2px; margin-bottom: -1px; border-color: lightgray;\">-->\n                <button pButton type=\"button\"\n                    style=\"float:left; background-color: transparent; font-size: x-large; color: black;\n                            border: none; text-align: center; margin-left: 5px;\" (click)=\"maximize()\"\n                    icon=\"pi pi-angle-double-right\" iconPos=\"center\"\n                    id=\"maximize\">\n                    <div style=\"float: right; border-right: thin solid white; height: 50px; margin-right: -3px;\"></div>\n                </button>\n              </a>\n        </mat-drawer>\n        <mat-drawer-content [style.background]=\"color\">\n          <!-- <div style=\"text-align: center; margin-top: 175px;\" *ngIf=\"!isins\">\n            <p-progressSpinner></p-progressSpinner>\n          </div> -->\n            <div *ngIf=\"div\">\n             <div style=\"margin: auto; padding: 5%;\" *ngIf=\"isins\" class=\"wrap\">\n                 <mat-card class=\"example-card\" *ngFor=\"let instance of instances\"\n                            (click)=\"saver(instance)\">\n                     <div style=\"margin: auto;\" id=\"list\">\n                        <button id=\"{{ instance.instanceName }}\" style=\"background-color: transparent; border-color: transparent;\"\n                                (click)=\"saver(instance)\">\n                          <mat-card-header style=\"vertical-align: middle; text-align: center;\">\n                              <div mat-card-avatar class=\"example-header-image\">\n                                  <img [src]=\"instance.IIcon\" alt=\"image\" style=\"height: 100px; width: 90px; margin-left: -20px; margin-top: -5px;\">\n                              </div>\n                              <div style=\"vertical-align: auto;\">\n                                <mat-card-title style=\"text-align: left; font-size: 25px; font-weight: bold;\" class=\"over\">\n                                  {{ instance.instanceName }}\n                                </mat-card-title>\n                                <mat-card-subtitle style=\"text-align: left; vertical-align: middle; font-size: 20px;\"> \n                                  <p> {{ instance.instanceDescription }} </p>                         \n                                </mat-card-subtitle>\n                              </div>\n                            </mat-card-header>\n                        </button>\n                     </div>\n                   </mat-card>\n             </div>\n            </div>\n            <!--<p style=\"text-align: center; vertical-align: middle;\" *ngIf=\"isload\">{{ 'GENERAL.LOADING' | translate }}</p>-->\n            <!-- <div style=\"text-align: center; margin-top: 175px;\" *ngIf=\"isload\">\n              <p-progressSpinner></p-progressSpinner>\n            </div> -->\n            <!-- PROGRESS SPINNER -->\n            <p-dialog [(visible)]=\"isload\" [modal]=\"true\" [showHeader]=\"false\"\n                        [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\"\n                        [style]=\"{'margin-left': '150px'}\">\n                <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n              </p-dialog>\n            <div *ngFor=\"let instance of instances2\" class=\"FrameContainer\">\n              <iframe [style.visibility]=\"instance.isVisible ? 'visible' : 'hidden'\"\n                      [src]='instance.fUrl' frameborder=\"0\"\n                      id=\"{{ instance.instanceName }}{{ instance.instanceName }}\"\n                      style=\"height: 100%;\">\n              </iframe>\n              </div>\n        </mat-drawer-content>\n      </mat-drawer-container>\n    </div>\n\n  </div>\n\n  <p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n    <p-footer>\n      <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n  </p-footer>\n  </p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"!isins\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/icons/icons.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/icons/icons.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"contents\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='cards'>\n        <div class='card-bodys'>\n          \n      <p class=\"headerss\">\n        <label class=\"primary\">\n          {{ 'GENERAL.ICONS' | translate }}\n        </label>\n        <button pButton type=\"button\" label=\"{{ 'GENERAL.UPLOADICON' | translate }}\"\n                    class=\"ui-button-raised ui-button-primary\"\n                    style=\"float: right;\" icon=\"pi pi-plus\" iconPos=\"left\"\n                    (click)=\"gotoupload()\"\n                    id=\"gotoupload\">\n            </button>\n      </p>\n          <div class=\"card-body\">\n            <div class=\"example-container\">\n              <p-card [style]=\"{width: '110px', margin: '0px', padding: '0px'}\" styleClass=\"ui-card-shadow\"\n                      *ngFor=\"let icon of icons\"\n                      class=\"icon-card\"\n                      id=\"{{ icon.iconName }}\">\n                <div style=\"text-align: center;\">\n                  <img [src]=\"icon.saveicon\" style=\"width: 50px; height: 50px;\">\n                </div>\n                <p-footer>\n                  <p style=\"text-align: center; font-size: small;\" class=\"over\">{{ icon.iconName }}</p>\n                  <p style=\"text-align: center; font-size: smaller;\" class=\"over\">{{ 'GENERAL.INSTANCES' | translate}} ({{ icon.count }})</p>\n                </p-footer>\n            </p-card>\n            </div>\n          </div>\n          <!--<button pButton type=\"button\" label=\"{{ 'GENERAL.LOADMORE' | translate }}\"\n                  *ngIf=\"apps && apps.length\"\n                  class=\"ui-button-raised ui-button-primary\"\n                  (click)=\"loadMore()\" style=\"margin-left: 0px;\"\n                  [disabled]=\"isLoadMore\"\n                  id=\"loadMore\">\n          </button>-->\n        </div>\n      </div>\n     </div>\n     \n<!-- <div style=\"text-align: center; margin-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div> -->\n\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"load\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/instance-detail/instance-detail.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/instance-detail/instance-detail.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"hicon\" *ngIf=\"hicon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"content\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='card'>\n        <label class=\"secondary\">{{ 'MANAGE.INSTANCES' | translate }}</label>\n        /\n       <label class=\"primary\">{{ 'GENERAL.EDITINSTANCE' | translate }}</label>\n      \n<!-- <div style=\"text-align: center; margin-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div> -->\n\n            <div class=\"card-body\">\n                <!--<p *ngIf='!(apps && apps.length)'\n                style=\"color: gray; font-size: medium; font-weight: bolder; margin-top: 15px; text-align: center;\">\n                Loading...</p>-->\n              <div class=\"example-container\" *ngIf=\"apps && apps.length\">\n                <br>\n                <div class=\"example-containerx\" style=\"float: left; padding: 0px; margin: 0px; width: 40%;\">\n                  <span class=\"ui-float-label\">\n                    <input id=\"appname\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"AppName\"\n                            disabled=\"true\"> \n                    <label for=\"appname\">{{ 'GENERAL.APPNAME' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"instancename\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"InstanceName\"> \n                    <label for=\"instancename\">{{ 'GENERAL.INSTANCENAME' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"instancedesc\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"InstanceDescription\"> \n                    <label for=\"instancedesc\">{{ 'GENERAL.INSTANCEDESC' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <input id=\"instanceparams\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 80%;\"\n                            [(ngModel)]=\"InstanceParameters\"> \n                    <label for=\"instanceparams\">{{ 'GENERAL.INSTANCEPARAMS' | translate }}</label>\n                  </span>\n                  <br>\n                  <span class=\"ui-float-label\">\n                    <p-dropdown [options]=\"targets\"\n                                [(ngModel)]=\"target\"\n                                id=\"selecttarget\"\n                                [style]=\"{'width':'80%', 'height':'35px'}\"\n                                placeholder=\" \"></p-dropdown>\n                        <label for=\"selecttarget\">{{ 'GENERAL.SELECTTARGET' | translate }} (*)</label>\n                  </span>\n      \n                  <p style=\"margin-top: 30px; margin-bottom: 25px;\">\n                    {{ 'GENERAL.INSTANCEICON' | translate }}\n                    <img [src]=\"icon\" style=\"width: 25px; height: 25px; margin-right: 15px; margin-left: 10px; margin-bottom: -5px;\"\n                          *ngIf=\"icon\"/>\n                    <!--<button type=\"button\" mat-raised-button (click)=\"fileInput.click()\" style=\"margin-top: -15px;\">-->\n                    <button type=\"button\" mat-raised-button (click)=\"showIcons()\" style=\"margin-top: -15px;\"\n                            id=\"selecticon\">\n                      {{ 'GENERAL.SELECTNEWICON' | translate }}\n                    </button>\n                    <input type=\"file\" hidden (change)=\"onFileSelected()\" #fileInput id=\"file\" accept=\"image/*\">\n                    {{ filename }}\n                  </p>\n                </div>\n                <div class=\"example-container\" id=\"orgsec\" style=\"float: right; padding: 0px; margin-bottom: 25px; width: 60%;\">\n                  <span class=\"ui-float-label\">\n                    <p-dropdown [options]=\"organisations\"\n                                [(ngModel)]=\"org\"\n                                id=\"selectorg\" (onChange)=\"get()\"\n                                [style]=\"{'width':'565px', 'height': '35px'}\"\n                                placeholder=\" \"></p-dropdown>\n                          <label for=\"selectorg\">{{ 'GENERAL.SELECTORGANISATION' | translate }} (*)</label>\n                  </span>\n                  <p-pickList [source]=\"groups1\" [target]=\"groups2\" \n                              sourceHeader=\"{{ 'GENERAL.ALLGROUPS' | translate}}\" \n                              targetHeader=\"{{ 'GENERAL.GROUPSININSTANCE' | translate}}\"\n                              filterBy=\"groupName\"\n                              dragdrop=\"true\"\n                              sourceFilterPlaceholder=\"{{ 'GENERAL.FILTERBYGROUPNAME' | translate }}\"\n                              targetFilterPlaceholder=\"{{ 'GENERAL.FILTERBYGROUPNAME' | translate }}\"\n                              [style]=\"{'width':'250px', 'height': '250'}\"\n                              [sourceStyle]=\"{'width':'250px', 'height': '250px'}\"\n                              [targetStyle]=\"{'width':'250px', 'height': '250px'}\"\n                              [showSourceControls]=\"false\"\n                              [showTargetControls]=\"false\">\n                    <ng-template let-group pTemplate=\"item\">\n                        <div class=\"ui-helper-clearfix\">\n                            <div style=\"font-size:14px; float:center;\">\n                              {{ group.groupName }}\n                            </div>\n                        </div>\n                    </ng-template>\n                  </p-pickList>\n                </div>\n                <br>\n              </div>\n         </div>\n         <br>\n        <div class='card-footers' *ngIf=\"apps && apps.length\" style=\"margin-top: 5px;\">\n          <div class=\"form-groups\">\n              <p class=\"alert\" *ngIf=\"isAlert\" id=\"alert\">{{ alertMessage }}</p>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n                (click)=\"Cancel()\"\n                [disabled]=\"loading\"\n                id=\"cancel\">\n              </button>\n              <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                (click)=\"Save()\"\n                [disabled]=\"loading\"\n                id=\"save\">\n              </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n\n<p-dialog header=\"{{ 'GENERAL.SELECTNEWICON' | translate }}\" [(visible)]=\"display\"\n                      modal=\"true\"\n                      [style]=\"{padding: '25px'}\">\n                      <p-scrollPanel [style]=\"{width: '100%', height: '300px'}\">\n                        <p-card [style]=\"{width: '110px', margin: '0px', padding: '0px'}\" styleClass=\"ui-card-shadow\"\n                                *ngFor=\"let icon of icons\"\n                                class=\"icon-card\"\n                                (click)=\"select(icon)\"\n                                id=\"{{ icon.iconName }}\">\n                          <div style=\"text-align: center;\">\n                            <img [src]=\"icon.saveicon\" style=\"width: 50px; height: 50px;\">\n                          </div>\n                          <p-footer>\n                            <p style=\"text-align: center; font-size: small;\" class=\"over\">{{ icon.iconName }}</p>\n                            <p style=\"text-align: center; font-size: smaller;\" class=\"over\">{{ 'GENERAL.INSTANCES' | translate}} ({{ icon.count }})</p>\n                          </p-footer>\n                        </p-card>\n                    </p-scrollPanel>\n    \n    <p-footer>\n      <button type=\"button\" pButton (click)=\"display=false\" label=\"{{ 'GENERAL.CLOSE' | translate }}\"></button>\n  </p-footer>\n  </p-dialog>\n     \n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading || load\" [modal]=\"true\" [showHeader]=\"false\"\n[closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n<p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/language/language.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/language/language.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n     <div class=\"content\">\n      <div style=\"margin: 25px;\">\n        <p class=\"primary\" id=\"language\">\n          {{ 'TOOLBAR.LANGUAGE' | translate }}\n        </p>\n        <span class=\"ui-float-label\" style=\"margin-top: 5px;\">\n          <p-dropdown [options]=\"langs\"\n                      [(ngModel)]=\"lang\"\n                      id=\"selectlanguage\"\n                      [style]=\"{'width':'30%'}\"\n                      placeholder=\"{{ 'LANGUAGE.SELECTLANGUAGE' | translate }}\"></p-dropdown>\n        </span>\n        <br>\n        <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                    class=\"ui-button-raised ui-button-primary\"\n                    (click)=\"transl()\"\n                    id=\"save\">\n            </button>\n        <!--<p>\n          <label id=\"language\" style=\"margin-right: 5px;\">{{ 'LANGUAGE.SELECTLANGUAGE' | translate }}</label>\n          <select #langSelect (change)=\"trans(langSelect.value)\"\n                  id=\"selectlanguage\">\n            <option *ngFor=\"let lang of translate.getLangs()\" \n                    [value]=\"lang\"\n                    [selected]=\"lang === translate.currentLang\">{{ lang }}</option>\n          </select>\n        </p>-->\n      </div>\n     </div>\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/login/login.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/login/login.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"fill\" style=\"float: left; height: 100%; width: 75%; background-color: #e4e1e1;\" *ngIf=\"isVis\">\n  <img [src]=\"image\" alt=\"{{ 'GENERAL.ORGANISATIONIMAGE' | translate }}\"/>\n</div>\n<div style=\"float: right; height: 100%; width: 25%; text-align: center;\" *ngIf=\"isVis\" class=\"center\">\n  <div style=\"background-color: transparent;\">\n    <div class=\"logins\" style=\"background-color: transparent;\">\n      <div style=\"padding-top: 5px;\">\n        <img [src]=\"icon\" alt=\"{{ 'GENERAL.ORGANISATIONICON' | translate }}\"\n             style=\"max-width: 300px; max-height: 200px; padding-bottom: 25px;\"/>\n      </div>\n      <!--<h2 class=\"login-headers\" style=\"background-color: transparent; color: transparent;\"\n          id=\"loginheader\">{{ 'GENERAL.LOGIN' | translate }}</h2>-->\n      <div class=\"login-containers\" style=\"padding-top: 15px\">\n        <form [formGroup]=\"userform\" (ngSubmit)=\"login()\">\n          <span class=\"ui-float-label\">\n            <input id=\"empid\" type=\"text\" size=\"30\"\n                   pInputText style=\"width: 100%;\"\n                   formControlName=\"empid\"\n                   [(ngModel)]=\"EmployeeId\"> \n            <label for=\"empid\">{{ 'GENERAL.EMPLOYEEIDOREMAIL' | translate }}</label>\n          </span>\n          <br>\n          <span class=\"ui-float-label\" style=\"margin-top: 5px;\">\n            <input id=\"pin\" type=\"password\" size=\"30\"\n                   pInputText style=\"width: 100%;\"\n                   formControlName=\"pin\"\n                   [(ngModel)]=\"Pin\"> \n            <label for=\"pin\">{{ 'GENERAL.PIN' | translate }}</label>\n          </span>\n          <br>\n          <button pButton type=\"submit\" label=\"{{ 'GENERAL.LOGIN' | translate }}\"\n                      style=\"margin-left: 0px; width: 100%; margin-top: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                      [disabled]=\"loading\"\n                      id=\"login\">\n                    </button>\n        </form>\n      </div>\n    \n      <h2 class=\"login-headers\" style=\"background-color: transparent; color: transparent;\"\n      id=\"loginheader\">{{ 'GENERAL.LOGIN' | translate }}</h2>\n\n    </div>\n  </div>\n</div>\n\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<div style=\"text-align: center; padding-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-apps/manage-apps.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-apps/manage-apps.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"contents\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='cards'>\n        <div class='card-bodys'>\n          \n      <p class=\"primary\">\n        {{ 'MANAGE.APPS' | translate }}\n      </p>\n      <button pButton type=\"button\" label=\"{{ 'GENERAL.CREATEAPP' | translate }}\"\n                  class=\"ui-button-raised ui-button-primary\"\n                  style=\"float: right;\" icon=\"pi pi-plus\" iconPos=\"left\"\n                  (click)=\"createApp()\"\n                  id=\"createapp\">\n          </button>\n          <br>\n          <br>\n          <p-table [value]=\"apps\" [styleClass]=\"'base-table'\">\n            <ng-template pTemplate=\"header\">\n                <tr>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.APPID' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.NAME' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.URL' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.CONFIGURATION' | translate }}</th>\n                    <th style=\"width: 115px;\"></th>\n                </tr>\n            </ng-template>\n            <ng-template pTemplate=\"body\" let-app id=\"apps\">\n                <tr>\n                    <td style=\"word-wrap: break-word;\">{{ app.appId }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ app.appName }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ app.appUrl }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ app.config }}</td>\n                    <td style=\"width: 115px;\">\n                      <p-dropdown autoWidth=\"true\"\n                        [options]=\"app.options\"\n                        [style]=\"{'width':'100%'}\"\n                        appendTo=\"body\"\n                        (onChange)=\"saveApp($event, app)\"\n                        id=\"{{ app.appName }}\"\n                        placeholder=\"{{ 'GENERAL.OPTIONS' | translate }}\">\n                      </p-dropdown></td>\n                </tr>\n            </ng-template>\n          </p-table>\n          <br>\n          <button pButton type=\"button\" label=\"{{ 'GENERAL.LOADMORE' | translate }}\"\n                  *ngIf=\"apps && apps.length\"\n                  class=\"ui-button-raised ui-button-primary\"\n                  (click)=\"loadMore()\" style=\"margin-left: 0px;\"\n                  [disabled]=\"isLoadMore\"\n                  id=\"loadMore\">\n          </button>\n        </div>\n      </div>\n     </div>\n     \n<!-- <div style=\"text-align: center; margin-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div> -->\n\n</div>\n\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"load\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-instances/manage-instances.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-instances/manage-instances.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"contents\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='cards'>\n        <div class='card-bodys'>\n          \n      <p class=\"primary\">\n        {{ 'MANAGE.INSTANCES' | translate }}\n      </p>\n          <button pButton type=\"button\" label=\"{{ 'GENERAL.CREATEINSTANCE' | translate }}\"\n                          class=\"ui-button-raised ui-button-primary\"\n                          style=\"float: right;\" icon=\"pi pi-plus\" iconPos=\"left\"\n                          (click)=\"createAppInstance()\"\n                          id=\"createinstance\">\n                  </button>\n          <br>\n          <br>\n          <p-table [value]=\"instances\" [styleClass]=\"'base-table'\">\n            <ng-template pTemplate=\"header\">\n                <tr>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.ID' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.INSTANCENAME' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.APPNAME' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.INSTANCEDESCRIPTION' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.PARAMETERS' | translate }}</th>\n                    <th style=\"word-wrap: break-word;\">{{ 'GENERAL.TARGET' | translate }}</th>\n                    <th style=\"width: 115px;\"></th>\n                </tr>\n            </ng-template>\n            <ng-template pTemplate=\"body\" let-instance id=\"instances\">\n                <tr>\n                    <td style=\"word-wrap: break-word;\">{{ instance.instanceId }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ instance.instanceName }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ instance.appName }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ instance.instanceDescription }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ instance.params }}</td>\n                    <td style=\"word-wrap: break-word;\">{{ instance.targ }}</td>\n                    <td style=\"width: 115px;\">\n                      <p-dropdown autoWidth=\"true\"\n                        [options]=\"instance.options\"\n                        [style]=\"{'width':'100%'}\"\n                        appendTo=\"body\"\n                        (onChange)=\"saveInstance($event, instance)\"\n                        id=\"{{ instance.instanceName }}\"\n                        placeholder=\"{{ 'GENERAL.OPTIONS' | translate }}\">\n                      </p-dropdown></td>\n                </tr>\n            </ng-template>\n          </p-table>\n          <br>\n          <button pButton type=\"button\" label=\"{{ 'GENERAL.LOADMORE' | translate }}\"\n                  *ngIf=\"instances && instances.length\"\n                  class=\"ui-button-raised ui-button-primary\"\n                  (click)=\"loadMore()\" style=\"margin-left: 0px;\"\n                  [disabled]=\"isLoadMore\"\n                  id=\"loadMore\">\n          </button>\n       </div>\n      </div>\n     </div>\n     \n<!-- <div style=\"text-align: center; margin-top: 50px;\" *ngIf=\"load\">\n  <p-progressSpinner></p-progressSpinner>\n</div> -->\n\n</div>\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"load\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage/manage.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage/manage.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n    <div class=\"header\" [style.background]=\"portalHeaderColor\">\n      <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n      <button id=\"home\">\n        <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n          <img id=\"homeicon\" src=\"assets/home.png\"/>\n        </a>\n    </button>\n          <span id=\"Title\">{{ title }}</span>\n          <img [src]=\"icon\" *ngIf=\"icon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n                style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n          <div class=\"spacer\"></div>\n          <label class=\"organisation\">{{ organisation }}</label>\n          <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n            {{ fullName }}\n            <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n          </button>\n          <mat-menu #accountMenu=\"matMenu\">\n            <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                    >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n            <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n            <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n            <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n          </mat-menu>\n        \n          <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n            <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n          </button>\n          <mat-menu #settingsMenu=\"matMenu\">\n            <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                    id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n            <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                    id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n          </mat-menu>\n        </div>\n  </div>\n  <div style=\"padding: 5px;\" class=\"content\">\n    <p-menubar [model]=\"items\" (click)=\"show($event)\" routerLinkActive=\"active\">\n    </p-menubar>\n\n    <div>      \n      <router-outlet name=\"manage\"></router-outlet>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/notification/notification.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/notification/notification.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"notifications\">\n\t<div *ngFor=\"let notification of notifications\" class=\"notification\" \n\t\t [ngClass]=\"className(notification)\">\n\t\t<ng-container *ngTemplateOutlet=\"notificationTpl;context:{notification:notification}\">\n\t\t</ng-container>\n\t</div>\n</div>\n\n<ng-template #notificationTpl let-notification=\"notification\">\n\n\t<div class=\"title\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n\t\t<div style=\"text-align: right;\">\n\t\t\t{{ notification.title }}\n\t\t<!--<button mat-icon-button \n            (click)=\"close(notification)\"\n            matTooltip=\"Close the notification\"\n            matTooltipPosition=\"before\">\n        <mat-icon>cancel</mat-icon>\n\t  </button>-->\n\t  <button pButton type=\"button\" icon=\"pi pi-times\"\n\t\t\t\ticonPos=\"left\"\n\t\t\t\tstyle=\"background-color: transparent; border-color: transparent;\"\n        \t  (click)=\"close(notification)\"></button></div>\n\t</div>\n\n\t<div class=\"message\" style=\"text-align: center;\">{{ notification.message }}</div>\n\n</ng-template>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/null/null.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/null/null.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p-confirmDialog id=\"confirm\" #cd header=\"{{ infoText }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ closeText }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/portal-info/portal-info.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/portal-info/portal-info.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n    <div class=\"header\" [style.background]=\"portalHeaderColor\">\n      <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n      <button id=\"home\">\n        <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n          <img id=\"homeicon\" src=\"assets/home.png\"/>\n        </a>\n    </button>\n          <span id=\"Title\">{{ title }}</span>\n          <img [src]=\"hicon\" *ngIf=\"hicon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n                style=\"max-width: 100px; max-height: 75px; min-width: 35px; min-height: 25px;\n                 margin-left: 5px; margin-bottom: 3px;\"/>\n          <div class=\"spacer\"></div>\n          <label class=\"organisation\">{{ organisation }}</label>\n          <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n            {{ fullName }}\n            <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n          </button>\n          <mat-menu #accountMenu=\"matMenu\">\n            <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                    >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n            <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n            <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n            <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n          </mat-menu>\n        \n          <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n            <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n          </button>\n          <mat-menu #settingsMenu=\"matMenu\">\n            <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                    id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n            <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                    id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n          </mat-menu>\n        </div>\n  </div>\n  \n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n  <div style=\"padding: 5px;\" class=\"contents\">\n    <div class=\"mymenu\">\n      <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n      </p-menubar>\n    </div>\n        <div class=\"card\">\n            <p class=\"primary\">\n              {{ 'GENERAL.MANAGEPORTALINFO' | translate }}\n            </p>\n            <div class=\"card-body\" style=\"margin-bottom: 10px;\">\n                <div class=\"example-container\">\n                    <div>\n                        <br>\n                        <span class=\"ui-float-label\">\n                          <input id=\"portalname\" type=\"text\" size=\"30\" \n                                  pInputText style=\"width: 30%;\"\n                                  [(ngModel)]=\"portalname\"> \n                          <label for=\"portalname\">{{ 'GENERAL.PORTALNAME' | translate }} (*)</label>\n                        </span>\n                        <p>\n                          <label for=\"portalname\" style=\"margin-right: 5px;\">{{ 'GENERAL.PORTALHEADERCOLOR' | translate }} (*)</label>\n                          <p-colorPicker [(ngModel)]=\"HeaderColor\"></p-colorPicker>\n                        </p>\n                        <div>\n                          <p style=\"margin-top: 30px; margin-bottom: 25px;\">\n                            <button type=\"button\" mat-raised-button (click)=\"fileInput.click()\"\n                                    style=\"margin-top: -15px; width: 30%; min-width: 250px;\"\n                                    id=\"selectorgicon\">\n                              {{ 'GENERAL.SELECTORGANISATIONICON' | translate }}\n                            </button>\n                            <input type=\"file\" hidden (change)=\"onIconSelected()\" #fileInput id=\"file\" accept=\"image/*\">\n                          </p>\n                          <img [src]=\"icon\" style=\"max-width: 100px; max-height: 50px; margin-right: 15px; margin-left: 10px; margin-bottom: 5px;\"\n                              *ngIf=\"icon\"/>\n                        </div>\n                        <div>\n                          <p style=\"margin-top: 25px; margin-bottom: 25px;\">\n                            <button type=\"button\" mat-raised-button (click)=\"fileInput2.click()\"\n                                    style=\"margin-top: -15px; width: 30%; min-width: 250px;\"\n                                    id=\"selectorgimage\">\n                              {{ 'GENERAL.SELECTORGANISATIONIMAGE' | translate }}\n                            </button>\n                            <input type=\"file\" hidden (change)=\"onImageSelected()\" #fileInput2 id=\"file2\" accept=\"image/*\">\n                          </p>\n                          <img [src]=\"image\" style=\"max-width: 100px; max-height: 50px; margin-right: 15px; margin-left: 10px; margin-bottom: 5px;\"\n                              *ngIf=\"image\"/>\n                        </div>\n                        <br>\n                        <button pButton type=\"button\" label=\"{{ 'GENERAL.SAVE' | translate }}\"\n                                style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n                                (click)=\"save()\"\n                                [disabled]=\"loading\"\n                                id=\"save\">\n                        </button>\n                    </div>\n                </div>\n            </div>\n          </div>\n       </div>\n  </div>\n  <p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n    <p-footer>\n      <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n  </p-footer>\n  </p-confirmDialog>\n  \n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n[closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n<p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/unauthorized-user/unauthorized-user.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/unauthorized-user/unauthorized-user.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n  <p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n      <p-footer>\n        <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n    </p-footer>\n    </p-confirmDialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/upload-icon/upload-icon.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/upload-icon/upload-icon.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n  <div class=\"header\" [style.background]=\"portalHeaderColor\">\n    <div class=\"toolbar\" role=\"banner\" [style.background]=\"portalHeaderColor\">\n    <button id=\"home\">\n      <a class=\"nav-link\" [routerLink]=\"['/home']\" mat-list-item>\n        <img id=\"homeicon\" src=\"assets/home.png\"/>\n      </a>\n  </button>\n        <span id=\"Title\">{{ title }}</span>\n        <img [src]=\"hicon\" *ngIf=\"hicon != null\" id=\"portalheadericon\" class=\"portalheadericon\"\n              style=\"max-width: 25px; max-height: 25px; margin-left: 5px; margin-bottom: 3px;\"/>\n        <div class=\"spacer\"></div>\n        <label class=\"organisation\">{{ organisation }}</label>\n        <button id=\"accountbutton\" mat-button [matMenuTriggerFor]=\"accountMenu\">\n          {{ fullName }}\n          <img id='accounticon' src=\"assets/account.png\" alt=\"Account\" title=\"Account\"/>\n        </button>\n        <mat-menu #accountMenu=\"matMenu\">\n          <button mat-menu-item id=\"account\" (click)=\"gotoAccount()\"\n                  >{{ 'TOOLBAR.ACCOUNT' | translate }}</button>\n          <!-- <button mat-menu-item (click)='changePass()' id=\"changepassword\">{{ 'TOOLBAR.CHANGEPASSWORD' | translate }}</button> -->\n          <button mat-menu-item (click)='changePin()' id=\"changepin\">{{ 'TOOLBAR.CHANGEPIN' | translate }}</button>\n          <button mat-menu-item (click)='logout()' id=\"logout\">{{ 'TOOLBAR.LOGOUT' | translate }}</button>\n        </mat-menu>\n      \n        <button id=\"settingsbutton\" mat-button [matMenuTriggerFor]=\"settingsMenu\">\n          <img id='settingsicon' src=\"assets/settings.png\" alt=\"Settings\" title=\"Settings\"/>        \n        </button>\n        <mat-menu #settingsMenu=\"matMenu\">\n          <button mat-menu-item *ngIf=\"isManage\" (click)=\"gotoManage()\"\n                  id=\"manage\">{{ 'TOOLBAR.MANAGE' | translate }}</button>\n          <button mat-menu-item (click)=\"gotoLanguage()\" *ngIf=\"isLanguage\"\n                  id=\"language\">{{ 'TOOLBAR.LANGUAGE' | translate }}</button>\n        </mat-menu>\n      </div>\n</div>\n\n<div class=\"myappmenu\" style=\"display: none; margin: 0px; padding: 0px;\" *ngIf=\"!div\">\n  <button type=\"button\" pButton pRipple icon=\"pi pi-bars\"\n         label=\" \"\n         style=\"background-color: transparent; border: none; color: black; font-size: 20px; margin-top: 5px;\"\n         (click)=\"menu.toggle($event)\"></button>\n  <p-menu #menu [popup]=\"true\" [model]=\"items\" [style]=\"{width: '100%'}\" [appendTo]=\"body\"></p-menu>\n\n</div>\n\n<div style=\"padding: 5px;\" class=\"content\">\n  <div class=\"mymenu\">\n    <p-menubar [model]=\"items\" routerLinkActive=\"active\">\n    </p-menubar>\n  </div>\n      <div class='card'>\n        <label class=\"secondary\">{{ 'GENERAL.ICONS' | translate }}</label>\n        /\n       <label class=\"primary\">{{ 'GENERAL.UPLOADICON' | translate }}</label>\n            <div class=\"card-body\">\n                <div class=\"example-container\">\n                  <p style=\"margin-top: 25px; margin-bottom: 30px;\">\n                    <button type=\"button\" mat-raised-button (click)=\"fileInput.click()\"\n                            style=\"margin-top: -15px; width: 30%; min-width: 250px;\">\n                      {{ 'GENERAL.SELECTICON' | translate }}\n                    </button>\n                    <input type=\"file\" hidden (change)=\"onFileSelected()\" #fileInput id=\"file\" accept=\"image/*\">\n                  </p>\n                  <span class=\"ui-float-label\">\n                    <input id=\"iconname\" type=\"text\" size=\"30\" \n                            pInputText style=\"width: 30%;\"\n                            [(ngModel)]=\"IconName\"> \n                    <label for=\"iconname\">{{ 'GENERAL.ICONNAME' | translate }} (*)</label>\n                  </span>\n                  <br>\n                  <img [src]=\"icon\" style=\"width: 50px; height: 50px; margin-right: 15px; margin-left: 10px; margin-bottom: 5px;\"\n                      *ngIf=\"icon\"/>\n              </div>\n            </div>\n      \n        <div class='card-footer'>\n          <div class=\"form-group\">\n            <button pButton type=\"button\" label=\"{{ 'GENERAL.CANCEL' | translate }}\"\n              style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-secondary\"\n              (click)=\"onCancel()\"\n              [disabled]=\"loading\"\n              id=\"cancel\">\n            </button>\n            <button pButton type=\"button\" label=\"{{ 'GENERAL.UPLOAD' | translate }}\"\n              style=\"margin-right: 5px;\" class=\"ui-button-raised ui-button-primary\"\n              (click)=\"onUpload()\"\n              [disabled]=\"loading\"\n              id=\"upload\">\n            </button>\n          </div>\n        </div>\n      </div>\n     </div>\n</div>\n     \n\n<p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n  <p-footer>\n    <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n</p-footer>\n</p-confirmDialog>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"cont\">\n     <div class=\"content\">\n        <router-outlet></router-outlet>\n        <app-notification></app-notification>\n     </div>\n</div>\n\n<!-- PROGRESS SPINNER -->\n<p-dialog [(visible)]=\"loading\" [modal]=\"true\" [showHeader]=\"false\"\n            [closable]=\"false\" [appendTo]=\"body\" [autoZIndex]=\"true\">\n   <p-progressSpinner [style]=\"{width: '50px', height: '50px'}\"></p-progressSpinner>\n</p-dialog>\n\n<div *ngIf=\"pop\">\n   <p-confirmDialog id=\"confirm\" #cd header=\"{{ 'GENERAL.INFO' | translate }}\">\n      <p-footer>\n        <button type=\"button\" id=\"butconfirm\" pButton label=\"{{ 'GENERAL.CLOSE' | translate }}\" (click)=\"cd.accept()\"></button>\n    </p-footer>\n    </p-confirmDialog>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/Components/app-detail/app-detail.component.css":
/*!****************************************************************!*\
  !*** ./src/app/Components/app-detail/app-detail.component.css ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  .example-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .example-container > * {\n    width: 100%;\n  }\n  \n  .example-form-field {\n    width: 200px;\n  }\n  \n  .example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  mat-form-field {\n  margin-right: 12px;\n  }\n  \n  .alert {\n  color: red;\n  }\n  \n  /*button {\n    background-color: #eee;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    cursor: hand;\n    font-family: Arial;\n    /*margin-left: 15px;*\n  }\n  \n  button:hover {\n      background-color: #cfd8dc;\n    }*/\n  \n  #home {\n      height: 25px;\n      width: 25px;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  \n  #homeicon {\n      /*margin: -15px,-25px,0px,0px;*/\n      margin-left: -25px;\n      margin-top: -25px;\n    }\n  \n  .spacer {\n        flex: 1;\n      }\n  \n  .toolbar {\n        height: 50px;\n        display: flex;\n        align-items: center;\n        /* background-color: #1976d2; */\n        color: white;\n        font-weight: 600;\n        position: relative;\n        top: 0;\n        z-index: 5;\n      }\n  \n  .toolbar span {\n        margin: 15px;\n    }\n  \n  .toolbar button {\n        margin: 15px;\n    }\n  \n  #accounticon {\n       width: 30px;\n       height: 30px;\n       margin-left: 5px;\n       margin-right: 0px;\n       margin-top: -10px;\n       margin-bottom: -5px;\n     }\n  \n  #settingsicon {\n      width: 25px;\n      height: 25;\n      margin-left: -20px;\n      margin-right: 0px;\n      margin-top: -10px;\n      margin-bottom: -5px;\n    }\n  \n  .nav-link #name {\n      color: white;\n    }\n  \n  #accountbutton {\n      background-color: transparent;\n      align-content: center;\n      text-align: center;\n      align-items: center;\n      border-color: transparent;\n      color:white;\n      margin-right: -15px;\n    }\n  \n  #settingsbutton {\n      background-color: transparent;\n      border-color: transparent;\n    }\n  \n  #para {\n      align-content: center;\n      align-items: center;\n    }\n  \n  .cont{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n    }\n  \n  .header{\n      flex-shrink: 0;\n      flex-grow: 0;\n      /* background: #039be5; */\n      width: 100%;\n    }\n  \n  .content{\n      flex-shrink: 1;\n      flex-grow: 1;\n      position: relative;\n      overflow-y: auto;\n    }\n  \n  input {\n  min-width: 250px !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/app-detail/app-detail.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/Components/app-detail/app-detail.component.ts ***!
  \***************************************************************/
/*! exports provided: AppDetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppDetailComponent", function() { return AppDetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");





















let AppDetailComponent = class AppDetailComponent {
    constructor(router, appservice, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, userService, home, cookieService, location, confirmationService, notificationSvc, injector, auth, app) {
        this.router = router;
        this.appservice = appservice;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.userService = userService;
        this.home = home;
        this.cookieService = cookieService;
        this.location = location;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.isAlert = false;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_11__["Urls"]();
        this.isAccount = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        // const usr = JSON.parse(localStorage.getItem('ext_user'));
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
        this.getApp();
    }
    ngOnInit() {
    }
    onCancel() {
        this.loading = true;
        this.isCancel = true;
        // this.router.navigateByUrl('/manageapps');
        this.location.back();
    }
    Save() {
        this.loading = true;
        this.isCreate = true;
        // tslint:disable-next-line: max-line-length
        if (this.AppName === undefined || this.AppName == null || this.AppName.trim() === '') {
            // this.isAlert = true;
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERAPPNAME').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
            // tslint:disable-next-line: max-line-length
        }
        else if (this.AppUrl === undefined || this.AppUrl === null || this.AppUrl.trim() === '') {
            // this.isAlert = true;
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERAPPURL').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else {
            this.isAlert = false;
            const app = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["AppUpdater"]();
            app.Id = this.AppId;
            app.Values = [];
            const name = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["KeyValue"]();
            name.Key = 'name';
            name.Value = this.AppName;
            app.Values.push(name);
            const appurl = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["KeyValue"]();
            appurl.Key = 'app_url';
            appurl.Value = this.AppUrl;
            app.Values.push(appurl);
            const config = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["KeyValue"]();
            config.Key = 'config';
            config.Value = this.AppConfig;
            app.Values.push(config);
            let check = false;
            // tslint:disable-next-line: deprecation
            this.appservice.getApplications().subscribe((resp) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < resp.length; i++) {
                    if (resp[i].appName === this.AppName && this.AppName !== this.appName) {
                        check = true;
                    }
                }
                if (check === true) {
                    let alrt;
                    // tslint:disable-next-line: deprecation
                    this.translate.get('ALERT.APPALREADYEXISTS').subscribe((res) => {
                        alrt = res;
                        this.confirm(alrt);
                    });
                    this.loading = false;
                    this.isCreate = false;
                }
                else {
                    // tslint:disable-next-line: deprecation
                    this.appservice.putApp(app).subscribe(() => {
                        // tslint:disable-next-line: deprecation
                        this.translate.get('GENERAL.APPUPDATED').subscribe((respp) => {
                            this.notificationSvc.info('', respp, 2000);
                            // this.router.navigateByUrl('/manageapps');
                            this.location.back();
                            this.loading = false;
                            this.isCreate = false;
                        });
                    });
                }
            });
        }
    }
    getApp() {
        const ap = localStorage.getItem('app_detail');
        const app = JSON.parse(ap);
        this.appName = app.appName;
        this.AppId = app.appId;
        this.AppName = app.appName;
        this.AppUrl = app.appUrl;
        this.AppConfig = app.appConfig;
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                    const extUser = JSON.parse(eu);
                    if (va !== null) {
                        // const extUser = JSON.parse(localStorage.getItem('ext_user'));
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                // const user = JSON.parse(localStorage.getItem('ext_user'));
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
    handleError(err) {
        this.loading = false;
    }
};
AppDetailComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_6__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_8__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__["Title"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_12__["UsersService"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__["CookieService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_15__["Location"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_16__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_17__["NotificationService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Injector"] },
    { type: _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_1__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_20__["AppComponent"] }
];
AppDetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-app-detail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app-detail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/app-detail/app-detail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app-detail.component.css */ "./src/app/Components/app-detail/app-detail.component.css")).default]
    })
], AppDetailComponent);



/***/ }),

/***/ "./src/app/Components/change-password/change-password.component.scss":
/*!***************************************************************************!*\
  !*** ./src/app/Components/change-password/change-password.component.scss ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\n.example-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.example-container > * {\n  width: 100%;\n}\n\n.example-form-field {\n  width: 200px;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\nmat-form-field {\n  margin-right: 12px;\n}\n\n.alert {\n  color: red;\n}\n\n/*button {\n  background-color: #eee;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  cursor: hand;\n  font-family: Arial;\n  /*margin-left: 15px;*\n}\n\nbutton:hover {\n    background-color: #cfd8dc;\n  }*/\n\n#home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -25px;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.toolbar {\n  height: 50px;\n  display: flex;\n  align-items: center;\n  color: white;\n  font-weight: 600;\n  position: relative;\n  top: 0;\n  z-index: 5;\n}\n\n.toolbar span {\n  margin: 15px;\n}\n\n.toolbar button {\n  margin: 15px;\n}\n\n#accounticon {\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n#settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n.nav-link #name {\n  color: white;\n}\n\n#accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color: white;\n  margin-right: -15px;\n}\n\n#settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#para {\n  align-content: center;\n  align-items: center;\n}\n\n.cont {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  flex-shrink: 0;\n  flex-grow: 0;\n  width: 100%;\n}\n\n.content {\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n\ninput {\n  min-width: 250px !important;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/change-password/change-password.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/Components/change-password/change-password.component.ts ***!
  \*************************************************************************/
/*! exports provided: ChangePasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangePasswordComponent", function() { return ChangePasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");





















let ChangePasswordComponent = class ChangePasswordComponent {
    constructor(router, appservice, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, userService, home, cookieService, location, confirmationService, notificationSvc, injector, auth, app) {
        this.router = router;
        this.appservice = appservice;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.userService = userService;
        this.home = home;
        this.cookieService = cookieService;
        this.location = location;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__["Urls"]();
        this.isAccount = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        translate.addLangs(['English', 'French']);
        translate.setDefaultLang('English');
        let browserLang = translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
    }
    onCancel() {
        this.loading = false;
        this.location.back();
    }
    Save() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // tslint:disable-next-line: max-line-length
            if (this.OldPass === undefined || this.OldPass == null || this.OldPass.trim() === '') {
                this.translate.get('ALERT.ENTERCURRENTPASSWORD').subscribe((res) => {
                    this.confirm(res);
                });
                // tslint:disable-next-line: max-line-length
            }
            else if (this.NewPass === undefined || this.NewPass === null || this.NewPass.trim() === '') {
                this.translate.get('ALERT.ENTERNEWPASSWORD').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else if (this.ConfirmPass === undefined || this.ConfirmPass === null || this.ConfirmPass.trim() === '') {
                this.translate.get('ALERT.ENTERNEWPASSWORDCONFIRMATION').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                const res = yield this.userService.checkUser(user.organisationId, user.employeeId, user.email, null, this.OldPass, null)
                    .toPromise().catch(err => this.handleError(err));
                if (res !== undefined && res !== null && res === true) {
                    if (this.NewPass !== this.ConfirmPass) {
                        this.translate.get('ALERT.NEWPASSWORDSDONOTMATCH').subscribe((resp) => {
                            this.confirm(resp);
                        });
                    }
                    else {
                        const upt = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__["UserUpdater"]();
                        upt.Id = user.userId;
                        upt.Values = [];
                        const pass = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__["KeyValue"]();
                        pass.Key = 'pass';
                        pass.Value = this.NewPass;
                        upt.Values.push(pass);
                        this.userService.putUser(user.userId, upt).subscribe(() => {
                            this.translate.get('GENERAL.PASSWORDCHANGED').subscribe((resp) => {
                                this.notificationSvc.info('', resp, 3000);
                            });
                            this.location.back();
                            this.loading = false;
                        }, err => {
                            this.handleError(err);
                        });
                    }
                }
            }
        });
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    handleError(err) {
        this.loading = false;
        if (err !== undefined && err != null && err.error !== undefined && err.error != null) {
            if (err.error.Message !== undefined && err.error.Message != null
                && err.error.Message === 'Incorrect password') {
                this.translate.get('ALERT.INCORRECTCURRENTPASSWORD').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else {
                console.log(err);
            }
        }
        else {
            console.log(err);
        }
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
ChangePasswordComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_15__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["Title"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__["UsersService"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_18__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_7__["CookieService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_1__["Location"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_8__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_14__["NotificationService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_20__["AppComponent"] }
];
ChangePasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-change-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-password/change-password.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-password.component.scss */ "./src/app/Components/change-password/change-password.component.scss")).default]
    })
], ChangePasswordComponent);



/***/ }),

/***/ "./src/app/Components/change-pin/change-pin.component.scss":
/*!*****************************************************************!*\
  !*** ./src/app/Components/change-pin/change-pin.component.scss ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\n.example-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.example-container > * {\n  width: 100%;\n}\n\n.example-form-field {\n  width: 200px;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\nmat-form-field {\n  margin-right: 12px;\n}\n\n.alert {\n  color: red;\n}\n\n/*button {\n  background-color: #eee;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  cursor: hand;\n  font-family: Arial;\n  /*margin-left: 15px;*\n}\n\nbutton:hover {\n    background-color: #cfd8dc;\n  }*/\n\n#home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -25px;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.toolbar {\n  height: 50px;\n  display: flex;\n  align-items: center;\n  color: white;\n  font-weight: 600;\n  position: relative;\n  top: 0;\n  z-index: 5;\n}\n\n.toolbar span {\n  margin: 15px;\n}\n\n.toolbar button {\n  margin: 15px;\n}\n\n#accounticon {\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n#settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n.nav-link #name {\n  color: white;\n}\n\n#accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color: white;\n  margin-right: -15px;\n}\n\n#settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#para {\n  align-content: center;\n  align-items: center;\n}\n\n.cont {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  flex-shrink: 0;\n  flex-grow: 0;\n  width: 100%;\n}\n\n.content {\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n\ninput {\n  min-width: 250px !important;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/change-pin/change-pin.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/Components/change-pin/change-pin.component.ts ***!
  \***************************************************************/
/*! exports provided: ChangePinComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangePinComponent", function() { return ChangePinComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");





















let ChangePinComponent = class ChangePinComponent {
    constructor(router, appservice, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, userService, home, cookieService, location, confirmationService, notificationSvc, injector, auth, app) {
        this.router = router;
        this.appservice = appservice;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.userService = userService;
        this.home = home;
        this.cookieService = cookieService;
        this.location = location;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__["Urls"]();
        this.isAccount = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        translate.addLangs(['English', 'French']);
        translate.setDefaultLang('English');
        let browserLang = translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
    }
    onCancel() {
        this.loading = false;
        this.location.back();
    }
    Save() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // tslint:disable-next-line: max-line-length
            if (this.OldPin === undefined || this.OldPin == null || this.OldPin.trim() === '') {
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.ENTERCURRENTPIN').subscribe((res) => {
                    this.confirm(res);
                });
                // tslint:disable-next-line: max-line-length
            }
            else if (this.NewPin === undefined || this.NewPin === null || this.NewPin.trim() === '') {
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.ENTERNEWPIN').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else if (this.ConfirmPin === undefined || this.ConfirmPin === null || this.ConfirmPin.trim() === '') {
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.ENTERNEWPINCONFIRMATION').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.loading = true;
                const res = yield this.userService.checkUser(user.organisationId, user.employeeId, user.email, null, null, this.OldPin)
                    .toPromise().catch(err => this.handleError(err));
                if (res !== undefined && res !== null && res === true) {
                    if (this.NewPin !== this.ConfirmPin) {
                        this.loading = false;
                        // tslint:disable-next-line: deprecation
                        this.translate.get('ALERT.NEWPINSDONOTMATCH').subscribe((resp) => {
                            this.confirm(resp);
                        });
                    }
                    else {
                        const upt = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__["UserUpdater"]();
                        upt.Id = user.userId;
                        upt.Values = [];
                        const pin = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_9__["KeyValue"]();
                        pin.Key = 'pin';
                        pin.Value = this.NewPin;
                        upt.Values.push(pin);
                        // tslint:disable-next-line: deprecation
                        this.userService.putUser(user.userId, upt).subscribe(() => {
                            // tslint:disable-next-line: deprecation
                            this.translate.get('GENERAL.PINCHANGED').subscribe((resp) => {
                                this.notificationSvc.info('', resp, 3000);
                            });
                            this.location.back();
                            this.loading = false;
                        }, err => {
                            this.handleError(err);
                        });
                    }
                }
            }
        });
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    handleError(err) {
        this.loading = false;
        if (err !== undefined && err != null && err.error !== undefined && err.error != null) {
            if (err.error.Message !== undefined && err.error.Message != null
                && err.error.Message === 'Incorrect password') {
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.INCORRECTCURRENTPIN').subscribe((res) => {
                    this.confirm(res);
                });
            }
            else {
                console.log(err);
            }
        }
        else {
            console.log(err);
        }
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_11__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
ChangePinComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_15__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["Title"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__["UsersService"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_18__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_7__["CookieService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_1__["Location"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_8__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_14__["NotificationService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_20__["AppComponent"] }
];
ChangePinComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-change-pin',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-pin.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/change-pin/change-pin.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-pin.component.scss */ "./src/app/Components/change-pin/change-pin.component.scss")).default]
    })
], ChangePinComponent);



/***/ }),

/***/ "./src/app/Components/create-app/create-app.component.css":
/*!****************************************************************!*\
  !*** ./src/app/Components/create-app/create-app.component.css ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  /*.example-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .example-container > * {\n    width: 100%;\n  }*/\n  \n  .example-container {\n    /*display: flex;*/\n    flex-direction: column;\n  }\n  \n  .example-container > * {\n    width: 50%;\n  }\n  \n  .example-form-field {\n    width: 200px;\n  }\n  \n  .example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  mat-form-field {\n  margin-right: 12px;\n}\n  \n  #home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n  \n  #homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -25px;\n}\n  \n  .spacer {\n    flex: 1;\n  }\n  \n  .toolbar {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    /* background-color: #1976d2; */\n    color: white;\n    font-weight: 600;\n    position: relative;\n    top: 0;\n    z-index: 5;\n  }\n  \n  .toolbar span {\n    margin: 15px;\n}\n  \n  .toolbar button {\n    margin: 15px;\n}\n  \n  #accounticon {\n   width: 30px;\n   height: 30px;\n   margin-left: 5px;\n   margin-right: 0px;\n   margin-top: -10px;\n   margin-bottom: -5px;\n }\n  \n  #settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n  \n  .nav-link #name {\n  color: white;\n}\n  \n  #accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color:white;\n  margin-right: -15px;\n}\n  \n  #settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n  \n  #para {\n  align-content: center;\n  align-items: center;\n}\n  \n  .cont{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n  \n  .header{\n  flex-shrink: 0;\n  flex-grow: 0;\n  /* background: #039be5; */\n  width: 100%;\n}\n  \n  .content{\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n  \n  input {\n  min-width: 250px !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/create-app/create-app.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/Components/create-app/create-app.component.ts ***!
  \***************************************************************/
/*! exports provided: CreateAppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateAppComponent", function() { return CreateAppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _Models_App__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../Models/App */ "./src/app/Models/App.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");





















let CreateAppComponent = class CreateAppComponent {
    constructor(router, appservice, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, home, cookieService, confirmationService, notificationSvc, location, injector, auth, userService, app) {
        this.router = router;
        this.appservice = appservice;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.location = location;
        this.injector = injector;
        this.auth = auth;
        this.userService = userService;
        this.app = app;
        this.AppConfig = '';
        this.pageTitle = 'Create application';
        this.alertMessage = 'Check information';
        this.isAlert = false;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_12__["Urls"]();
        this.isAccount = false;
        this.orgs1 = [];
        this.orgs2 = [];
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
        // this.getOrganisations();
    }
    onCancel() {
        this.loading = true;
        this.isCancel = true;
        // this.router.navigateByUrl('/manageapps');
        this.location.back();
    }
    onCreate() {
        this.loading = true;
        this.isCreate = true;
        // tslint:disable-next-line: max-line-length
        if (this.AppName === undefined || this.AppName == null || this.AppName.trim() === '') {
            // this.isAlert = true;
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERAPPNAME').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
            // tslint:disable-next-line: max-line-length
        }
        else if (this.AppUrl === undefined || this.AppUrl === null || this.AppUrl.trim() === '') {
            // this.isAlert = true;
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERAPPURL').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else {
            this.isAlert = false;
            const app = new _Models_App__WEBPACK_IMPORTED_MODULE_4__["App"]();
            app.AppId = 0;
            app.AppName = this.AppName;
            app.AppUrl = this.AppUrl;
            app.AppConfig = this.AppConfig;
            let check = false;
            // tslint:disable-next-line: deprecation
            this.appservice.getApplications().subscribe((resp) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < resp.length; i++) {
                    if (resp[i].appName === this.AppName) {
                        check = true;
                    }
                }
                if (check === true) {
                    let alrt;
                    // tslint:disable-next-line: deprecation
                    this.translate.get('ALERT.APPALREADYEXISTS').subscribe((res) => {
                        alrt = res;
                        this.confirm(alrt);
                    });
                    this.loading = false;
                    this.isCreate = false;
                }
                else {
                    // tslint:disable-next-line: deprecation
                    this.appservice.postApp(app).subscribe(() => {
                        // tslint:disable-next-line: deprecation
                        this.translate.get('GENERAL.APPCREATED').subscribe((respp) => {
                            this.notificationSvc.info('', respp, 2000);
                            // this.router.navigateByUrl('/manageapps');
                            this.location.back();
                            this.loading = false;
                            this.isCreate = false;
                        });
                    }, err => this.handleError(err));
                }
            });
        }
    }
    getOrganisations() {
        // tslint:disable-next-line: deprecation
        this.userService.getOrganisations().subscribe((res) => {
            if (res != null) {
                for (const val of res) {
                    this.orgs1.push(val);
                }
            }
        }, err => this.handleError(err));
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    handleError(err) {
        this.loading = false;
        console.log(err);
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_8__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_8__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
CreateAppComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_6__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_9__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_11__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_14__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_15__["NotificationService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_5__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_16__["AuthService"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_1__["UsersService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_20__["AppComponent"] }
];
CreateAppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["Component"])({
        selector: 'app-create-app',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./create-app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-app/create-app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./create-app.component.css */ "./src/app/Components/create-app/create-app.component.css")).default]
    })
], CreateAppComponent);



/***/ }),

/***/ "./src/app/Components/create-instance/create-instance.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/Components/create-instance/create-instance.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n@keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n.icon-card {\n  float: left;\n  width: 350px;\n  height: 125px;\n  max-width: 100px;\n  margin: 10px;\n  margin-bottom: 25px;\n}\n\n.icon-card:hover {\n  cursor: pointer;\n  background-color: lightgrey;\n}\n\n.over {\n  width: 75px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\n.ui-float-label {\n  margin-bottom: 5px;\n}\n\n.example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n\n.example-full-width {\n    width: 100%;\n  }\n\n.example-container {\n    /*display: flex;*/\n    flex-direction: column;\n  }\n\n.example-container > * {\n    width: 50%;\n  }\n\n.example-form-field {\n    width: 200px;\n  }\n\n.example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n\n.example-full-width {\n    width: 100%;\n  }\n\nmat-form-field {\n  margin-right: 12px;\n}\n\n.alert {\n  color: red;\n}\n\n/*button:hover {\n  background-color: #cfd8dc;\n}*/\n\n#home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -25px;\n}\n\n.spacer {\n    flex: 1;\n  }\n\n.toolbar {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    /* background-color: #1976d2; */\n    color: white;\n    font-weight: 600;\n    position: relative;\n    top: 0;\n    z-index: 5;\n  }\n\n.toolbar span {\n    margin: 15px;\n}\n\n.toolbar button {\n    margin: 15px;\n}\n\n#accounticon {\n   width: 30px;\n   height: 30px;\n   margin-left: 5px;\n   margin-right: 0px;\n   margin-top: -10px;\n   margin-bottom: -5px;\n }\n\n#settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n.nav-link #name {\n  color: white;\n}\n\n#accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color:white;\n  margin-right: -15px;\n}\n\n#settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#para {\n  align-content: center;\n  align-items: center;\n}\n\n.cont{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header{\n  flex-shrink: 0;\n  flex-grow: 0;\n  /* background: #039be5; */\n  width: 100%;\n}\n\n.content{\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n\n/* Tablet targetted size */\n\n@media screen and (max-width:768px) {\n  #orgsec {\n    float: none !important;\n    margin-top: 400px;\n    width: 100% !important;\n  }\n\n  .example-containerx {\n    width: 100% !important;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/create-instance/create-instance.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/Components/create-instance/create-instance.component.ts ***!
  \*************************************************************************/
/*! exports provided: CreateInstanceComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateInstanceComponent", function() { return CreateInstanceComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_organisation_organisation_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Services/organisation/organisation.service */ "./src/app/Services/organisation/organisation.service.ts");
/* harmony import */ var _Services_group_instance_group_instance_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../Services/group-instance/group-instance.service */ "./src/app/Services/group-instance/group-instance.service.ts");
/* harmony import */ var src_app_Models_GroupInstance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/Models/GroupInstance */ "./src/app/Models/GroupInstance.ts");
/* harmony import */ var _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../Services/groups/groups.service */ "./src/app/Services/groups/groups.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/Services/userappinstnce/userappinstance.service */ "./src/app/Services/userappinstnce/userappinstance.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Instance__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Models/Instance */ "./src/app/Models/Instance.ts");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/Services/icons/icons.service */ "./src/app/Services/icons/icons.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");


























let CreateInstanceComponent = class CreateInstanceComponent {
    constructor(router, userappinstanceservice, appservice, translate, domSanitizer, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, home, cookieService, location, confirmationService, notificationSvc, groups, groupinstance, iconsService, injector, auth, orgService, appc) {
        this.router = router;
        this.userappinstanceservice = userappinstanceservice;
        this.appservice = appservice;
        this.translate = translate;
        this.domSanitizer = domSanitizer;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.location = location;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.groups = groups;
        this.groupinstance = groupinstance;
        this.iconsService = iconsService;
        this.injector = injector;
        this.auth = auth;
        this.orgService = orgService;
        this.appc = appc;
        this.pageTitle = 'Create app instance';
        this.alertMessage = 'check information';
        this.isAlert = false;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.AppConfig = '';
        this.InstanceParameters = '';
        this.apps = [];
        this.targets = [];
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_16__["Urls"]();
        this.groups1 = [];
        this.groups2 = [];
        this.organisations = [];
        this.icons = [];
        this.display = false;
        this.isAccount = false;
        this.load = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.hicon = appc.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_23__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_24__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_24__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.CONTENTOPTION').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.NEWTABOPTION').subscribe((resp2) => {
                this.targets = [
                    {
                        label: resp1, value: 'content'
                    },
                    {
                        label: resp2, value: 'new_tab'
                    }
                ];
            });
        });
        this.loadUserProfile();
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.NOFILESELECTED').subscribe((res) => {
            this.filename = res;
        });
        this.load = true;
        // tslint:disable-next-line: deprecation
        appservice.getApplications().subscribe((apps) => {
            if (apps != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < apps.length; i++) {
                    this.apps.push({ label: apps[i].appName, value: apps[i] });
                }
                this.load = false;
                /*this.apps.sort((a, b) => {
                  if (a.appName < b.appName) { return -1; }
                  if (a.appName > b.appName) { return 1; }
                  return 0;
                });*/
            }
        }, err => this.handleError(err));
        this.getOrganisations();
        this.getIcons();
    }
    ngOnInit() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
        });
    }
    getOrganisations() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const orgs = yield this.orgService.getOrganisations().toPromise().catch(err => this.handleError(err));
            if (orgs != null && orgs.length > 0) {
                for (const val of orgs) {
                    this.organisations.push({ label: val.organisationName, value: val });
                }
            }
            this.loading = false;
        });
    }
    get() {
        this.getGroups();
    }
    getGroups() {
        this.loading = true;
        this.groups1 = [];
        // tslint:disable-next-line: deprecation
        this.groups.getGroupsByOrganisation(this.org.organisationId).subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.groups1.push(res[i]);
                }
                this.loading = false;
            }
            else {
                this.loading = false;
            }
        }, err => this.handleError(err));
    }
    selectedApp(event) {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.apps.length; i++) {
            if (this.apps[i].appName === event.value) {
                this.AppId = this.apps[i].appId;
            }
        }
    }
    getIcons() {
        this.loading = true;
        // tslint:disable-next-line: deprecation
        this.iconsService.getIcons().subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    res[i].saveicon = this.domSanitizer.bypassSecurityTrustUrl(res[i].icon);
                    this.icons.push(res[i]);
                }
            }
            this.loading = false;
        }, err => this.handleError(err));
    }
    onCancel() {
        this.loading = true;
        this.isCancel = true;
        // this.router.navigateByUrl('/manageinstances');
        this.location.back();
    }
    onCreate() {
        this.loading = true;
        this.isCreate = true;
        let check = false;
        if (this.app === undefined || this.app === null) {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SELECTAPP').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.InstanceName === undefined || this.InstanceName === null || this.InstanceName.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERINSTANCENAME').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.InstanceDescription === undefined || this.InstanceDescription === null || this.InstanceDescription.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERINSTANCEDESCRIPTION').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.target === undefined || this.target === null || this.target.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SELECTTARGET').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.InstanceIcon === undefined || this.InstanceIcon === null || this.InstanceIcon.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SELECTICON').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else {
            this.isAlert = false;
            const ai = new src_app_Models_Instance__WEBPACK_IMPORTED_MODULE_11__["Instance"]();
            ai.AppId = this.app.appId;
            ai.InstanceId = 0;
            ai.InstanceName = this.InstanceName;
            ai.InstanceDescription = this.InstanceDescription;
            ai.InstanceIcon = this.InstanceIcon;
            ai.InstanceIconName = this.filename;
            ai.InstanceTarget = this.target;
            ai.InstanceParameters = this.InstanceParameters;
            // tslint:disable-next-line: deprecation
            this.userappinstanceservice.getUserAppInstances().subscribe((resp) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < resp.length; i++) {
                    if (resp[i].instanceName === this.InstanceName) {
                        check = true;
                    }
                }
                if (check === true) {
                    let alrt;
                    // tslint:disable-next-line: deprecation
                    this.translate.get('ALERT.INSTANCEALREADYEXISTS').subscribe((res) => {
                        alrt = res;
                        this.confirm(alrt);
                    });
                    this.loading = false;
                    this.isCreate = false;
                }
                else {
                    // tslint:disable-next-line: deprecation
                    this.userappinstanceservice.postAppInstance(ai).subscribe((res) => {
                        if (this.groups2.length > 0) {
                            // tslint:disable-next-line: prefer-for-of
                            for (let i = 0; i < this.groups2.length; i++) {
                                const ginst = new src_app_Models_GroupInstance__WEBPACK_IMPORTED_MODULE_3__["GroupInstance"]();
                                ginst.InstanceId = res;
                                // ginst.Group = this.groups2[i].groupName;
                                ginst.Group = this.groups2[i].groupId.toString();
                                // tslint:disable-next-line: deprecation
                                this.groupinstance.postGroupInstance(ginst).subscribe(() => {
                                    if ((i + 1) === this.groups2.length) {
                                        // tslint:disable-next-line: deprecation
                                        this.translate.get('GENERAL.INSTANCECREATED').subscribe((respp) => {
                                            this.notificationSvc.info('', respp, 2000);
                                            // this.router.navigateByUrl('/manageinstances');
                                            this.location.back();
                                            this.loading = false;
                                            this.isCreate = false;
                                        });
                                    }
                                });
                            }
                        }
                        else {
                            // tslint:disable-next-line: deprecation
                            this.translate.get('GENERAL.INSTANCECREATED').subscribe((respp) => {
                                this.notificationSvc.info('', respp, 2000);
                                // this.router.navigateByUrl('/manageinstances');
                                this.location.back();
                                this.loading = false;
                                this.isCreate = false;
                            });
                        }
                    });
                }
            });
        }
    }
    select(icon) {
        this.display = false;
        this.icon = icon.saveicon;
        this.filename = icon.iconName;
        this.InstanceIcon = icon.icon;
    }
    showIcons() {
        this.display = true;
    }
    onFileSelected() {
        const inputNode = document.querySelector('#file');
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (inputNode.files[0]) {
                reader.readAsDataURL(inputNode.files[0]);
            }
            reader.onloadend = (e) => {
                this.filename = inputNode.files[0].name;
                const base64 = e.target.result;
                this.InstanceIcon = base64;
                this.icon = this.domSanitizer.bypassSecurityTrustUrl(base64);
            };
            reader.onerror = (() => {
                this.InstanceIcon = '';
                this.icon = null;
            });
        }
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.load = false;
        console.log(err);
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_23__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_22__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_13__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_22__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_13__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_23__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_24__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_24__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_23__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_24__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_24__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
CreateInstanceComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_9__["Router"] },
    { type: src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_8__["UserappinstanceService"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_12__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["DomSanitizer"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_14__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_15__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_17__["CookieService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_5__["Location"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_18__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_19__["NotificationService"] },
    { type: _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_4__["GroupsService"] },
    { type: _Services_group_instance_group_instance_service__WEBPACK_IMPORTED_MODULE_2__["GroupInstanceService"] },
    { type: src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_20__["IconsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_10__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_21__["AuthService"] },
    { type: _Services_organisation_organisation_service__WEBPACK_IMPORTED_MODULE_1__["OrganisationService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_25__["AppComponent"] }
];
CreateInstanceComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_10__["Component"])({
        selector: 'app-create-instance',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./create-instance.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/create-instance/create-instance.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./create-instance.component.css */ "./src/app/Components/create-instance/create-instance.component.css")).default]
    })
], CreateInstanceComponent);



/***/ }),

/***/ "./src/app/Components/home1/home1.component.css":
/*!******************************************************!*\
  !*** ./src/app/Components/home1/home1.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".iframe-container {\n    overflow: hidden;\n    /* Calculated from the aspect ration of the content (in case of 16:9 it is 9/16= 0.5625)*\n    padding-top: 56.25%;*/\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 75vh;\n  }\n\n  .iframe-container iframe {\n     border: 0;\n     height: 100%;\n     left: 0;\n     position: absolute;\n     top: 0;\n     width: 100%;\n  }\n\n  .h2 {\n   text-align: center;\n   align-content: flex-start;\n }\n\n  p {\n   font-family: Lato;\n }\n\n  .float {\n   float: left;\n   width: 150px;\n   height: 75px;\n   margin: 10px;\n   border: 3px solid #73AD21;\n }\n\n  /* .example-card {\n   float: left;\n   width: 350px;\n   height: 125px;\n   max-width: 500px;\n   margin: 10px;\n } */\n\n  .example-card:hover {\n   cursor: pointer;\n   background-color: lightgrey;\n }\n\n  button:hover {\n  cursor: pointer;\n  background-color: lightgrey;\n}\n\n  .example-header-image {\n   /*background-image: url('https://material.angular.io/assets/img/examples/shiba1.jpg');\n   background-image: url('/assets/settings.png');*/\n   background-size: cover;\n   height: 50px;\n   width: 50px;\n   vertical-align: center;\n }\n\n  .table td {\n   padding: 0.75rem;\n   vertical-align: center;\n   border-top: 1px solid #dee2e6;\n }\n\n  .container {\n    position: relative;\n    padding-bottom: 56.25%;\n    padding-top: 35px;\n    height: 0;\n    overflow: hidden;\n }\n\n  .container iframe {\n    position: absolute;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n }\n\n  .FrameContainer {\n    width: 100%;\n    height: 0;\n    top: 0;\n    bottom: 0;\n    /*padding-bottom: 56.25%;\n    /*padding-bottom: 12.2%;*/\n }\n\n  .FrameContainer iframe {\n    position: absolute;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n }\n\n  #home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n  #homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -3px;\n}\n\n  button:focus {outline:0 !important;}\n\n  .spacer {\n    flex: 1;\n  }\n\n  .toolbar {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    /* background-color: #1976d2; */\n    color: white;\n    font-weight: 600;\n    position: relative;\n    top: 0;\n    z-index: 5;\n  }\n\n  .toolbar span {\n    margin: 15px;\n}\n\n  .toolbar button {\n    margin: 15px;\n}\n\n  #accounticon {\n   width: 30px;\n   height: 30px;\n   margin-left: 5px;\n   margin-right: 0px;\n   margin-top: -10px;\n   margin-bottom: -5px;\n }\n\n  #settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n  .nav-link #name {\n  color: white;\n}\n\n  #accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color:white;\n  margin-right: -15px;\n}\n\n  #settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n  #para {\n  align-content: center;\n  align-items: center;\n}\n\n  .cont{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n  .header{\n  flex-shrink: 0;\n  flex-grow: 0;\n  /* background: #039be5; */\n  width: 100%;\n}\n\n  .content{\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n\n  @-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: blue;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: blue;\n  }\n  80%,\n  90% {\n      stroke: blue;\n  }\n}\n\n  @keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: blue;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: blue;\n  }\n  80%,\n  90% {\n      stroke: blue;\n  }\n}\n\n  .active {\n  background-color: #f2f2f2 !important;\n}\n\n  .over {\n  width: 225px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\n  .example-card {\n  /* float: left; */\n  width: 350px;\n  height: 125px;\n  max-width: 500px;\n  margin: 10px;\n}\n\n  .wrap {\ndisplay: flex;\nflex-wrap: wrap;\n}\n\n  .apphover:hover {\n  cursor: pointer;\n}\n\n  button:focus {\n  outline: 0px !important;\n}\n\n  /* Tablet targetted size */\n\n  @media screen and (max-width:768px) {\n  .wrap {\n    padding: 10% !important;\n  }\n\n  .app-sidenav {\n    display: none;\n  }\n\n  .appmenu {\n    display: block !important;\n  }\n}\n\n  .hover:hover {\n  background-color: lightgray;\n  cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/home1/home1.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/Components/home1/home1.component.ts ***!
  \*****************************************************/
/*! exports provided: Home1Component */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Home1Component", function() { return Home1Component; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../app.component */ "./src/app/app.component.ts");
/* harmony import */ var _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../Services/groups/groups.service */ "./src/app/Services/groups/groups.service.ts");
/* harmony import */ var _Services_user_groups_user_groups_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../../Services/user-groups/user-groups.service */ "./src/app/Services/user-groups/user-groups.service.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Services/userappinstnce/userappinstance.service */ "./src/app/Services/userappinstnce/userappinstance.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");



















let Home1Component = class Home1Component {
    constructor(sanitizer, 
    // private keycloakService: KeycloakService,
    userInstanceService, router, domSanitizer, translate, portalinfo, userService, titleService, confirmationService, cookieService, usrgrp, group, injector, auth, keycloakService, app) {
        this.sanitizer = sanitizer;
        this.userInstanceService = userInstanceService;
        this.router = router;
        this.domSanitizer = domSanitizer;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.userService = userService;
        this.titleService = titleService;
        this.confirmationService = confirmationService;
        this.cookieService = cookieService;
        this.usrgrp = usrgrp;
        this.group = group;
        this.injector = injector;
        this.auth = auth;
        this.keycloakService = keycloakService;
        this.app = app;
        this.isManage = false;
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_15__["Urls"]();
        this.accs = [];
        this.isins = false;
        this.instances = [];
        this.ids = [];
        this.browser = false;
        this.insts = [];
        this.isAccount = false;
        this.color = 'white';
        this.items = [];
        this.issmallmenu = false;
        this.variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
        this.instcount = 0;
        this.portalHeaderColor = 'transparent';
        translate.addLangs(['English', 'French']);
        translate.setDefaultLang('English');
        let browserLang = translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        router.navigateByUrl('/home/');
        this.icon = app.icon;
    }
    ngOnInit() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (localStorage.getItem('portal-title') === null) {
                this.portalinfo.getPortalInfo().subscribe((res) => {
                    // tslint:disable-next-line: prefer-for-of
                    for (let i = 0; i < res.length; i++) {
                        this.title = res[i].portalTitle;
                        localStorage.setItem('portal-title', res[i].portalTitle);
                        localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                        this.portalHeaderColor = res[i].portalHeaderColor;
                        localStorage.setItem('headercolor', res[i].portalHeaderColor);
                        this.titleService.setTitle(res[i].portalTitle);
                    }
                }, err => this.handleError(err));
            }
            else {
                this.title = localStorage.getItem('portal-title');
                this.titleService.setTitle(this.title);
                this.portalHeaderColor = localStorage.getItem('headercolor');
            }
            this.translate.addLangs(['English', 'French']);
            this.translate.setDefaultLang('English');
            let browserLang = this.translate.getBrowserLang();
            if (localStorage.getItem('language') !== null) {
                browserLang = localStorage.getItem('language');
            }
            this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
            const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
            const va = localStorage.getItem('eu');
            const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
            const usr = JSON.parse(eu);
            const og = usr.organisationName;
            if (og === 'ORG_SUPER_ADMIN') {
                this.isLanguage = true;
                this.isManage = true;
            }
            if (this.router.url === '/home' || this.router.url === '/home/' || this.router.url === '/' || this.router.url === '') {
                this.div = 'true';
                this.drawer = null;
            }
            else {
                this.div = null;
                this.drawer = 'true';
            }
            // const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            const isChrome = true;
            if (isChrome === true) {
                const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                // const version = raw ? parseInt(raw[2], 10) : false;
                const version = 80;
                if (version >= 80) {
                    this.browser = true;
                    localStorage.setItem('browser', 'true');
                }
                else {
                    this.browser = false;
                    localStorage.setItem('browser', 'false');
                    this.translate.get('ALERT.BROWSERCHECK').subscribe((resp) => {
                        this.confirm(resp);
                    });
                    return;
                }
            }
            else {
                this.browser = false;
                localStorage.setItem('browser', 'false');
                this.translate.get('ALERT.BROWSERCHECK').subscribe((resp) => {
                    this.confirm(resp);
                });
                return;
            }
            this.loadUserProfile();
        });
    }
    loadInstances(name, group) {
        this.getUserAppInstances(name, group);
    }
    showHome() {
        this.color = 'white';
        this.isload = false;
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
        const usr = JSON.parse(eu);
        if (va !== null) {
            const extUser = usr;
            if (extUser.userId !== 0) {
                this.isHomeVisible = 'true';
                this.isMainVisible = null;
                this.drawer = null;
                this.drawer2 = null;
                this.div = 'true';
                if (this.instances2 != null && this.instances2.length > 0) {
                    // tslint:disable-next-line: prefer-for-of
                    for (let i = 0; i < this.instances2.length; i++) {
                        this.instances2[i].isVisible = false;
                    }
                }
                this.router.navigateByUrl('/home/');
            }
        }
    }
    showMain() {
        this.isHomeVisible = null;
        this.isMainVisible = 'true';
    }
    toggleOn() {
        this.drawer = null;
        this.div = 'true';
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.instances2.length; i++) {
            this.instances2[i].isVisible = false;
        }
    }
    toggleOff() {
        this.drawer = 'true';
        this.div = null;
    }
    getUserAppInstances(name, group) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.insts = [];
            this.instances = [];
            this.items = [];
            const groups = [];
            if (group != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < group.length; i++) {
                    // groups.push(group[i].groupName);
                    groups.push(group[i].groupId.toString());
                }
            }
            this.instcount = 0;
            const igid = [];
            yield this.userInstanceService.getUserAppInstancesByUser(name).subscribe((instance1) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                if (instance1 !== undefined && instance1 !== null && instance1.length > 0) {
                    for (const i of instance1) {
                        if (!igid.includes(i.instanceId)) {
                            this.instcount += 1;
                            igid.push(i.instanceId);
                        }
                    }
                }
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < instance1.length; i++) {
                    const image = this.domSanitizer.bypassSecurityTrustUrl(instance1[i].instanceIcon);
                    instance1[i].IIcon = image;
                    if (this.ids.includes(instance1[i].instanceId) === false) {
                        let url = '';
                        if (!/^http[s]?:\/\//.test(instance1[i].appUrl)) {
                            url += 'http://';
                        }
                        url += instance1[i].appUrl;
                        instance1[i].appUrl = url;
                        this.ids.push(instance1[i].instanceId);
                        this.insts.push(instance1[i]);
                        this.instances.push(instance1[i]);
                        this.items.push({ label: instance1[i].instanceName, value: instance1[i],
                            routerLink: ['/home/' + instance1[i].instanceName],
                            icon: this.domSanitizer.bypassSecurityTrustUrl(instance1[i].instanceIcon),
                            command: (event) => { this.show(instance1[i]); } });
                    }
                }
                if (groups !== null && groups.length !== 0) {
                    const igrps = [];
                    let counting = 1;
                    // tslint:disable-next-line: prefer-for-of
                    for (let j = 0; j < groups.length; j++) {
                        // tslint:disable-next-line: no-shadowed-variable
                        yield this.userInstanceService.getUserAppInstancesByGroup(groups[j]).subscribe((instance) => {
                            if (instance !== undefined && instance !== null && instance.length > 0) {
                                for (const i of instance) {
                                    if (!igid.includes(i.instanceId)) {
                                        this.instcount += 1;
                                        igid.push(i.instanceId);
                                    }
                                }
                            }
                            let count = 1;
                            if (instance != null && instance.length > 0) {
                                // tslint:disable-next-line: prefer-for-of
                                for (let k = 0; k < instance.length; k++) {
                                    // tslint:disable-next-line: no-shadowed-variable
                                    const image = this.domSanitizer.bypassSecurityTrustUrl(instance[k].instanceIcon);
                                    instance[k].IIcon = image;
                                    if (this.ids.includes(instance[k].instanceId) === false) {
                                        let url = '';
                                        if (!/^http[s]?:\/\//.test(instance[k].appUrl)) {
                                            url += 'http://';
                                        }
                                        url += instance[k].appUrl;
                                        instance[k].appUrl = url;
                                        this.ids.push(instance[k].instanceId);
                                        this.insts.push(instance[k]);
                                        this.instances.push(instance[k]);
                                        this.items.push({ label: instance[k].instanceName, value: instance[k],
                                            routerLink: ['/home/' + instance[k].instanceName],
                                            icon: this.domSanitizer.bypassSecurityTrustUrl(instance[k].instanceIcon),
                                            command: (event) => { this.show(instance[k]); } });
                                        if (count === instance.length && counting === groups.length) {
                                            this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                                            let counter = 1;
                                            // tslint:disable-next-line: prefer-for-of
                                            for (let m = 0; m < this.insts.length; m++) {
                                                // this.instances.push(this.insts[m]);
                                                if (counter === this.insts.length) {
                                                    // localStorage.setItem('instances', JSON.stringify(this.instances));
                                                    this.load();
                                                }
                                                counter += 1;
                                            }
                                        }
                                        if (groups.length === counting) {
                                            // this.instances = [];
                                            this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                                            let counter = 1;
                                            for (const ins of this.insts) {
                                                if (this.ids.includes(ins.instanceId) === false) {
                                                    // this.instances.push(ins);
                                                    this.ids.push(ins.instanceId);
                                                }
                                                if (counter === this.insts.length) {
                                                    // localStorage.setItem('instances', JSON.stringify(this.instances));
                                                    this.load();
                                                }
                                                counter += 1;
                                            }
                                        }
                                        if (count === instance.length) {
                                            counting += 1;
                                        }
                                        count += 1;
                                    }
                                    else {
                                        if (count === instance.length && counting === groups.length) {
                                            this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                                            let counter = 1;
                                            // tslint:disable-next-line: prefer-for-of
                                            for (let m = 0; m < this.insts.length; m++) {
                                                // this.instances.push(this.insts[m]);
                                                if (counter === this.insts.length) {
                                                    // localStorage.setItem('instances', JSON.stringify(this.instances));
                                                    this.load();
                                                }
                                                counter += 1;
                                            }
                                        }
                                        if (groups.length === counting) {
                                            // this.instances = [];
                                            this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                                            let counter = 1;
                                            for (const ins of this.insts) {
                                                if (this.ids.includes(ins.instanceId) === false) {
                                                    // this.instances.push(ins);
                                                    this.ids.push(ins.instanceId);
                                                }
                                                if (counter === this.insts.length) {
                                                    // localStorage.setItem('instances', JSON.stringify(this.instances));
                                                    this.load();
                                                }
                                                counter += 1;
                                            }
                                        }
                                        if (count === instance.length) {
                                            counting += 1;
                                        }
                                        count += 1;
                                    }
                                }
                            }
                            else {
                                if (counting === groups.length) {
                                    this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                                    let counter = 1;
                                    if (this.insts.length > 0) {
                                        // tslint:disable-next-line: prefer-for-of
                                        for (let m = 0; m < this.insts.length; m++) {
                                            if (this.ids.includes(this.insts[m].instanceId) === false) {
                                                // this.instances.push(this.insts[m]);
                                                this.ids.push(this.insts[m].instanceId);
                                            }
                                            if (counter === this.insts.length) {
                                                // localStorage.setItem('instances', JSON.stringify(this.instances));
                                                this.load();
                                            }
                                            counter += 1;
                                        }
                                    }
                                    else {
                                        this.load();
                                    }
                                }
                                counting += 1;
                            }
                        });
                    }
                }
                else {
                    if (this.insts != null && this.insts.length > 0) {
                        this.insts.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
                        let counter = 1;
                        // tslint:disable-next-line: prefer-for-of
                        for (let m = 0; m < this.insts.length; m++) {
                            if (this.ids.includes(this.insts[m].instanceId) === false) {
                                // this.instances.push(this.insts[m]);
                                this.ids.push(this.insts[m].instanceId);
                            }
                            if (counter === this.insts.length) {
                                // localStorage.setItem('instances', JSON.stringify(this.instances));
                                this.load();
                            }
                            counter += 1;
                        }
                    }
                    else {
                        this.load();
                    }
                }
            }));
        });
    }
    save(instance) {
        localStorage.setItem('instance', JSON.stringify(instance));
        localStorage.setItem('instances', JSON.stringify(this.instances));
        if (instance.instanceTarget === 'new_tab') {
            window.open(instance.appUrl);
        }
        else if (instance.instanceTarget === 'content') {
            this.router.navigateByUrl('/home/' + instance.instanceName);
            this.isHomeVisible = null;
            this.isMainVisible = 'true';
        }
    }
    saver(instance) {
        if (instance.instanceTarget === 'new_tab') {
            window.open(instance.appUrl);
        }
        else if (instance.instanceTarget === 'content') {
            // this.toggleOff();
            this.color = '#f2f2f2';
            this.show(instance);
        }
    }
    changePass() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const res = yield this.router.navigateByUrl('/change-password');
            if (res === false) {
                yield this.router.navigateByUrl('/change-password');
            }
        });
    }
    changePin() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const res = yield this.router.navigateByUrl('/change-pin');
            if (res === false) {
                yield this.router.navigateByUrl('/change-pin');
            }
        });
    }
    scroll(elm) {
        const el = document.getElementById(elm);
        if (el != null) {
            el.scrollIntoView({ block: 'center' });
            clearInterval(this.inter);
        }
    }
    scroll2(elm) {
        const el = document.getElementById(elm);
        if (el != null) {
            el.scrollIntoView({ block: 'center' });
            clearInterval(this.inter2);
        }
    }
    scroll3(elm) {
        const el = document.getElementById(elm);
        if (el != null) {
            el.scrollIntoView({ block: 'center' });
            clearInterval(this.inter3);
        }
    }
    load() {
        // this.instances = this.insts;
        this.instances.sort((a, b) => a.instanceName.localeCompare(b.instanceName));
        this.items.sort((a, b) => a.label.localeCompare(b.label));
        localStorage.setItem('instances', JSON.stringify(this.instances));
        if (this.instances.length === 0) {
        }
        else {
            const instance = JSON.parse(localStorage.getItem('instance'));
            const insts = JSON.parse(localStorage.getItem('instances'));
            if (insts != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < insts.length; i++) {
                    const image = this.domSanitizer.bypassSecurityTrustUrl(insts[i].instanceIcon);
                    insts[i].IIcon = image;
                    insts[i].isVisible = false;
                    insts[i].fUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
                    insts[i].first = true;
                }
            }
            this.instances2 = insts;
            // this.show(this.instances2[0]);
            if (this.instances2 !== undefined && this.instances2 !== null && this.instances2.length > 0) {
                if (this.instcount === 1) {
                    this.saver(this.instances[0]);
                }
                else {
                }
            }
        }
        this.isins = true;
    }
    set(instance) {
        const to = setInterval(() => {
            try {
                document.getElementById(instance.instanceName + instance.instanceName).onload = (() => {
                    this.isload = false;
                    clearInterval(to);
                });
            }
            catch (error) {
                // this.isload = false;
            }
        }, 1);
    }
    show(instance) {
        this.isload = true;
        this.issmallmenu = false;
        this.set(instance);
        if (this.holder === 'drawer') {
            this.drawer = 'true';
            this.drawer2 = null;
        }
        else if (this.holder === 'drawer2') {
            this.drawer2 = 'true';
            this.drawer = null;
        }
        else {
            this.drawer2 = null;
            this.drawer = 'true';
        }
        this.div = null;
        if (instance.instanceTarget === 'content') {
            this.previous = instance.instanceName;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.instances2.length; i++) {
                if (this.instances2[i].instanceName === instance.instanceName) {
                    if (this.instances2[i].first === true) {
                        this.instances2[i].fUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.instances[i].appUrl);
                        this.instances2[i].first = false;
                    }
                    else {
                        this.isload = false;
                    }
                    this.instances2[i].isVisible = true;
                }
                else {
                    this.instances2[i].isVisible = false;
                }
            }
            this.router.navigateByUrl('/home/' + instance.instanceName);
            this.inter = setInterval(() => {
                this.scroll(instance.instanceId);
            }, 100);
        }
        else {
            this.isload = false;
            this.router.navigateByUrl('/home/' + this.previous);
            window.open(instance.appUrl);
        }
        localStorage.setItem('instance', JSON.stringify(instance));
    }
    minimize() {
        const ins = JSON.parse(localStorage.getItem('instance'));
        this.drawer = null;
        this.drawer2 = 'true';
        this.holder = 'drawer2';
        this.inter2 = setInterval(() => {
            this.scroll2(ins.instanceId + ' ' + ins.instanceId);
        }, 100);
    }
    maximize() {
        const ins = JSON.parse(localStorage.getItem('instance'));
        this.drawer = 'true';
        this.drawer2 = null;
        this.holder = 'drawer';
        this.inter3 = setInterval(() => {
            this.scroll3(ins.instanceId);
        }, 100);
    }
    menuClicked() {
        this.issmallmenu = !this.issmallmenu;
    }
    gotoAccount() {
        window.open(this.urls.keycloakUrl + '/auth/realms/' + this.variables.realm + '/account');
    }
    gotoLanguage() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const res = yield this.router.navigateByUrl('/language');
            if (res === false) {
                yield this.router.navigateByUrl('/language');
            }
        });
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        this.cookieService.delete('goepla-portal-login');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_9__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_9__["KeycloakService"]);
            keycloakService.loadUserProfile().then((user) => {
                this.fullName = user.firstName + ' ' + user.lastName;
                const extId = keycloakService.getKeycloakInstance().tokenParsed.sub;
                this.userService.getExternalUserById(extId).subscribe((res) => {
                    if (res.userId === 0) {
                        this.translate.get('GENERAL.USERNOTFOUND').subscribe((resp) => {
                            this.confirm(resp);
                        });
                        return;
                    }
                    else {
                        // localStorage.setItem('ext_user', JSON.stringify(res));
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                        const us = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(JSON.stringify(res), v.pass);
                        localStorage.setItem('eu', us);
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                        const pass = 'ranitessarldev2019';
                        const encorg = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(extUser.organisationId.toString(), pass).toString();
                        const encuser = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(extUser.userId.toString(), pass).toString();
                        const domain = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].domain;
                        // this.cookieService.set('goepla-portal-organisation-id', encorg, 1000, '/', domain, false, 'Lax');
                        // this.cookieService.set('goepla-portal-user-id', encuser, 1000, '/', domain, false, 'Lax');
                        const name = extUser.firstName + ' ' + extUser.lastName;
                        this.fullName = name;
                        localStorage.setItem('fullname', name);
                        this.usrgrp.getUserGroupsByUserId(extUser.userId).subscribe((resp) => {
                            const grp = [];
                            let count = 1;
                            if (resp != null) {
                                // tslint:disable-next-line: prefer-for-of
                                for (let m = 0; m < resp.length; m++) {
                                    this.group.getGroupByGroupId(resp[m].groupId).subscribe((respp) => {
                                        // tslint:disable-next-line: prefer-for-of
                                        for (let n = 0; n < respp.length; n++) {
                                            grp.push(respp[n]);
                                        }
                                        if (count === resp.length) {
                                            this.loadInstances(name, grp);
                                        }
                                        count += 1;
                                    });
                                }
                            }
                            else {
                                this.loadInstances(name, null);
                            }
                        });
                    }
                }, err => {
                    this.handleError(err);
                });
            });
        }
        else {
            const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
            let va = localStorage.getItem('eu');
            let eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
            let usr = JSON.parse(eu);
            this.userService.getUser(0, usr.userId, null, null).subscribe((res) => {
                if (res.userId === 0) {
                    this.translate.get('GENERAL.USERNOTFOUND').subscribe((resp) => {
                        this.confirm(resp);
                    });
                    return;
                }
                else {
                    const us = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(JSON.stringify(res), v.pass);
                    localStorage.setItem('eu', us);
                    va = localStorage.getItem('eu');
                    eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
                    usr = JSON.parse(eu);
                    const extUser = usr;
                    this.organisation = extUser.organisationName;
                    const pass = 'ranitessarldev2019';
                    const encorg = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(extUser.organisationId.toString(), pass).toString();
                    const encuser = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].encrypt(extUser.userId.toString(), pass).toString();
                    const domain = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].domain;
                    // this.cookieService.set('goepla-portal-organisation-id', encorg, 1000, '/', domain, false, 'Lax');
                    // this.cookieService.set('goepla-portal-user-id', encuser, 1000, '/', domain, false, 'Lax');
                    const name = extUser.firstName + ' ' + extUser.lastName;
                    this.fullName = name;
                    localStorage.setItem('fullname', name);
                    this.usrgrp.getUserGroupsByUserId(extUser.userId).subscribe((resp) => {
                        const grp = [];
                        let count = 1;
                        if (resp != null) {
                            // tslint:disable-next-line: prefer-for-of
                            for (let m = 0; m < resp.length; m++) {
                                this.group.getGroupByGroupId(resp[m].groupId).subscribe((respp) => {
                                    // tslint:disable-next-line: prefer-for-of
                                    for (let n = 0; n < respp.length; n++) {
                                        grp.push(respp[n]);
                                    }
                                    if (count === resp.length) {
                                        this.loadInstances(name, grp);
                                    }
                                    count += 1;
                                });
                            }
                        }
                        else {
                            this.loadInstances(name, null);
                        }
                    });
                }
            }, err => {
                this.handleError(err);
            });
        }
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        console.log(err);
        return;
    }
};
Home1Component.ctorParameters = () => [
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_12__["DomSanitizer"] },
    { type: src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_10__["UserappinstanceService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_11__["Router"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_12__["DomSanitizer"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_14__["PortalInfoService"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_16__["UsersService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_12__["Title"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_7__["ConfirmationService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_6__["CookieService"] },
    { type: _Services_user_groups_user_groups_service__WEBPACK_IMPORTED_MODULE_5__["UserGroupsService"] },
    { type: _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_4__["GroupsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Injector"] },
    { type: _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_1__["AuthService"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_9__["KeycloakService"] },
    { type: _app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"] }
];
Home1Component = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"])({
        selector: 'app-home1',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home1.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/home1/home1.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home1.component.css */ "./src/app/Components/home1/home1.component.css")).default]
    })
], Home1Component);



/***/ }),

/***/ "./src/app/Components/icons/icons.component.css":
/*!******************************************************!*\
  !*** ./src/app/Components/icons/icons.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n@keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n.icon-card {\n  float: left;\n  width: 350px;\n  height: 125px;\n  max-width: 100px;\n  margin: 10px;\n  margin-bottom: 25px;\n}\n\n.over {\n  width: 75px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\n#home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n#homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n\n.spacer {\n      flex: 1;\n    }\n\n.toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n\n.toolbar span {\n      margin: 15px;\n  }\n\n.toolbar button {\n      margin: 15px;\n  }\n\n#accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n\n#settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n\n.nav-link #name {\n    color: white;\n  }\n\n#accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n\n#settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n#para {\n    align-content: center;\n    align-items: center;\n  }\n\n.cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n.header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n\n.content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/icons/icons.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/Components/icons/icons.component.ts ***!
  \*****************************************************/
/*! exports provided: IconsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconsComponent", function() { return IconsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Services/icons/icons.service */ "./src/app/Services/icons/icons.service.ts");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");


















let IconsComponent = class IconsComponent {
    constructor(router, translate, 
    // private keycloakService: KeycloakService,
    titleService, home, cookieService, confirmationService, notificationSvc, portalinfo, iconsService, domSanitizer, injector, auth, app) {
        this.router = router;
        this.translate = translate;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.portalinfo = portalinfo;
        this.iconsService = iconsService;
        this.domSanitizer = domSanitizer;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.apps = [];
        this.isLoadMore = true;
        this.page = 1;
        this.size = 100;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.options = [];
        this.icons = [];
        this.isAccount = false;
        this.load = false;
        this.isperm = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.translate.get('GENERAL.EDIT').subscribe((resp1) => {
            this.translate.get('GENERAL.DELETE').subscribe((resp2) => {
                this.options = [
                    { label: resp1, value: 'Edit' },
                    { label: resp2, value: 'Delete' }
                ];
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
        this.getIcons();
    }
    gotoupload() {
        this.router.navigateByUrl('/uploadicon');
    }
    getIcons() {
        this.load = true;
        this.iconsService.getIcons().subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    res[i].saveicon = this.domSanitizer.bypassSecurityTrustUrl(res[i].icon);
                    this.icons.push(res[i]);
                }
            }
            this.load = false;
        }, err => this.handleError(err));
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.load = false;
        // tslint:disable-next-line: max-line-length
        if (err.error.Message === '23503: update or delete on table "t_portal_app" violates foreign key constraint "t_portal_app_inst_app_id_fkey" on table "t_portal_app_inst"') {
            this.translate.get('GENERAL.APPHASINSTANCES').subscribe((res) => {
                this.confirm(res);
            });
        }
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
IconsComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__["TranslateService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_11__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__["NotificationService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_2__["PortalInfoService"] },
    { type: _Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_1__["IconsService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["DomSanitizer"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_17__["AppComponent"] }
];
IconsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-icons',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./icons.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/icons/icons.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./icons.component.css */ "./src/app/Components/icons/icons.component.css")).default]
    })
], IconsComponent);



/***/ }),

/***/ "./src/app/Components/instance-detail/instance-detail.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/Components/instance-detail/instance-detail.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".icon-card {\n  float: left;\n  width: 350px;\n  height: 125px;\n  max-width: 100px;\n  margin: 10px;\n  margin-bottom: 25px;\n}\n\n.icon-card:hover {\n  cursor: pointer;\n  background-color: lightgrey;\n}\n\n.over {\n  width: 75px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n\n.ui-float-label {\n  margin-bottom: 5px;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\n.example-container {\n  /*display: flex;*/\n  flex-direction: column;\n}\n\n.example-container > * {\n  width: 50%;\n}\n\n.example-form-field {\n  width: 200px;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\nmat-form-field {\nmargin-right: 12px;\n}\n\n.alert {\ncolor: red;\n}\n\n#home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n#homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n\n.spacer {\n      flex: 1;\n    }\n\n.toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n\n.toolbar span {\n      margin: 15px;\n  }\n\n.toolbar button {\n      margin: 15px;\n  }\n\n#accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n\n#settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n\n.nav-link #name {\n    color: white;\n  }\n\n#accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n\n#settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n#para {\n    align-content: center;\n    align-items: center;\n  }\n\n.cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n.header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n\n.content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n\n/* Tablet targetted size */\n\n@media screen and (max-width:768px) {\n  #orgsec {\n    float: none !important;\n    margin-top: 400px;\n    width: 100% !important;\n  }\n\n  .example-containerx {\n    width: 100% !important;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/instance-detail/instance-detail.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/Components/instance-detail/instance-detail.component.ts ***!
  \*************************************************************************/
/*! exports provided: InstanceDetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InstanceDetailComponent", function() { return InstanceDetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _Models_GroupInstance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../Models/GroupInstance */ "./src/app/Models/GroupInstance.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/Services/userappinstnce/userappinstance.service */ "./src/app/Services/userappinstnce/userappinstance.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/Services/groups/groups.service */ "./src/app/Services/groups/groups.service.ts");
/* harmony import */ var src_app_Services_group_instance_group_instance_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/Services/group-instance/group-instance.service */ "./src/app/Services/group-instance/group-instance.service.ts");
/* harmony import */ var src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! src/app/Services/icons/icons.service */ "./src/app/Services/icons/icons.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var src_app_Services_organisation_organisation_service__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! src/app/Services/organisation/organisation.service */ "./src/app/Services/organisation/organisation.service.ts");
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");



























let InstanceDetailComponent = class InstanceDetailComponent {
    constructor(router, 
    // private keycloakService: KeycloakService,
    userappinstanceservice, appservice, domSanitizer, translate, portalinfo, titleService, home, cookieService, location, confirmationService, notificationSvc, groups, groupinstance, iconsService, injector, auth, orgService, appc) {
        this.router = router;
        this.userappinstanceservice = userappinstanceservice;
        this.appservice = appservice;
        this.domSanitizer = domSanitizer;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.location = location;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.groups = groups;
        this.groupinstance = groupinstance;
        this.iconsService = iconsService;
        this.injector = injector;
        this.auth = auth;
        this.orgService = orgService;
        this.appc = appc;
        this.alertMessage = 'check information';
        this.isAlert = false;
        this.loading = false;
        this.isCreate = false;
        this.isCancel = false;
        this.AppConfig = '';
        this.InstanceParameters = '';
        this.apps = [];
        this.targets = [];
        this.tempgrps = [];
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_13__["Urls"]();
        this.groups1 = [];
        this.groups2 = [];
        this.grps = [];
        this.icons = [];
        this.display = false;
        this.isAccount = false;
        this.load = false;
        this.organisations = [];
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.hicon = appc.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_22__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_23__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_23__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.CONTENTOPTION').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.NEWTABOPTION').subscribe((resp2) => {
                this.targets = [
                    {
                        label: resp1, value: 'content'
                    },
                    {
                        label: resp2, value: 'new_tab'
                    }
                ];
            });
        });
        this.loadUserProfile();
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.NOFILESELECTED').subscribe((res) => {
            this.filename = res;
        });
        this.load = true;
        // tslint:disable-next-line: deprecation
        appservice.getApplications().subscribe((apps) => {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < apps.length; i++) {
                this.apps.push(apps[i]);
            }
            this.setInstance();
            this.load = false;
        }, err => this.handleError(err));
        this.getOrganisations();
        this.getIcons();
    }
    ngOnInit() {
    }
    setInstance() {
        const inst = localStorage.getItem('inst_detail');
        const instance = JSON.parse(inst);
        this.instanceId = instance.instanceId;
        this.instanceName = instance.instanceName;
        this.InstanceId = instance.instanceId;
        this.InstanceName = instance.instanceName;
        this.InstanceDescription = instance.instanceDescription;
        this.InstanceParameters = instance.instanceParameters;
        this.AppId = instance.appId;
        this.InstanceTarget = instance.instanceTarget;
        this.target = instance.instanceTarget;
        this.icon = this.domSanitizer.bypassSecurityTrustUrl(instance.instanceIcon);
        this.InstanceIcon = instance.instanceIcon;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.apps.length; i++) {
            if (this.apps[i].appId === instance.appId) {
                this.AppName = this.apps[i].appName;
                this.AppId = instance.appId;
            }
        }
    }
    getOrganisations() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const orgs = yield this.orgService.getOrganisations().toPromise().catch(err => this.handleError(err));
            if (orgs != null && orgs.length > 0) {
                for (const val of orgs) {
                    this.organisations.push({ label: val.organisationName, value: val });
                }
            }
            this.loading = false;
        });
    }
    get() {
        this.getGroups();
    }
    getGroups() {
        this.groups1 = [];
        this.groups2 = [];
        this.loading = true;
        // tslint:disable-next-line: deprecation
        this.groups.getGroupsByOrganisation(this.org.organisationId).subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.groups1.push(res[i]);
                }
                this.getInstance();
            }
            else {
                this.getInstance();
            }
        }, err => this.handleError(err));
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    getIcons() {
        this.loading = true;
        // tslint:disable-next-line: deprecation
        this.iconsService.getIcons().subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    res[i].saveicon = this.domSanitizer.bypassSecurityTrustUrl(res[i].icon);
                    this.icons.push(res[i]);
                }
            }
            this.loading = false;
        });
    }
    select(icon) {
        this.display = false;
        this.icon = icon.saveicon;
        this.filename = icon.iconName;
        this.InstanceIcon = icon.icon;
    }
    showIcons() {
        this.display = true;
    }
    Cancel() {
        this.loading = true;
        this.isCancel = true;
        // this.router.navigateByUrl('/manageinstances');
        this.location.back();
    }
    Save() {
        this.loading = true;
        this.isCreate = true;
        if (this.InstanceName === undefined || this.InstanceName === null || this.InstanceName.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERINSTANCENAME').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.InstanceDescription === undefined || this.InstanceDescription === null || this.InstanceDescription.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.ENTERINSTANCEDESCRIPTION').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.target === undefined || this.target === null || this.target.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SELECTTARGET').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else if (this.InstanceIcon === undefined || this.InstanceIcon === null || this.InstanceIcon.trim() === '') {
            this.loading = false;
            this.isCreate = false;
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SELECTICON').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
        }
        else {
            this.isAlert = false;
            const ai = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["InstanceUpdater"]();
            ai.Id = this.instanceId;
            ai.Values = [];
            const name = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            name.Key = 'name';
            name.Value = this.InstanceName;
            ai.Values.push(name);
            const desc = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            desc.Key = 'desc';
            desc.Value = this.InstanceDescription;
            ai.Values.push(desc);
            const target = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            target.Key = 'target';
            target.Value = this.target;
            ai.Values.push(target);
            const params = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            params.Key = 'params';
            params.Value = this.InstanceParameters;
            ai.Values.push(params);
            const icon = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            icon.Key = 'icon';
            icon.Value = this.InstanceIcon;
            ai.Values.push(icon);
            const iconname = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            iconname.Key = 'icon_name';
            iconname.Value = this.filename;
            ai.Values.push(iconname);
            let check = false;
            // tslint:disable-next-line: deprecation
            this.userappinstanceservice.getUserAppInstances().subscribe((resp) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < resp.length; i++) {
                    if (resp[i].instanceName === this.InstanceName && this.InstanceName !== this.instanceName) {
                        check = true;
                    }
                }
                if (check === true) {
                    let alrt;
                    // tslint:disable-next-line: deprecation
                    this.translate.get('ALERT.INSTANCEALREADYEXISTS').subscribe((res) => {
                        alrt = res;
                        this.confirm(alrt);
                    });
                    this.loading = false;
                    this.isCreate = false;
                }
                else {
                    // tslint:disable-next-line: deprecation
                    this.userappinstanceservice.putAppInstance(ai).subscribe(() => {
                        if (this.tempgrps.length > 0) {
                            // tslint:disable-next-line: prefer-for-of
                            for (let i = 0; i < this.tempgrps.length; i++) {
                                const ginst = new _Models_GroupInstance__WEBPACK_IMPORTED_MODULE_4__["GroupInstance"]();
                                ginst.InstanceId = this.instanceId;
                                ginst.Group = this.tempgrps[i];
                                // tslint:disable-next-line: deprecation
                                this.groupinstance.deleteGroupInstance(JSON.stringify(ginst)).subscribe(() => {
                                    if ((i + 1) === this.tempgrps.length) {
                                        this.update();
                                    }
                                });
                            }
                        }
                        else {
                            this.update();
                        }
                    });
                }
            });
        }
    }
    update() {
        if (this.groups2.length > 0) {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.groups2.length; i++) {
                const ginst = new _Models_GroupInstance__WEBPACK_IMPORTED_MODULE_4__["GroupInstance"]();
                ginst.InstanceId = this.instanceId;
                // ginst.Group = this.groups2[i].groupName;
                ginst.Group = this.groups2[i].groupId.toString();
                // tslint:disable-next-line: deprecation
                this.groupinstance.postGroupInstance(ginst).subscribe(() => { });
            }
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.INSTANCEUPDATED').subscribe((respp) => {
                this.notificationSvc.info('', respp, 2000);
                // this.router.navigateByUrl('/manageinstances');
                this.location.back();
                this.loading = false;
                this.isCreate = false;
            });
        }
        else {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.INSTANCEUPDATED').subscribe((respp) => {
                this.notificationSvc.info('', respp, 2000);
                // this.router.navigateByUrl('/manageinstances');
                this.location.back();
                this.loading = false;
                this.isCreate = false;
            });
        }
    }
    getInstance() {
        this.loading = true;
        const inst = localStorage.getItem('inst_detail');
        const instance = JSON.parse(inst);
        this.instanceId = instance.instanceId;
        this.instanceName = instance.instanceName;
        this.InstanceId = instance.instanceId;
        this.InstanceName = instance.instanceName;
        this.InstanceDescription = instance.instanceDescription;
        this.InstanceParameters = instance.instanceParameters;
        this.AppId = instance.appId;
        this.InstanceTarget = instance.instanceTarget;
        this.target = instance.instanceTarget;
        this.icon = this.domSanitizer.bypassSecurityTrustUrl(instance.instanceIcon);
        this.InstanceIcon = instance.instanceIcon;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.apps.length; i++) {
            if (this.apps[i].appId === instance.appId) {
                this.AppName = this.apps[i].appName;
                this.AppId = instance.appId;
            }
        }
        // tslint:disable-next-line: deprecation
        this.groupinstance.getGroupInstances(this.instanceId).subscribe((res) => {
            if (res != null) {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.grps.push(res[i].group.toString());
                }
                const grp = [];
                this.tempgrps = [];
                let count = 0;
                // tslint:disable-next-line: prefer-for-of
                for (let j = 0; j < this.groups1.length; j++) {
                    if (!this.grps.includes(this.groups1[j].groupId.toString())) {
                        grp.push(this.groups1[j]);
                    }
                    else {
                        this.groups2.push(this.groups1[j]);
                        this.tempgrps.push(this.groups1[j].groupId.toString());
                    }
                    count += 1;
                    if (count === this.groups1.length) {
                        this.groups1 = grp;
                    }
                }
                this.loading = false;
            }
        });
    }
    assignUser() {
        this.router.navigateByUrl('/assignuser');
    }
    assignGroup() {
        this.router.navigateByUrl('/assigngroup');
    }
    onFileSelected() {
        const inputNode = document.querySelector('#file');
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (inputNode.files[0]) {
                reader.readAsDataURL(inputNode.files[0]);
            }
            reader.onloadend = (e) => {
                this.filename = inputNode.files[0].name;
                const base64 = e.target.result;
                this.InstanceIcon = base64;
                this.icon = this.domSanitizer.bypassSecurityTrustUrl(base64);
            };
            reader.onerror = (() => {
                this.InstanceIcon = '';
                this.icon = null;
            });
        }
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.load = false;
        this.loading = false;
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_22__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_21__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_8__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_21__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_8__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_22__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_23__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_23__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_22__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_23__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_23__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
InstanceDetailComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_9__["Router"] },
    { type: src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_6__["UserappinstanceService"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_10__["AppService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["DomSanitizer"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_11__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_12__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_14__["CookieService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_1__["Location"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_15__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_16__["NotificationService"] },
    { type: src_app_Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_17__["GroupsService"] },
    { type: src_app_Services_group_instance_group_instance_service__WEBPACK_IMPORTED_MODULE_18__["GroupInstanceService"] },
    { type: src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_19__["IconsService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_7__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_20__["AuthService"] },
    { type: src_app_Services_organisation_organisation_service__WEBPACK_IMPORTED_MODULE_24__["OrganisationService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_25__["AppComponent"] }
];
InstanceDetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_7__["Component"])({
        selector: 'app-instance-detail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./instance-detail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/instance-detail/instance-detail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./instance-detail.component.css */ "./src/app/Components/instance-detail/instance-detail.component.css")).default]
    })
], InstanceDetailComponent);



/***/ }),

/***/ "./src/app/Components/language/language.component.css":
/*!************************************************************!*\
  !*** ./src/app/Components/language/language.component.css ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n  \n  .spacer {\n      flex: 1;\n    }\n  \n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n  \n  .toolbar span {\n      margin: 15px;\n  }\n  \n  .toolbar button {\n      margin: 15px;\n  }\n  \n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n  \n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n  \n  .nav-link #name {\n    color: white;\n  }\n  \n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n  \n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #para {\n    align-content: center;\n    align-items: center;\n  }\n  \n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n  \n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/language/language.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/Components/language/language.component.ts ***!
  \***********************************************************/
/*! exports provided: LanguageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageComponent", function() { return LanguageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Models_language__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Models/language */ "./src/app/Models/language.ts");
/* harmony import */ var _Services_language_language_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../Services/language/language.service */ "./src/app/Services/language/language.service.ts");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");



















let LanguageComponent = class LanguageComponent {
    constructor(translate, 
    // private keycloakService: KeycloakService,
    router, portalinfo, titleService, home, confirmationService, cookieService, injector, auth, language, notificationSvc, app) {
        this.translate = translate;
        this.router = router;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.confirmationService = confirmationService;
        this.cookieService = cookieService;
        this.injector = injector;
        this.auth = auth;
        this.language = language;
        this.notificationSvc = notificationSvc;
        this.app = app;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_11__["Urls"]();
        this.langs = [];
        this.isAccount = false;
        this.loading = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        this.loadUserProfile();
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
        const usr = JSON.parse(eu);
        const og = usr.organisationName;
        if (og === 'ORG_SUPER_ADMIN') {
            this.isLanguage = true;
            this.isManage = true;
        }
        this.getLangs();
    }
    ngOnInit() {
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    trans(value) {
        this.translate.use(value);
        localStorage.setItem('language', value);
        const pass = 'ranitessarldev2019';
        const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].encrypt(value, pass).toString();
        const domain = src_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].domain;
        this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', domain, false, 'Lax');
    }
    getLangs() {
        const langs = this.translate.getLangs();
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < langs.length; i++) {
            this.langs.push({ label: langs[i], value: langs[i] });
        }
        const lang = localStorage.getItem('language');
        // const lang = this.translate.currentLang;
        // tslint:disable-next-line: prefer-for-of
        for (let j = 0; j < this.langs.length; j++) {
            if (this.langs[j].value === lang) {
                this.lang = this.langs[j].value;
            }
        }
    }
    transl() {
        // this.translate.use(this.lang);
        localStorage.setItem('language', this.lang);
        const pass = 'ranitessarldev2019';
        const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].encrypt(this.lang, pass).toString();
        // const enclanguage = this.lang;
        const domain = src_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].domain;
        this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', domain, false, 'Lax');
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
        const va = localStorage.getItem('ui');
        const u = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
        const ui = u;
        const uid = +ui;
        const lang = new _Models_language__WEBPACK_IMPORTED_MODULE_1__["Language"]();
        lang.UserId = uid;
        lang.Lang = this.lang;
        this.loading = true;
        // Remove this field later
        lang.UserId = 1;
        // tslint:disable-next-line: deprecation
        this.language.postLanguage(lang).subscribe((res) => {
            this.loading = false;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.SAVED').subscribe((resp) => {
                this.notificationSvc.info('', resp, 2000);
            });
        }, err => this.handleError(err));
    }
    handleError(err) {
        this.loading = false;
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_15__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_15__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
};
LanguageComponent.ctorParameters = () => [
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_8__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_10__["Home1Component"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_3__["ConfirmationService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_12__["CookieService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_14__["AuthService"] },
    { type: _Services_language_language_service__WEBPACK_IMPORTED_MODULE_2__["LanguageService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_17__["NotificationService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_18__["AppComponent"] }
];
LanguageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-language',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./language.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/language/language.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./language.component.css */ "./src/app/Components/language/language.component.css")).default]
    })
], LanguageComponent);



/***/ }),

/***/ "./src/app/Components/login/login.component.css":
/*!******************************************************!*\
  !*** ./src/app/Components/login/login.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".login {\n    width: 400px;\n    margin: 16px auto;\n    font-size: 16px;\n  }\n  \n  .login-header,\n  .login p {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  \n  .login-triangle {\n    width: 0;\n    margin-right: auto;\n    margin-left: auto;\n    border: 12px solid transparent;\n    border-bottom-color: rgb(15, 66, 107);\n  }\n  \n  .login-header {\n    background: rgb(12, 77, 129);\n    padding: 20px;\n    font-size: 1.4em;\n    font-weight: normal;\n    text-align: center;\n    text-transform: uppercase;\n    color: #fff;\n  }\n  \n  .login-container {\n    background: #ebebeb;\n    padding: 15%;\n  }\n  \n  .fill {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden\n}\n  \n  .fill img {\n    flex-shrink: 0;\n    min-width: 100%;\n    min-height: 100%\n}\n  \n  .center {\n  padding: 7% 2%;\n  text-align: center;\n}\n  \n  @-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n  \n  @keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n  \n  /* Tablet targetted size */\n  \n  @media screen and (max-width:768px) {\n  .fill {\n    display: none;\n    float: none;\n  }\n\n  .center {\n    float: none;\n    margin: auto;\n    width: 100% !important;\n  }\n\n  .login-containers {\n    width: 50%;\n    min-width: 250px;\n    margin: auto;\n  }\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/login/login.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/Components/login/login.component.ts ***!
  \*****************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _Models_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../Services/groups/groups.service */ "./src/app/Services/groups/groups.service.ts");
/* harmony import */ var _Services_permission_permission_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../Services/permission/permission.service */ "./src/app/Services/permission/permission.service.ts");
/* harmony import */ var _Services_image_image_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../../Services/image/image.service */ "./src/app/Services/image/image.service.ts");
/* harmony import */ var _Services_language_language_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../../Services/language/language.service */ "./src/app/Services/language/language.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var src_app_Models_User__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Models/User */ "./src/app/Models/User.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! src/app/Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");






















let LoginComponent = class LoginComponent {
    constructor(authService, router, formBuilder, notificationSvc, translate, confirmationService, userService, location, cookieService, language, fb, imageService, permService, groupService, domSanitizer, keycloakService) {
        this.authService = authService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.notificationSvc = notificationSvc;
        this.translate = translate;
        this.confirmationService = confirmationService;
        this.userService = userService;
        this.location = location;
        this.cookieService = cookieService;
        this.language = language;
        this.fb = fb;
        this.imageService = imageService;
        this.permService = permService;
        this.groupService = groupService;
        this.domSanitizer = domSanitizer;
        this.keycloakService = keycloakService;
        this.load = false;
        this.loading = false;
        this.isVis = false;
        this.orgs = [];
        this.oid = 0;
        this.domain = src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].domain;
        localStorage.clear();
        this.cookieService.set('goepla-portal-language', '', 1000, '/', this.domain, false, 'Lax');
        this.cookieService.set('goepla-portal-user-id', '', 1000, '/', this.domain, false, 'Lax');
        this.cookieService.set('goepla-portal-organisation-id', '', 1000, '/', this.domain, false, 'Lax');
        this.userform = this.fb.group({
            // selectorg: new FormControl(null, Validators.required),
            empid: new _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormControl"]('', _angular_forms__WEBPACK_IMPORTED_MODULE_11__["Validators"].required),
            pin: new _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormControl"]('', _angular_forms__WEBPACK_IMPORTED_MODULE_11__["Validators"].required)
        });
        // this.getImages();
    }
    getLanguage() {
        // Replace the user id with the users user id later
        this.language.getLanguage(1).subscribe((lang) => {
            if (lang.userId > 0) {
                const pass = 'ranitessarldev2019';
                const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(lang.lang, pass).toString();
                // const domain = environment.domain;
                this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', this.domain, false, 'Lax');
                localStorage.setItem('language', lang.lang);
                this.translate.addLangs(['English', 'French']);
                this.translate.setDefaultLang('English');
                let browserLang = this.translate.getBrowserLang();
                if (localStorage.getItem('language') !== null) {
                    browserLang = localStorage.getItem('language');
                }
                this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
                this.isVis = true;
                this.load = false;
            }
            else {
                this.translate.addLangs(['English', 'French']);
                this.translate.setDefaultLang('English');
                let browserLang = this.translate.getBrowserLang();
                if (localStorage.getItem('language') !== null) {
                    browserLang = localStorage.getItem('language');
                }
                this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
                this.isVis = true;
                this.load = false;
            }
        }, err => this.handleError(err));
    }
    getOrganisations() {
        this.userService.getOrganisations().subscribe((os) => {
            if (os != null && os.length > 0) {
                for (const i of os) {
                    this.orgs.push({ label: i.organisationName, value: i });
                }
            }
        });
    }
    getImages() {
        this.load = true;
        this.imageService.getImages().subscribe((res) => {
            this.getLanguage();
            if (res !== null) {
                for (const img of res) {
                    if (img.name === 'icon') {
                        this.icon = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                        // this.icon = img.img;
                        if (img.img === null || img.img === '') {
                            this.icon = 'assets/img.jpg';
                        }
                    }
                    else if (img.name === 'image') {
                        this.image = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                        // this.image = img.img;
                        if (img.img === null || img.img === '') {
                            this.image = 'assets/img.jpg';
                        }
                    }
                }
            }
        }, err => this.handleError(err));
    }
    ngOnInit() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            //   if (this.authService.isLoggedIn) {
            //     this.router.navigate(['/home']);
            //  } else {
            //    await this.getUser();
            //  }
            yield this.getUser();
        });
    }
    login() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            let eml = null;
            let eid = 0;
            if (this.EmployeeId === undefined || this.EmployeeId.toString().trim() === null
                || this.EmployeeId === 0 || this.EmployeeId.toString().trim() === '' || this.EmployeeId.toString().trim() === '0') {
                this.translate.get('GENERAL.ENTEREMPLOYEEIDOREMAIL').subscribe((resp) => {
                    this.confirm(resp);
                    this.loading = false;
                });
                return;
            }
            else {
                if (isNaN(this.EmployeeId)) {
                    if (!this.EmployeeId.toString().match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$')) {
                        this.translate.get('GENERAL.EMAILNOTINCORRECTFORMAT').subscribe((resp) => {
                            this.confirm(resp);
                        });
                        this.loading = false;
                        return;
                    }
                    else {
                        eml = this.EmployeeId;
                    }
                }
                else {
                    eid = this.EmployeeId;
                }
            }
            if (this.Pin === undefined || this.Pin === null || this.Pin.trim() === '') {
                this.translate.get('GENERAL.ENTERPIN').subscribe((resp) => {
                    this.confirm(resp);
                    this.loading = false;
                });
                return;
            }
            const usr = new src_app_Models_User__WEBPACK_IMPORTED_MODULE_16__["User"]();
            usr.EmployeeId = this.EmployeeId;
            usr.Pin = this.Pin;
            this.userService.checkUser(this.oid, eid, eml, null, null, this.Pin).subscribe((response) => {
                if (response === true) {
                    this.userService.getUser(eid, 0, eml, null).subscribe((ress) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                        // Replace the user id with the users user id later
                        this.language.getLanguage(1).subscribe((lang) => {
                            if (lang.userId > 0) {
                                const pass = 'ranitessarldev2019';
                                const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(lang.lang, pass).toString();
                                const dom = src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].domain;
                                this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', dom, false, 'Lax');
                                localStorage.setItem('language', lang.lang);
                            }
                        }, err => this.handleError(err));
                        // const domain = environment.domain;
                        // this.cookieService.set('goepla-portal-login', 'true', 0.042, '/', domain, false, 'Lax');
                        // localStorage.setItem('organisation-id', ress.organisationId);
                        // localStorage.setItem('org-id', ress.organisationId);
                        // localStorage.setItem('user-id', ress.userId);
                        const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
                        const oid = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(JSON.stringify(ress.organisationId), v.pass).toString();
                        const uid = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(JSON.stringify(ress.userId), v.pass).toString();
                        localStorage.setItem('oi', oid);
                        localStorage.setItem('ui', uid);
                        yield this.getGroups();
                    }), err => {
                        this.handleError(err);
                    });
                }
                else {
                    this.translate.get('GENERAL.INVALIDUSER').subscribe((resp) => {
                        this.confirm(resp);
                        this.loading = false;
                    });
                }
            }, err => this.handleError(err));
        });
    }
    getUser() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const eml = (yield this.keycloakService.loadUserProfile()).email;
            this.userService.getUser(0, 0, eml, null).subscribe((ress) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                // Replace the user id with the users user id later
                this.language.getLanguage(1).subscribe((lang) => {
                    if (lang.userId > 0) {
                        const pass = 'ranitessarldev2019';
                        const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(lang.lang, pass).toString();
                        const dom = src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].domain;
                        this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', dom, false, 'Lax');
                        localStorage.setItem('language', lang.lang);
                    }
                }, err => this.handleError(err));
                const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
                const oid = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(JSON.stringify(ress.organisationId), v.pass).toString();
                const uid = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(JSON.stringify(ress.userId), v.pass).toString();
                localStorage.setItem('oi', oid);
                localStorage.setItem('ui', uid);
                yield this.getGroups();
            }), err => {
                this.handleError(err);
            });
        });
    }
    getGroups() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
            const va = localStorage.getItem('ui');
            const ui = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
            const uid = +ui;
            let mygroups = '';
            let username = '';
            let groupids = '';
            const usergroups = yield this.groupService.getUserGroups(0, uid).toPromise()
                .catch(err => this.handleError(err));
            if (usergroups != null && usergroups.length > 0) {
                for (const val of usergroups) {
                    groupids += val.groupId + ':';
                    const group = yield this.groupService.getGroupById(val.groupId).toPromise()
                        .catch(err => this.handleError(err));
                    if (group != null && group.length > 0) {
                        mygroups += group[0].groupName + ':';
                    }
                }
            }
            const gs = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(mygroups, v.pass);
            localStorage.setItem('mg', gs);
            // localStorage.setItem('my-groups', mygroups);
            const user = yield this.userService.getUserInfo(uid, 0, ' ', ' ').toPromise()
                .catch(err => this.handleError(err));
            if (user != null && user.firstName != null && user.lastName != null) {
                username = user.firstName + ' ' + user.lastName;
            }
            // localStorage.setItem('user-name', username);
            // localStorage.setItem('user-group-ids', groupids);
            yield this.getPermissions(user, groupids);
        });
    }
    getPermissions(user, groupids) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const permissions = [];
            // const groupids = localStorage.getItem('user-group-ids');
            if (groupids != null) {
                const gids = groupids.split(':');
                if (gids !== undefined && gids !== null && gids.length > 0) {
                    for (const id of gids) {
                        if (id !== '') {
                            const perms = yield this.permService.getUserPermissions(0, id, ' ').toPromise()
                                .catch(err => this.handleError(err));
                            if (perms != null && perms.length > 0) {
                                for (const perm of perms) {
                                    // localStorage.setItem(perm.perm, perm.perm);
                                    permissions.push(perm.perm);
                                }
                            }
                        }
                    }
                }
            }
            const usr = new src_app_Models_User__WEBPACK_IMPORTED_MODULE_16__["User"]();
            usr.EmployeeId = this.EmployeeId;
            usr.Pin = this.Pin;
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
            const us = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].encrypt(JSON.stringify(user), v.pass);
            localStorage.setItem('eu', us);
            yield this.setLastLogin();
            // localStorage.setItem('ext_user', JSON.stringify(user));
            this.authService.login(usr);
            window.location.reload();
            this.loading = false;
        });
    }
    setLastLogin() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
            const va = localStorage.getItem('eu');
            const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
            const usr = JSON.parse(eu);
            const upt = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_20__["UserUpdater"]();
            upt.Id = usr.userId;
            upt.Values = [];
            const llogin = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_20__["KeyValue"]();
            llogin.Key = 'lst_login';
            upt.Values.push(llogin);
            yield this.userService.putUser(upt.Id, upt).toPromise().catch(err => this.handleError(err));
        });
    }
    logout() {
        this.authService.logout();
        this.router.navigateByUrl('/login');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        console.log(err);
        this.loading = false;
        this.load = false;
        this.translate.addLangs(['English', 'French']);
        this.translate.setDefaultLang('English');
        let browserLang = this.translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        this.isVis = true;
        if (err.error.Message === 'Invalid employee id') {
            this.translate.get('GENERAL.INVALIDUSER').subscribe((resp) => {
                this.confirm(resp);
                this.loading = false;
            });
        }
        if (err.error.Message === 'Incorrect password') {
            this.translate.get('GENERAL.INVALIDUSER').subscribe((resp) => {
                this.confirm(resp);
                this.loading = false;
            });
        }
        if (err.error.Message === 'More than one employee ids') {
            this.translate.get('GENERAL.EMPLOYEEIDCANNOTBEUSED').subscribe((resp) => {
                this.confirm(resp);
                this.loading = false;
            });
        }
        if (err.error.Message === 'Invalid email') {
            this.translate.get('GENERAL.INVALIDUSER').subscribe((resp) => {
                this.confirm(resp);
                this.loading = false;
            });
        }
    }
};
LoginComponent.ctorParameters = () => [
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_9__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_10__["Router"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormBuilder"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__["NotificationService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__["TranslateService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_14__["ConfirmationService"] },
    { type: src_app_Services_users_users_service__WEBPACK_IMPORTED_MODULE_15__["UsersService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_7__["Location"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_18__["CookieService"] },
    { type: _Services_language_language_service__WEBPACK_IMPORTED_MODULE_6__["LanguageService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormBuilder"] },
    { type: _Services_image_image_service__WEBPACK_IMPORTED_MODULE_5__["ImageService"] },
    { type: _Services_permission_permission_service__WEBPACK_IMPORTED_MODULE_4__["PermissionService"] },
    { type: _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_3__["GroupsService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["DomSanitizer"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_21__["KeycloakService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/Components/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/Components/manage-apps/manage-apps.component.css":
/*!******************************************************************!*\
  !*** ./src/app/Components/manage-apps/manage-apps.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n\n\n\n\n\n\n  @keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n\n\n\n\n\n\n  #home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n\n\n\n\n\n\n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n\n\n\n\n\n\n\n  .spacer {\n      flex: 1;\n    }\n\n\n\n\n\n\n\n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n\n\n\n\n\n\n\n  .toolbar span {\n      margin: 15px;\n  }\n\n\n\n\n\n\n\n  .toolbar button {\n      margin: 15px;\n  }\n\n\n\n\n\n\n\n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n\n\n\n\n\n\n\n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n\n\n\n\n\n\n\n  .nav-link #name {\n    color: white;\n  }\n\n\n\n\n\n\n\n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n\n\n\n\n\n\n\n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n\n\n\n\n\n\n  #para {\n    align-content: center;\n    align-items: center;\n  }\n\n\n\n\n\n\n\n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n\n\n\n\n\n\n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n\n\n\n\n\n\n\n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/manage-apps/manage-apps.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/Components/manage-apps/manage-apps.component.ts ***!
  \*****************************************************************/
/*! exports provided: ManageAppsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManageAppsComponent", function() { return ManageAppsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");


















let ManageAppsComponent = class ManageAppsComponent {
    constructor(router, appservice, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, home, cookieService, confirmationService, notificationSvc, injector, auth, app) {
        this.router = router;
        this.appservice = appservice;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.apps = [];
        this.isLoadMore = true;
        this.page = 1;
        this.size = 100;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_9__["Urls"]();
        this.options = [];
        this.isAccount = false;
        this.load = false;
        this.isperm = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.EDIT').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.DELETE').subscribe((resp2) => {
                this.options = [
                    { label: resp1, value: 'Edit' },
                    { label: resp2, value: 'Delete' }
                ];
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
        localStorage.removeItem('app_detail');
        this.getApps();
    }
    createApp() {
        this.router.navigateByUrl('/createapp');
    }
    getApps() {
        this.load = true;
        // tslint:disable-next-line: deprecation
        this.appservice.getApplicationsPageSize(this.page, this.size).subscribe((apps) => {
            // tslint:disable-next-line: prefer-for-of
            for (let j = 0; j < apps.length; j++) {
                apps[j].config = apps[j].appConfig;
                if (apps[j].appConfig.trim() === '') {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.NOCONFIGURATION').subscribe((res) => {
                        apps[j].config = res;
                    });
                }
                apps[j].options = this.options;
                this.apps.push(apps[j]);
            }
            if (apps.length < this.size) {
                this.isLoadMore = true;
            }
            else {
                this.isLoadMore = false;
            }
            this.load = false;
            /*this.apps.sort((a, b) => {
              if (a.appName < b.appName) { return -1; }
              if (a.appName > b.appName) { return 1; }
              return 0;
            });*/
        }, err => this.handleError(err));
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    saveApp(event, app) {
        if (event.value === 'Edit') {
            localStorage.setItem('app_detail', JSON.stringify(app));
            this.router.navigateByUrl('/appdetail');
        }
        else if (event.value === 'Delete') {
            this.deleteApp(app);
        }
    }
    deleteApp(app) {
        this.load = true;
        // tslint:disable-next-line: deprecation
        this.appservice.deleteApp(app.appId).subscribe((resp) => {
            if (resp === true) {
                let alrt;
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.DELETED').subscribe((res) => {
                    alrt = res;
                    this.notificationSvc.info('', alrt, 2000);
                });
                this.apps = [];
                this.getApps();
            }
            else {
                this.load = false;
                let alrt;
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.COULDNOTDELETEAPP').subscribe((res) => {
                    alrt = res;
                    this.confirm(alrt);
                });
            }
        }, err => this.handleError(err));
    }
    loadMore() {
        this.page += 1;
        this.getApps();
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.load = false;
        // tslint:disable-next-line: max-line-length
        if (err.error.Message === '23503: update or delete on table "t_portal_app" violates foreign key constraint "t_portal_app_inst_app_id_fkey" on table "t_portal_app_inst"') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.APPHASINSTANCES').subscribe((res) => {
                this.confirm(res);
            });
        }
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_5__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_5__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
ManageAppsComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_4__["AppService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_1__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_6__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_7__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_8__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_11__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__["NotificationService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_13__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_17__["AppComponent"] }
];
ManageAppsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-manage-apps',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./manage-apps.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-apps/manage-apps.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./manage-apps.component.css */ "./src/app/Components/manage-apps/manage-apps.component.css")).default]
    })
], ManageAppsComponent);



/***/ }),

/***/ "./src/app/Components/manage-instances/manage-instances.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/Components/manage-instances/manage-instances.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n\n\n\n\n\n  @keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n\n\n\n\n\n  #home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n\n\n\n\n\n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n\n\n\n\n\n\n  .spacer {\n      flex: 1;\n    }\n\n\n\n\n\n\n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n\n\n\n\n\n\n  .toolbar span {\n      margin: 15px;\n  }\n\n\n\n\n\n\n  .toolbar button {\n      margin: 15px;\n  }\n\n\n\n\n\n\n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n\n\n\n\n\n\n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n\n\n\n\n\n\n  .nav-link #name {\n    color: white;\n  }\n\n\n\n\n\n\n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n\n\n\n\n\n\n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n\n\n\n\n\n  #para {\n    align-content: center;\n    align-items: center;\n  }\n\n\n\n\n\n\n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n\n\n\n\n\n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n\n\n\n\n\n\n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/manage-instances/manage-instances.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/Components/manage-instances/manage-instances.component.ts ***!
  \***************************************************************************/
/*! exports provided: ManageInstancesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManageInstancesComponent", function() { return ManageInstancesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/app/Services/application/app.service */ "./src/app/Services/application/app.service.ts");
/* harmony import */ var src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Services/userappinstnce/userappinstance.service */ "./src/app/Services/userappinstnce/userappinstance.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");



















let ManageInstancesComponent = class ManageInstancesComponent {
    constructor(router, userInstanceService, translate, 
    // private keycloakService: KeycloakService,
    portalinfo, titleService, home, cookieService, confirmationService, notificationSvc, appservice, injector, auth, app) {
        this.router = router;
        this.userInstanceService = userInstanceService;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.appservice = appservice;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.instances = [];
        this.isLoadMore = true;
        this.page = 1;
        this.size = 100;
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_10__["Urls"]();
        this.options = [];
        this.isAccount = false;
        this.load = false;
        this.isperm = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.EDIT').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.DELETE').subscribe((resp2) => {
                this.options = [
                    { label: resp1, value: 'Edit' },
                    { label: resp2, value: 'Delete' }
                ];
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
        localStorage.removeItem('inst_detail');
        this.getInstances();
    }
    createAppInstance() {
        this.router.navigateByUrl('/createinstance');
    }
    getInstances() {
        this.load = true;
        // tslint:disable-next-line: deprecation
        this.userInstanceService.getUserAppInstancesPageSize(this.page, this.size).subscribe((instances) => {
            const insts = [];
            // tslint:disable-next-line: prefer-for-of
            for (let j = 0; j < instances.length; j++) {
                instances[j].options = this.options;
                instances[j].params = instances[j].instanceParameters;
                if (instances[j].instanceParameters.trim() === '') {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.NOPARAMETERS').subscribe((res) => {
                        instances[j].params = res;
                    });
                }
                if (instances[j].instanceTarget === 'content') {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.CONTENTOPTION').subscribe((res) => {
                        instances[j].targ = res;
                    });
                }
                else if (instances[j].instanceTarget === 'new_tab') {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.NEWTABOPTION').subscribe((res) => {
                        instances[j].targ = res;
                    });
                }
                this.instances.push(instances[j]);
            }
            if (instances.length < this.size) {
                this.isLoadMore = true;
            }
            else {
                this.isLoadMore = false;
            }
            this.load = false;
            /*this.instances.sort((a, b) => {
              if (a.instanceName < b.instanceName) { return -1; }
              if (a.instanceName > b.instanceName) { return 1; }
              return 0;
            });*/
        }, err => this.handleError(err));
    }
    saveInstance(event, instance) {
        if (event.value === 'Edit') {
            localStorage.setItem('inst_detail', JSON.stringify(instance));
            this.router.navigateByUrl('/instancedetail');
        }
        else if (event.value === 'Delete') {
            this.deleteInstance(instance);
        }
    }
    deleteInstance(instance) {
        this.load = true;
        // tslint:disable-next-line: deprecation
        this.userInstanceService.deleteAppInstance(instance.instanceId).subscribe((resp) => {
            if (resp === true) {
                let alrt;
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.DELETED').subscribe((res) => {
                    alrt = res;
                    this.notificationSvc.info('', alrt, 2000);
                });
                this.instances = [];
                this.getInstances();
            }
            else {
                this.load = false;
                let alrt;
                // tslint:disable-next-line: deprecation
                this.translate.get('ALERT.COULDNOTDELETEINSTANCE').subscribe((res) => {
                    alrt = res;
                    this.confirm(alrt);
                });
            }
        }, err => this.handleError(err));
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    loadMore() {
        this.page += 1;
        this.getInstances();
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.load = false;
        console.log(err);
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_14__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_6__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_16__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_17__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_17__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
ManageInstancesComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: src_app_Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_2__["UserappinstanceService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_7__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_11__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_13__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__["NotificationService"] },
    { type: src_app_Services_application_app_service__WEBPACK_IMPORTED_MODULE_1__["AppService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_4__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_15__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_18__["AppComponent"] }
];
ManageInstancesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Component"])({
        selector: 'app-manage-instances',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./manage-instances.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage-instances/manage-instances.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./manage-instances.component.css */ "./src/app/Components/manage-instances/manage-instances.component.css")).default]
    })
], ManageInstancesComponent);



/***/ }),

/***/ "./src/app/Components/manage/manage.component.css":
/*!********************************************************!*\
  !*** ./src/app/Components/manage/manage.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n  \n  .spacer {\n      flex: 1;\n    }\n  \n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n  \n  .toolbar span {\n      margin: 15px;\n  }\n  \n  .toolbar button {\n      margin: 15px;\n  }\n  \n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n  \n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n  \n  .nav-link #name {\n    color: white;\n  }\n  \n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n  \n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #para {\n    align-content: center;\n    align-items: center;\n  }\n  \n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n  \n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/manage/manage.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/Components/manage/manage.component.ts ***!
  \*******************************************************/
/*! exports provided: ManageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManageComponent", function() { return ManageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");















let ManageComponent = class ManageComponent {
    constructor(
    // private keycloakService: KeycloakService,
    router, translate, portalinfo, titleService, home, cookieService, injector, auth, app) {
        this.router = router;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_8__["Urls"]();
        this.isAccount = false;
        this.portalHeaderColor = 'transparent';
        router.navigateByUrl('/manageapps');
        if (localStorage.getItem('portal-title') === null) {
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.icon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_12__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_13__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_13__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_12__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_11__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_2__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_11__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_2__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_12__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_13__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_13__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_12__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_13__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_13__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
ManageComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_4__["TranslateService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_5__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_7__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_9__["CookieService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_10__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_14__["AppComponent"] }
];
ManageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-manage',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./manage.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/manage/manage.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./manage.component.css */ "./src/app/Components/manage/manage.component.css")).default]
    })
], ManageComponent);



/***/ }),

/***/ "./src/app/Components/notification/notification.component.css":
/*!********************************************************************!*\
  !*** ./src/app/Components/notification/notification.component.css ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".notifications {\n    position: fixed;\n    top: 0;\n    right: 0;\n    margin-right: 35%;\n    z-index: 1000;\n    min-width: 400px;\n    max-width: 400px;\n}\n    .notification {\n      margin: 5px;\n      border-radius: 5px;\n      color: #fff;\n      overflow: hidden;\n    }\n    .title {\n        background: rgba(0, 0, 0, 0.6);\n        padding-left: 10px;\n        font-weight: bold;\n      }\n    .message {\n        background: rgba(0, 0, 0, 0.4);\n        padding: 10px;\n        max-height: 200px;\n        overflow-y: auto;\n      }\n    .info {\n        background-color: rgba(189, 189, 189, 0.9);\n      }\n    .success {\n        background-color: rgba(27, 158, 119, 0.9);\n      }\n    .warning {\n        background-color: rgba(217, 95, 2, 0.9);\n      }\n    .error {\n        background-color: rgba(246, 71, 71, 0.9);\n      }\n  \n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvQ29tcG9uZW50cy9ub3RpZmljYXRpb24vbm90aWZpY2F0aW9uLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxlQUFlO0lBQ2YsTUFBTTtJQUNOLFFBQVE7SUFDUixpQkFBaUI7SUFDakIsYUFBYTtJQUNiLGdCQUFnQjtJQUNoQixnQkFBZ0I7QUFDcEI7SUFDSTtNQUNFLFdBQVc7TUFDWCxrQkFBa0I7TUFDbEIsV0FBVztNQUNYLGdCQUFnQjtJQUNsQjtJQUNFO1FBQ0UsOEJBQThCO1FBQzlCLGtCQUFrQjtRQUNsQixpQkFBaUI7TUFDbkI7SUFFQTtRQUNFLDhCQUE4QjtRQUM5QixhQUFhO1FBQ2IsaUJBQWlCO1FBQ2pCLGdCQUFnQjtNQUNsQjtJQUVBO1FBQ0UsMENBQTBDO01BQzVDO0lBRUE7UUFDRSx5Q0FBeUM7TUFDM0M7SUFFQTtRQUNFLHVDQUF1QztNQUN6QztJQUVBO1FBQ0Usd0NBQXdDO01BQzFDIiwiZmlsZSI6InNyYy9hcHAvQ29tcG9uZW50cy9ub3RpZmljYXRpb24vbm90aWZpY2F0aW9uLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubm90aWZpY2F0aW9ucyB7XG4gICAgcG9zaXRpb246IGZpeGVkO1xuICAgIHRvcDogMDtcbiAgICByaWdodDogMDtcbiAgICBtYXJnaW4tcmlnaHQ6IDM1JTtcbiAgICB6LWluZGV4OiAxMDAwO1xuICAgIG1pbi13aWR0aDogNDAwcHg7XG4gICAgbWF4LXdpZHRoOiA0MDBweDtcbn1cbiAgICAubm90aWZpY2F0aW9uIHtcbiAgICAgIG1hcmdpbjogNXB4O1xuICAgICAgYm9yZGVyLXJhZGl1czogNXB4O1xuICAgICAgY29sb3I6ICNmZmY7XG4gICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIH1cbiAgICAgIC50aXRsZSB7XG4gICAgICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC42KTtcbiAgICAgICAgcGFkZGluZy1sZWZ0OiAxMHB4O1xuICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgIH1cbiAgXG4gICAgICAubWVzc2FnZSB7XG4gICAgICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC40KTtcbiAgICAgICAgcGFkZGluZzogMTBweDtcbiAgICAgICAgbWF4LWhlaWdodDogMjAwcHg7XG4gICAgICAgIG92ZXJmbG93LXk6IGF1dG87XG4gICAgICB9XG4gIFxuICAgICAgLmluZm8ge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDE4OSwgMTg5LCAxODksIDAuOSk7XG4gICAgICB9XG4gIFxuICAgICAgLnN1Y2Nlc3Mge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI3LCAxNTgsIDExOSwgMC45KTtcbiAgICAgIH1cbiAgXG4gICAgICAud2FybmluZyB7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMjE3LCA5NSwgMiwgMC45KTtcbiAgICAgIH1cbiAgXG4gICAgICAuZXJyb3Ige1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI0NiwgNzEsIDcxLCAwLjkpO1xuICAgICAgfVxuICAiXX0= */");

/***/ }),

/***/ "./src/app/Components/notification/notification.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/Components/notification/notification.component.ts ***!
  \*******************************************************************/
/*! exports provided: NotificationComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationComponent", function() { return NotificationComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/Helpers/notification */ "./src/app/Helpers/notification.ts");




let NotificationComponent = class NotificationComponent {
    constructor(notificationSvc) {
        this.notificationSvc = notificationSvc;
        this.notifications = [];
    }
    _addNotification(notification) {
        this.notifications.push(notification);
        if (notification.timeout !== 0) {
            setTimeout(() => this.close(notification), notification.timeout);
        }
    }
    ngOnInit() {
        this.subscription = this.notificationSvc.getObservable().subscribe(notification => this._addNotification(notification));
    }
    // tslint:disable-next-line: use-lifecycle-interface
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    close(notification) {
        this.notifications = this.notifications.filter(notif => notif.id !== notification.id);
    }
    className(notification) {
        let style;
        switch (notification.type) {
            case src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_3__["NotificationType"].success:
                style = 'success';
                break;
            case src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_3__["NotificationType"].warning:
                style = 'warning';
                break;
            case src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_3__["NotificationType"].error:
                style = 'error';
                break;
            default:
                style = 'info';
                break;
        }
        return style;
    }
};
NotificationComponent.ctorParameters = () => [
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_2__["NotificationService"] }
];
NotificationComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-notification',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./notification.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/notification/notification.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./notification.component.css */ "./src/app/Components/notification/notification.component.css")).default]
    })
], NotificationComponent);



/***/ }),

/***/ "./src/app/Components/null/null.component.css":
/*!****************************************************!*\
  !*** ./src/app/Components/null/null.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL0NvbXBvbmVudHMvbnVsbC9udWxsLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/Components/null/null.component.ts":
/*!***************************************************!*\
  !*** ./src/app/Components/null/null.component.ts ***!
  \***************************************************/
/*! exports provided: NullComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NullComponent", function() { return NullComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");





let NullComponent = class NullComponent {
    constructor(confirmationService, translate, keycloakService) {
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        this.confirmationService = confirmationService;
        this.translate = translate;
        this.keycloakService = keycloakService;
        this.infoText = 'Information';
        this.closeText = 'Close';
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        // this.translate.get('ALERT.BROWSERCHECK').subscribe((resp) => {
        //   this.confirm(resp);
        // });
    }
    ngOnInit() {
        this.confirm('Browser doesn\'t fulfill the browser requirements:' +
            ' The Browser requirements are: Browser type = Chrome, Minimum browser version = 80.0.3987.122');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
};
NullComponent.ctorParameters = () => [
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_3__["ConfirmationService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_4__["TranslateService"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_1__["KeycloakService"] }
];
NullComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./null.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/null/null.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./null.component.css */ "./src/app/Components/null/null.component.css")).default]
    })
], NullComponent);



/***/ }),

/***/ "./src/app/Components/portal-info/portal-info.component.css":
/*!******************************************************************!*\
  !*** ./src/app/Components/portal-info/portal-info.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n  .example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  .example-container {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .example-container > * {\n    width: 100%;\n  }\n  \n  .example-form-field {\n    width: 200px;\n  }\n  \n  .example-form {\n    min-width: 150px;\n    max-width: 500px;\n    width: 100%;\n  }\n  \n  .example-full-width {\n    width: 100%;\n  }\n  \n  mat-form-field {\n  margin-right: 12px;\n  }\n  \n  #home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n  \n  .spacer {\n      flex: 1;\n    }\n  \n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n  \n  .toolbar span {\n      margin: 15px;\n  }\n  \n  .toolbar button {\n      margin: 15px;\n  }\n  \n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n  \n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n  \n  .nav-link #name {\n    color: white;\n  }\n  \n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n  \n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #para {\n    align-content: center;\n    align-items: center;\n  }\n  \n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n  \n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n  input {\n  min-width: 250px !important;\n}\n  \n  @media screen and (max-width:768px) {\n  #portalname, #selectorgicon, #selectorgimage {\n    width: 100% !important;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/portal-info/portal-info.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/Components/portal-info/portal-info.component.ts ***!
  \*****************************************************************/
/*! exports provided: PortalInfoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalInfoComponent", function() { return PortalInfoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_image_image_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Services/image/image.service */ "./src/app/Services/image/image.service.ts");
/* harmony import */ var src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./../../app.component */ "./src/app/app.component.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../../Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _Models_PortalInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../../Models/PortalInfo */ "./src/app/Models/PortalInfo.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_19__);





















let PortalInfoComponent = class PortalInfoComponent {
    constructor(portalinfo, translate, appcomp, home, titleService, 
    // private keycloakService: KeycloakService,
    router, cookieService, confirmationService, notificationSvc, injector, auth, domSanitizer, imageService) {
        this.portalinfo = portalinfo;
        this.translate = translate;
        this.appcomp = appcomp;
        this.home = home;
        this.titleService = titleService;
        this.router = router;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.injector = injector;
        this.auth = auth;
        this.domSanitizer = domSanitizer;
        this.imageService = imageService;
        this.portalHeaderColor = 'transparent';
        this.isSave = false;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_12__["Urls"]();
        this.loading = false;
        this.isAccount = false;
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.titleService.setTitle(res[i].portalTitle);
                    this.HeaderColor = res[i].portalHeaderColor;
                    this.portalHeaderColor = res[i].portalHeaderColor;
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.HeaderColor = localStorage.getItem('headercolor');
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.hicon = appcomp.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        this.loadUserProfile();
        this.portalname = localStorage.getItem('portal-title');
        // tslint:disable-next-line: radix
        this.portalid = parseInt(localStorage.getItem('portal-id'));
        this.getImages();
    }
    ngOnInit() {
    }
    getImages() {
        this.loading = true;
        // tslint:disable-next-line: deprecation
        this.imageService.getImages().subscribe((res) => {
            if (res !== null) {
                for (const img of res) {
                    if (img.name === 'icon') {
                        // this.icon = img.img;
                        this.icon = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                        this.Icon = img.img;
                    }
                    else if (img.name === 'image') {
                        // this.image = img.img;
                        this.image = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                        this.Image = img.img;
                    }
                }
            }
            this.loading = false;
        }, err => this.handleError(err));
    }
    save() {
        this.isSave = true;
        this.loading = true;
        if (this.portalname === undefined || this.portalname == null || this.portalname.trim() === '') {
            let alrt;
            // tslint:disable-next-line: deprecation
            this.translate.get('ALERT.PROVIDEAPPTITLE').subscribe((res) => {
                alrt = res;
                this.confirm(alrt);
            });
            this.isSave = false;
            this.loading = false;
        }
        else if (this.Icon === undefined || this.Icon === null || this.Icon.toString().trim() === '') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.SELECTORGANISATIONICON').subscribe((res) => {
                this.confirm(res);
            });
            this.isSave = false;
            this.loading = false;
        }
        else if (this.Image === undefined || this.Image === null || this.Image.toString().trim() === '') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.SELECTORGANISATIONIMAGE').subscribe((res) => {
                this.confirm(res);
            });
            this.isSave = false;
            this.loading = false;
        }
        else {
            const pi = new _Models_PortalInfo__WEBPACK_IMPORTED_MODULE_7__["PortalInfo"]();
            pi.PortalId = this.portalid;
            pi.PortalTitle = this.portalname;
            pi.PortalHeaderColor = this.HeaderColor;
            const img = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["ImageUpdater"]();
            img.Name = 'general';
            img.Values = [];
            const icon = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            icon.Key = 'icon';
            icon.Value = this.Icon;
            img.Values.push(icon);
            const image = new src_app_Models_KeyValue__WEBPACK_IMPORTED_MODULE_2__["KeyValue"]();
            image.Key = 'image';
            image.Value = this.Image;
            img.Values.push(image);
            // tslint:disable-next-line: deprecation
            this.imageService.putImage(img).subscribe(() => {
                // tslint:disable-next-line: deprecation
                this.portalinfo.putPortalInfo(pi).subscribe(() => {
                    localStorage.setItem('portal-title', this.portalname);
                    localStorage.setItem('headercolor', this.HeaderColor);
                    this.title = this.portalname;
                    this.appcomp.title = this.portalname;
                    this.home.title = this.portalname;
                    this.appcomp.icon = this.icon;
                    this.hicon = this.icon;
                    this.portalHeaderColor = this.HeaderColor;
                    this.titleService.setTitle(this.portalname);
                    let alrt;
                    // tslint:disable-next-line: deprecation
                    this.translate.get('ALERT.SAVED').subscribe((res) => {
                        alrt = res;
                        this.notificationSvc.info('', alrt, 2000);
                        this.loading = false;
                    });
                    this.isSave = false;
                }, err => this.handleError(err));
            }, err => this.handleError(err));
        }
    }
    onIconSelected() {
        const inputNode = document.querySelector('#file');
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (inputNode.files[0]) {
                reader.readAsDataURL(inputNode.files[0]);
            }
            reader.onloadend = (e) => {
                this.IconName = inputNode.files[0].name;
                const base64 = e.target.result;
                this.Icon = base64;
                this.icon = this.domSanitizer.bypassSecurityTrustUrl(base64);
            };
            reader.onerror = (() => {
                this.IconName = '';
                this.Icon = '';
                this.icon = null;
            });
        }
    }
    onImageSelected() {
        const inputNode = document.querySelector('#file2');
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (inputNode.files[0]) {
                reader.readAsDataURL(inputNode.files[0]);
            }
            reader.onloadend = (e) => {
                this.ImageName = inputNode.files[0].name;
                const base64 = e.target.result;
                this.Image = base64;
                this.image = this.domSanitizer.bypassSecurityTrustUrl(base64);
            };
            reader.onerror = (() => {
                this.ImageName = '';
                this.Image = '';
                this.image = null;
            });
        }
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.loading = false;
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_10__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_10__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_18__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_19__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_19__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
PortalInfoComponent.ctorParameters = () => [
    { type: _Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_6__["PortalInfoService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateService"] },
    { type: _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_3__["Home1Component"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__["Title"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_11__["Router"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_13__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_14__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_15__["NotificationService"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_8__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_16__["AuthService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_9__["DomSanitizer"] },
    { type: _Services_image_image_service__WEBPACK_IMPORTED_MODULE_1__["ImageService"] }
];
PortalInfoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"])({
        selector: 'app-portal-info',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./portal-info.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/portal-info/portal-info.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./portal-info.component.css */ "./src/app/Components/portal-info/portal-info.component.css")).default]
    })
], PortalInfoComponent);



/***/ }),

/***/ "./src/app/Components/unauthorized-user/unauthorized-user.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/Components/unauthorized-user/unauthorized-user.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL0NvbXBvbmVudHMvdW5hdXRob3JpemVkLXVzZXIvdW5hdXRob3JpemVkLXVzZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/Components/unauthorized-user/unauthorized-user.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/Components/unauthorized-user/unauthorized-user.component.ts ***!
  \*****************************************************************************/
/*! exports provided: UnauthorizedUserComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnauthorizedUserComponent", function() { return UnauthorizedUserComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");






let UnauthorizedUserComponent = class UnauthorizedUserComponent {
    constructor(translate, confirmationService, cookieService, keycloakService) {
        this.translate = translate;
        this.confirmationService = confirmationService;
        this.cookieService = cookieService;
        this.keycloakService = keycloakService;
        this.translate.addLangs(['English', 'French']);
        this.translate.setDefaultLang('English');
        let browserLang = this.translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        // this.cookieService.delete('goepla-portal-login');
        localStorage.clear();
        this.translate.get('GENERAL.NOPERMISSION').subscribe((resp) => {
            this.confirm(resp);
        });
    }
    ngOnInit() {
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
};
UnauthorizedUserComponent.ctorParameters = () => [
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_3__["TranslateService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_4__["ConfirmationService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_5__["CookieService"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_1__["KeycloakService"] }
];
UnauthorizedUserComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-unauthorized-user',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./unauthorized-user.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/unauthorized-user/unauthorized-user.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./unauthorized-user.component.css */ "./src/app/Components/unauthorized-user/unauthorized-user.component.css")).default]
    })
], UnauthorizedUserComponent);



/***/ }),

/***/ "./src/app/Components/upload-icon/upload-icon.component.css":
/*!******************************************************************!*\
  !*** ./src/app/Components/upload-icon/upload-icon.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#home {\n    height: 25px;\n    width: 25px;\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #homeicon {\n    /*margin: -15px,-25px,0px,0px;*/\n    margin-left: -25px;\n    margin-top: -25px;\n  }\n  \n  .spacer {\n      flex: 1;\n    }\n  \n  .toolbar {\n      height: 50px;\n      display: flex;\n      align-items: center;\n      /* background-color: #1976d2; */\n      color: white;\n      font-weight: 600;\n      position: relative;\n      top: 0;\n      z-index: 5;\n    }\n  \n  .toolbar span {\n      margin: 15px;\n  }\n  \n  .toolbar button {\n      margin: 15px;\n  }\n  \n  #accounticon {\n     width: 30px;\n     height: 30px;\n     margin-left: 5px;\n     margin-right: 0px;\n     margin-top: -10px;\n     margin-bottom: -5px;\n   }\n  \n  #settingsicon {\n    width: 25px;\n    height: 25;\n    margin-left: -20px;\n    margin-right: 0px;\n    margin-top: -10px;\n    margin-bottom: -5px;\n  }\n  \n  .nav-link #name {\n    color: white;\n  }\n  \n  #accountbutton {\n    background-color: transparent;\n    align-content: center;\n    text-align: center;\n    align-items: center;\n    border-color: transparent;\n    color:white;\n    margin-right: -15px;\n  }\n  \n  #settingsbutton {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  \n  #para {\n    align-content: center;\n    align-items: center;\n  }\n  \n  .cont{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .header{\n    flex-shrink: 0;\n    flex-grow: 0;\n    /* background: #039be5; */\n    width: 100%;\n  }\n  \n  .content{\n    flex-shrink: 1;\n    flex-grow: 1;\n    position: relative;\n    overflow-y: auto;\n  }\n  \n  input {\n  min-width: 250px !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/Components/upload-icon/upload-icon.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/Components/upload-icon/upload-icon.component.ts ***!
  \*****************************************************************/
/*! exports provided: UploadIconComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadIconComponent", function() { return UploadIconComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Models_Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Models/Icons */ "./src/app/Models/Icons.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/Services/notification/notification.service */ "./src/app/Services/notification/notification.service.ts");
/* harmony import */ var src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/Services/icons/icons.service */ "./src/app/Services/icons/icons.service.ts");
/* harmony import */ var src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var src_app_app_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! src/app/app.component */ "./src/app/app.component.ts");




















let UploadIconComponent = class UploadIconComponent {
    constructor(router, translate, 
    // private keycloakService: KeycloakService,
    titleService, home, cookieService, confirmationService, notificationSvc, portalinfo, iconsService, domSanitizer, location, injector, auth, app) {
        this.router = router;
        this.translate = translate;
        this.titleService = titleService;
        this.home = home;
        this.cookieService = cookieService;
        this.confirmationService = confirmationService;
        this.notificationSvc = notificationSvc;
        this.portalinfo = portalinfo;
        this.iconsService = iconsService;
        this.domSanitizer = domSanitizer;
        this.location = location;
        this.injector = injector;
        this.auth = auth;
        this.app = app;
        this.apps = [];
        this.isLoadMore = true;
        this.page = 1;
        this.size = 100;
        this.instances = [];
        this.urls = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.options = [];
        this.isAccount = false;
        this.portalHeaderColor = 'transparent';
        if (localStorage.getItem('portal-title') === null) {
            // tslint:disable-next-line: deprecation
            portalinfo.getPortalInfo().subscribe((res) => {
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < res.length; i++) {
                    this.title = res[i].portalTitle;
                    localStorage.setItem('portal-title', res[i].portalTitle);
                    localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                    this.portalHeaderColor = res[i].portalHeaderColor;
                    localStorage.setItem('headercolor', res[i].portalHeaderColor);
                    this.titleService.setTitle(res[i].portalTitle);
                }
            });
        }
        else {
            this.title = localStorage.getItem('portal-title');
            this.titleService.setTitle(this.title);
            this.portalHeaderColor = localStorage.getItem('headercolor');
        }
        this.hicon = app.icon;
        // translate.addLangs(['English', 'French']);
        // translate.setDefaultLang('English');
        // let browserLang = translate.getBrowserLang();
        // if (localStorage.getItem('language') !== null) {
        //   browserLang = localStorage.getItem('language');
        // }
        // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        translate.use('English');
        // tslint:disable-next-line: deprecation
        this.translate.get('MANAGE.APPS').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('MANAGE.INSTANCES').subscribe((resp2) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3) => {
                    // tslint:disable-next-line: deprecation
                    this.translate.get('GENERAL.ICONS').subscribe((resp4) => {
                        this.items = [];
                        this.items.push({ label: resp1, routerLink: ['/manageapps'] });
                        this.items.push({ label: resp2, routerLink: ['/manageinstances'] });
                        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_17__["Variables"]();
                        const va = localStorage.getItem('eu');
                        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_18__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_18__["enc"].Utf8);
                        const usr = JSON.parse(eu);
                        const og = usr.organisationName;
                        if (og === 'ORG_SUPER_ADMIN') {
                            this.isLanguage = true;
                            this.isManage = true;
                            this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
                        }
                        this.items.push({ label: resp4, routerLink: ['/icons'] });
                    });
                });
            });
        });
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.EDIT').subscribe((resp1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.DELETE').subscribe((resp2) => {
                this.options = [
                    { label: resp1, value: 'Edit' },
                    { label: resp2, value: 'Delete' }
                ];
            });
        });
        this.loadUserProfile();
    }
    ngOnInit() {
    }
    onUpload() {
        this.loading = true;
        if (this.Icon === undefined || this.Icon === null || this.Icon.trim() === '') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.SELECTICON').subscribe((res) => {
                this.confirm(res);
                this.loading = false;
            });
        }
        else if (this.IconName === undefined || this.IconName === null || this.IconName.trim() === '') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.ENTERICONNAME').subscribe((res) => {
                this.confirm(res);
                this.loading = false;
            });
        }
        else {
            const icon = new _Models_Icons__WEBPACK_IMPORTED_MODULE_1__["Icons"]();
            icon.Icon = this.Icon;
            icon.IconName = this.IconName;
            // tslint:disable-next-line: deprecation
            this.iconsService.postIcon(icon).subscribe((resp) => {
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.ICONUPLOADED').subscribe((res) => {
                    this.notificationSvc.info('', res, 2000);
                    this.loading = false;
                });
                this.location.back();
            }, err => this.handleError(err));
        }
    }
    onCancel() {
        this.location.back();
    }
    onFileSelected() {
        const inputNode = document.querySelector('#file');
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (inputNode.files[0]) {
                reader.readAsDataURL(inputNode.files[0]);
            }
            reader.onloadend = (e) => {
                this.IconName = inputNode.files[0].name;
                const base64 = e.target.result;
                this.Icon = base64;
                this.icon = this.domSanitizer.bypassSecurityTrustUrl(base64);
            };
            reader.onerror = (() => {
                this.IconName = '';
                this.Icon = '';
                this.icon = null;
            });
        }
    }
    changePass() {
        this.router.navigateByUrl('/change-password');
    }
    changePin() {
        this.router.navigateByUrl('/change-pin');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
            }
        });
    }
    handleError(err) {
        this.loading = false;
        // tslint:disable-next-line: max-line-length
        if (err.error.Message === '23505: duplicate key value violates unique constraint "t_icon_icon_name_key"') {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.ICONNAMEALREADYEXISTS').subscribe((res) => {
                this.confirm(res);
            });
        }
    }
    gotoAccount() {
        const variables = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_17__["Variables"]();
        window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_16__["environment"].useKeycloak === 'true') {
            const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
            keycloakService.logout(this.urls.appUrl + '/');
        }
        else {
            this.auth.logout();
            // window.location.reload();
        }
    }
    loadUserProfile() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (src_environments_environment__WEBPACK_IMPORTED_MODULE_16__["environment"].useKeycloak === 'true') {
                const keycloakService = this.injector.get(keycloak_angular__WEBPACK_IMPORTED_MODULE_7__["KeycloakService"]);
                keycloakService.loadUserProfile().then((user) => {
                    this.fullName = user.firstName + ' ' + user.lastName;
                    if (localStorage.getItem('fullname') != null) {
                        this.fullName = localStorage.getItem('fullname');
                    }
                    const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_17__["Variables"]();
                    const va = localStorage.getItem('eu');
                    const eu = crypto_js__WEBPACK_IMPORTED_MODULE_18__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_18__["enc"].Utf8);
                    const usr = JSON.parse(eu);
                    if (va !== null) {
                        const extUser = usr;
                        this.organisation = extUser.organisationName;
                    }
                });
            }
            else {
                const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_17__["Variables"]();
                const va = localStorage.getItem('eu');
                const eu = crypto_js__WEBPACK_IMPORTED_MODULE_18__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_18__["enc"].Utf8);
                const user = JSON.parse(eu);
                this.organisation = user.organisationName;
                this.fullName = user.firstName + ' ' + user.lastName;
            }
        });
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
};
UploadIconComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__["TranslateService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["Title"] },
    { type: _home1_home1_component__WEBPACK_IMPORTED_MODULE_9__["Home1Component"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_10__["CookieService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_11__["ConfirmationService"] },
    { type: src_app_Services_notification_notification_service__WEBPACK_IMPORTED_MODULE_12__["NotificationService"] },
    { type: src_app_Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_13__["PortalInfoService"] },
    { type: src_app_Services_icons_icons_service__WEBPACK_IMPORTED_MODULE_14__["IconsService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_8__["DomSanitizer"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"] },
    { type: src_app_Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_15__["AuthService"] },
    { type: src_app_app_component__WEBPACK_IMPORTED_MODULE_19__["AppComponent"] }
];
UploadIconComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-upload-icon',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./upload-icon.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/upload-icon/upload-icon.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./upload-icon.component.css */ "./src/app/Components/upload-icon/upload-icon.component.css")).default]
    })
], UploadIconComponent);



/***/ }),

/***/ "./src/app/Helpers/Data.ts":
/*!*********************************!*\
  !*** ./src/app/Helpers/Data.ts ***!
  \*********************************/
/*! exports provided: Data */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Data", function() { return Data; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let Data = class Data {
    constructor() { }
};
Data = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], Data);



/***/ }),

/***/ "./src/app/Helpers/notification.ts":
/*!*****************************************!*\
  !*** ./src/app/Helpers/notification.ts ***!
  \*****************************************/
/*! exports provided: Notification, NotificationType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return Notification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationType", function() { return NotificationType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Notification {
    constructor(id, type, title, message, timeout) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.message = message;
        this.timeout = timeout;
    }
}
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["success"] = 0] = "success";
    NotificationType[NotificationType["warning"] = 1] = "warning";
    NotificationType[NotificationType["error"] = 2] = "error";
    NotificationType[NotificationType["info"] = 3] = "info";
})(NotificationType || (NotificationType = {}));


/***/ }),

/***/ "./src/app/Helpers/route-reuse.strategy.ts":
/*!*************************************************!*\
  !*** ./src/app/Helpers/route-reuse.strategy.ts ***!
  \*************************************************/
/*! exports provided: CacheRouteReuseStrategy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CacheRouteReuseStrategy", function() { return CacheRouteReuseStrategy; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class CacheRouteReuseStrategy {
    constructor() {
        this.handlers = {};
    }
    /**
     * Determines if this route (and its subtree) should be detached to be reused later
     * param route
     */
    shouldDetach(route) {
        if (!route.routeConfig || route.routeConfig.loadChildren) {
            return false;
        }
        /** Whether this route should be re used or not */
        let shouldReuse = false;
        // console.log('[router-reuse] checking if this route should be re used or not', route);
        if (route.routeConfig.data) {
            route.routeConfig.data.reuse ? shouldReuse = true : shouldReuse = false;
        }
        return shouldReuse;
    }
    /**
     * Stores the detached route.
     */
    store(route, handler) {
        // console.log('[router-reuse] storing handler');
        if (handler) {
            this.handlers[this.getUrl(route)] = handler;
        }
    }
    /**
     * Determines if this route (and its subtree) should be reattached
     * @param route Stores the detached route.
     */
    shouldAttach(route) {
        // console.log('[router-reuse] checking if it should be re attached');
        return !!this.handlers[this.getUrl(route)];
    }
    /**
     * Retrieves the previously stored route
     */
    retrieve(route) {
        if (!route.routeConfig || route.routeConfig.loadChildren) {
            return null;
        }
        return this.handlers[this.getUrl(route)];
    }
    /**
     * Determines if a route should be reused
     * param future
     * param current
     */
    shouldReuseRoute(future, current) {
        /** We only want to reuse the route if the data of the route config contains a reuse true boolean */
        let reUseUrl = false;
        if (future.routeConfig) {
            if (future.routeConfig.data) {
                reUseUrl = future.routeConfig.data.reuse;
            }
        }
        /**
         * Default reuse strategy by angular assers based on the following condition
         * @see https://github.com/angular/angular/blob/4.4.6/packages/router/src/route_reuse_strategy.ts#L67
         */
        const defaultReuse = (future.routeConfig === current.routeConfig);
        // If either of our reuseUrl and default Url are true, we want to reuse the route
        //
        return reUseUrl || defaultReuse;
    }
    /**
     * Returns a url for the current route
     * param route
     */
    getUrl(route) {
        /** The url we are going to return */
        if (route.routeConfig) {
            const url = route.routeConfig.path;
            // console.log('[router-reuse] returning url', url);
            return url;
        }
    }
}


/***/ }),

/***/ "./src/app/Interceptors/httpconfig.interceptor.ts":
/*!********************************************************!*\
  !*** ./src/app/Interceptors/httpconfig.interceptor.ts ***!
  \********************************************************/
/*! exports provided: HttpConfigInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpConfigInterceptor", function() { return HttpConfigInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");






let HttpConfigInterceptor = class HttpConfigInterceptor {
    constructor(keycloakService) {
        this.keycloakService = keycloakService;
    }
    intercept(request, next) {
        if (request.url.includes('assets')) {
            //
        }
        else {
            const token = this.keycloakService.getKeycloakInstance().idToken;
            if (this.keycloakService.getKeycloakInstance().isTokenExpired() === true) {
                window.location.reload();
            }
            if (token) {
                request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
            }
        }
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])((event) => {
            if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpResponse"]) {
                // console.log('event--->>>', event);
            }
            return event;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])((error) => {
            let data = {};
            data = {
                reason: error && error.error && error.error.reason ? error.error.reason : '',
                status: error.status
            };
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(error);
        }));
    }
};
HttpConfigInterceptor.ctorParameters = () => [
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_1__["KeycloakService"] }
];
HttpConfigInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])()
], HttpConfigInterceptor);



/***/ }),

/***/ "./src/app/Models/App.ts":
/*!*******************************!*\
  !*** ./src/app/Models/App.ts ***!
  \*******************************/
/*! exports provided: App */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return App; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class App {
}


/***/ }),

/***/ "./src/app/Models/GroupInstance.ts":
/*!*****************************************!*\
  !*** ./src/app/Models/GroupInstance.ts ***!
  \*****************************************/
/*! exports provided: GroupInstance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupInstance", function() { return GroupInstance; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class GroupInstance {
}


/***/ }),

/***/ "./src/app/Models/Icons.ts":
/*!*********************************!*\
  !*** ./src/app/Models/Icons.ts ***!
  \*********************************/
/*! exports provided: Icons */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icons", function() { return Icons; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Icons {
}


/***/ }),

/***/ "./src/app/Models/Instance.ts":
/*!************************************!*\
  !*** ./src/app/Models/Instance.ts ***!
  \************************************/
/*! exports provided: Instance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Instance", function() { return Instance; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Instance {
}


/***/ }),

/***/ "./src/app/Models/KeyValue.ts":
/*!************************************!*\
  !*** ./src/app/Models/KeyValue.ts ***!
  \************************************/
/*! exports provided: KeyValue, AppUpdater, InstanceUpdater, IconUpdater, UserUpdater, ImageUpdater */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValue", function() { return KeyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppUpdater", function() { return AppUpdater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InstanceUpdater", function() { return InstanceUpdater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconUpdater", function() { return IconUpdater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserUpdater", function() { return UserUpdater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageUpdater", function() { return ImageUpdater; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class KeyValue {
}
class AppUpdater {
}
class InstanceUpdater {
}
class IconUpdater {
}
class UserUpdater {
}
class ImageUpdater {
}


/***/ }),

/***/ "./src/app/Models/PortalInfo.ts":
/*!**************************************!*\
  !*** ./src/app/Models/PortalInfo.ts ***!
  \**************************************/
/*! exports provided: PortalInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalInfo", function() { return PortalInfo; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class PortalInfo {
}


/***/ }),

/***/ "./src/app/Models/Urls.ts":
/*!********************************!*\
  !*** ./src/app/Models/Urls.ts ***!
  \********************************/
/*! exports provided: Urls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Urls", function() { return Urls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");


// import { environment } from './../../environments/environment.prod';
class Urls {
    constructor() {
        this.keycloakUrl = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].keycloakUrl;
        this.baseUrl = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].baseUrl;
        this.appUrl = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].appUrl;
        this.usmUrl = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].usmUrl;
    }
}


/***/ }),

/***/ "./src/app/Models/User.ts":
/*!********************************!*\
  !*** ./src/app/Models/User.ts ***!
  \********************************/
/*! exports provided: User */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class User {
}


/***/ }),

/***/ "./src/app/Models/language.ts":
/*!************************************!*\
  !*** ./src/app/Models/language.ts ***!
  \************************************/
/*! exports provided: Language */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Language", function() { return Language; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Language {
}


/***/ }),

/***/ "./src/app/Models/variables.ts":
/*!*************************************!*\
  !*** ./src/app/Models/variables.ts ***!
  \*************************************/
/*! exports provided: Variables */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Variables", function() { return Variables; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");


class Variables {
    constructor() {
        this.pass = '#ranitessarldev2020';
        this.realm = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].realm;
        this.clientid = src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].clientid;
    }
}


/***/ }),

/***/ "./src/app/Services/application/app.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/Services/application/app.service.ts ***!
  \*****************************************************/
/*! exports provided: AppService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppService", function() { return AppService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Models_Urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let AppService = class AppService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new _Models_Urls__WEBPACK_IMPORTED_MODULE_1__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getApplications() {
        const url = this.baseUrl + '/api/applications';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getApplicationById(id) {
        const url = this.baseUrl + '/api/applications/' + id;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getApplicationsPageSize(page, size) {
        const url = this.baseUrl + '/api/applications/' + page + '/' + size;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    postApp(app) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/applications', app, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    putApp(app) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/applications/' + app.Id, app, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    deleteApp(id) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/applications/' + id, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        throw error;
        return error;
    }
};
AppService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
AppService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], AppService);



/***/ }),

/***/ "./src/app/Services/auth-guard/auth-guard.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/Services/auth-guard/auth-guard.service.ts ***!
  \***********************************************************/
/*! exports provided: AuthGuardService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuardService", function() { return AuthGuardService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_3__);




let AuthGuardService = class AuthGuardService {
    constructor(
    // private keycloakService: KeycloakService,
    injector) {
        this.injector = injector;
        this.isManage = false;
    }
    canActivate() {
        if (localStorage.getItem('browser') === null
            || localStorage.getItem('browser') === undefined
            || localStorage.getItem('browser') === 'false') {
            return false;
        }
        else {
            const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_2__["Variables"]();
            const va = localStorage.getItem('eu');
            const eu = crypto_js__WEBPACK_IMPORTED_MODULE_3__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_3__["enc"].Utf8);
            const usr = JSON.parse(eu);
            const og = usr.organisationName;
            if (og === 'ORG_SUPER_ADMIN') {
                return true;
            }
            else {
                return false;
            }
        }
    }
};
AuthGuardService.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] }
];
AuthGuardService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], AuthGuardService);



/***/ }),

/***/ "./src/app/Services/auth/auth.service.ts":
/*!***********************************************!*\
  !*** ./src/app/Services/auth/auth.service.ts ***!
  \***********************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");




let AuthService = class AuthService {
    constructor(keycloakService) {
        this.keycloakService = keycloakService;
    }
    login(userInfo) {
        localStorage.setItem('ACCESS_TOKEN', 'access_token');
    }
    isLoggedIn() {
        return localStorage.getItem('ACCESS_TOKEN') !== null;
    }
    logout() {
        const url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__["Urls"]();
        localStorage.removeItem('ACCESS_TOKEN');
        this.keycloakService.logout(url.appUrl + '/');
    }
    clear() {
        localStorage.removeItem('ACCESS_TOKEN');
    }
};
AuthService.ctorParameters = () => [
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_3__["KeycloakService"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], AuthService);



/***/ }),

/***/ "./src/app/Services/file/file.service.ts":
/*!***********************************************!*\
  !*** ./src/app/Services/file/file.service.ts ***!
  \***********************************************/
/*! exports provided: FileService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileService", function() { return FileService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");






let FileService = class FileService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.flmApiUrl = src_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].flmApiUrl;
    }
    getFiles(page, size, fileid, filename, bucketname, start, end) {
        // tslint:disable-next-line: max-line-length
        const url = this.flmApiUrl + '/api/files/' + page + '/' + size + '/' + fileid + '/' + filename
            + '/' + bucketname + '/' + start + '/' + end + '/';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getFile(bucketname, filename) {
        // tslint:disable-next-line: max-line-length
        const url = this.flmApiUrl + '/api/files/' + bucketname + '/' + filename + '/';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    downloadFile(url, type) {
        let headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]();
        // headers = headers.set('Accept', 'application/pdf');
        headers = headers.set('Accept', type);
        headers = headers.set('Remove', 'r');
        return this.httpclient.get(url, { headers, responseType: 'blob' });
    }
    postFile(file) {
        return this.httpclient.post(this.flmApiUrl + '/api/files', file)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    handleError(error) {
        throw error;
        return error;
    }
};
FileService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
FileService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], FileService);



/***/ }),

/***/ "./src/app/Services/group-instance/group-instance.service.ts":
/*!*******************************************************************!*\
  !*** ./src/app/Services/group-instance/group-instance.service.ts ***!
  \*******************************************************************/
/*! exports provided: GroupInstanceService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupInstanceService", function() { return GroupInstanceService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");





let GroupInstanceService = class GroupInstanceService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getGroupInstances(inst) {
        return this.httpclient.get(this.baseUrl + '/api/groupinstance/' + inst)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    postGroupInstance(inst) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/groupinstance', inst, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    deleteGroupInstance(inst) {
        const str = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/groupinstance/' + inst, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    handleError(error) {
        console.error('error', error);
        return error;
    }
};
GroupInstanceService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
GroupInstanceService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], GroupInstanceService);



/***/ }),

/***/ "./src/app/Services/groups/groups.service.ts":
/*!***************************************************!*\
  !*** ./src/app/Services/groups/groups.service.ts ***!
  \***************************************************/
/*! exports provided: GroupsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupsService", function() { return GroupsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_6__);







let GroupsService = class GroupsService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__["Urls"]();
        this.usmUrl = this.url.usmUrl;
    }
    getGroups() {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        const usr = JSON.parse(eu);
        const extUser = usr;
        this.orgId = extUser.organisationId;
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/groups/' + this.orgId;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getGroupByGroupId(id) {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        const usr = JSON.parse(eu);
        const extUser = usr;
        this.orgId = extUser.organisationId;
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/groups/' + this.orgId + '/' + id;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserGroups(gid, uid) {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const val = localStorage.getItem('oi');
        const oi = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(val, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        const orgId = +oi;
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/usergroups/Get_ByUserId/' + orgId + '/' + gid + '/' + uid;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getGroupById(id) {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const val = localStorage.getItem('oi');
        const oi = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(val, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        const orgId = +oi;
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/groups/' + orgId + '/' + id;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getGroupsByOrganisation(orgid) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/groups/' + orgid;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    handleError(error) {
        // console.error('error', error);
        throw error;
        return error;
    }
};
GroupsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
GroupsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], GroupsService);



/***/ }),

/***/ "./src/app/Services/icons/icons.service.ts":
/*!*************************************************!*\
  !*** ./src/app/Services/icons/icons.service.ts ***!
  \*************************************************/
/*! exports provided: IconsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconsService", function() { return IconsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let IconsService = class IconsService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getIcons() {
        return this.httpclient.get(this.baseUrl + '/api/icons')
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    postIcon(icon) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/icons', icon, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    putIcon(icon) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/icons/' + icon.Id, icon, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    deleteIcon(id) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/icons/' + id, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        throw error;
        return error;
    }
};
IconsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
IconsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], IconsService);



/***/ }),

/***/ "./src/app/Services/image/image.service.ts":
/*!*************************************************!*\
  !*** ./src/app/Services/image/image.service.ts ***!
  \*************************************************/
/*! exports provided: ImageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageService", function() { return ImageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let ImageService = class ImageService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getImages() {
        return this.httpclient.get(this.baseUrl + '/api/image')
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    putImage(image) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/image/' + image.Name, image, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        throw error;
        return error;
    }
};
ImageService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
ImageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ImageService);



/***/ }),

/***/ "./src/app/Services/language/language.service.ts":
/*!*******************************************************!*\
  !*** ./src/app/Services/language/language.service.ts ***!
  \*******************************************************/
/*! exports provided: LanguageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LanguageService", function() { return LanguageService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");





let LanguageService = class LanguageService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_2__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getLanguage(uid) {
        return this.httpclient.get(this.baseUrl + '/api/language/' + uid)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    postLanguage(lang) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/language', lang, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    putLanguage(lang) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/language/' + lang.UserId, lang, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    deleteLanguage(uid) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/language/' + uid, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    handleError(error) {
        console.error('error', error);
        return error;
    }
};
LanguageService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
LanguageService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], LanguageService);



/***/ }),

/***/ "./src/app/Services/notification/notification.service.ts":
/*!***************************************************************!*\
  !*** ./src/app/Services/notification/notification.service.ts ***!
  \***************************************************************/
/*! exports provided: NotificationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationService", function() { return NotificationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Helpers/notification */ "./src/app/Helpers/notification.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let NotificationService = class NotificationService {
    constructor() {
        this.subject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.idx = 0;
    }
    getObservable() {
        return this.subject.asObservable();
    }
    info(title, message, timeout = 3000) {
        this.subject.next(new src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["Notification"](this.idx++, src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["NotificationType"].info, title, message, timeout));
    }
    success(title, message, timeout = 3000) {
        this.subject.next(new src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["Notification"](this.idx++, src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["NotificationType"].success, title, message, timeout));
    }
    warning(title, message, timeout = 3000) {
        this.subject.next(new src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["Notification"](this.idx++, src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["NotificationType"].warning, title, message, timeout));
    }
    error(title, message, timeout = 0) {
        this.subject.next(new src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["Notification"](this.idx++, src_app_Helpers_notification__WEBPACK_IMPORTED_MODULE_2__["NotificationType"].error, title, message, timeout));
    }
};
NotificationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], NotificationService);



/***/ }),

/***/ "./src/app/Services/organisation/organisation.service.ts":
/*!***************************************************************!*\
  !*** ./src/app/Services/organisation/organisation.service.ts ***!
  \***************************************************************/
/*! exports provided: OrganisationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrganisationService", function() { return OrganisationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");





let OrganisationService = class OrganisationService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.apiUrl = this.url.usmUrl;
    }
    getOrganisations() {
        // tslint:disable-next-line: max-line-length
        const url = this.apiUrl + '/api/organisations';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getOrganisationsPageSize(page, size) {
        // tslint:disable-next-line: max-line-length
        const url = this.apiUrl + '/api/organisations/' + page + '/' + size;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    handleError(error) {
        // console.error('error', error);
        throw error;
        return error;
    }
};
OrganisationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] }
];
OrganisationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], OrganisationService);



/***/ }),

/***/ "./src/app/Services/permission/permission.service.ts":
/*!***********************************************************!*\
  !*** ./src/app/Services/permission/permission.service.ts ***!
  \***********************************************************/
/*! exports provided: PermissionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PermissionService", function() { return PermissionService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_6__);







let PermissionService = class PermissionService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.apiUrl = this.url.usmUrl;
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const val = localStorage.getItem('oi');
        const oi = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(val, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        this.orgId = +oi;
    }
    getUserPermissions(uid, gid, perm) {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const val = localStorage.getItem('oi');
        const oi = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(val, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        this.orgId = +oi;
        // tslint:disable-next-line: max-line-length
        const url = this.apiUrl + '/api/userpermission/' + this.orgId + '/' + uid + '/' + gid + '/' + perm + '/';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    handleError(error) {
        // console.error('error', error);
        throw error;
        return error;
    }
};
PermissionService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] }
];
PermissionService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], PermissionService);



/***/ }),

/***/ "./src/app/Services/portal-info/portal-info.service.ts":
/*!*************************************************************!*\
  !*** ./src/app/Services/portal-info/portal-info.service.ts ***!
  \*************************************************************/
/*! exports provided: PortalInfoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalInfoService", function() { return PortalInfoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");






let PortalInfoService = class PortalInfoService {
    constructor(httpclient, keycloakService) {
        this.httpclient = httpclient;
        this.keycloakService = keycloakService;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getPortalInfo() {
        return this.httpclient.get(this.baseUrl + '/api/portalinfo')
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    postPortalInfo(pInfo) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/portalinfo', pInfo, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    putPortalInfo(pInfo) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/portalinfo/' + pInfo.PortalId, pInfo, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    deletePortalInfo(id) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/portalinfo/' + id, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        console.error('error', error);
        return error;
    }
};
PortalInfoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClient"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_1__["KeycloakService"] }
];
PortalInfoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    })
], PortalInfoService);



/***/ }),

/***/ "./src/app/Services/user-groups/user-groups.service.ts":
/*!*************************************************************!*\
  !*** ./src/app/Services/user-groups/user-groups.service.ts ***!
  \*************************************************************/
/*! exports provided: UserGroupsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserGroupsService", function() { return UserGroupsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_6__);







let UserGroupsService = class UserGroupsService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.usmUrl = this.url.usmUrl;
    }
    getUserGroupsByUserId(id) {
        const v = new src_app_Models_variables__WEBPACK_IMPORTED_MODULE_5__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_6__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_6__["enc"].Utf8);
        const usr = JSON.parse(eu);
        const extUser = usr;
        this.orgId = extUser.organisationId;
        const url = this.usmUrl + '/api/usergroups/Get_ByUserId/' + this.orgId + '/0/' + id;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    handleError(error) {
        console.log(error);
        throw error;
        return error;
    }
};
UserGroupsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
UserGroupsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UserGroupsService);



/***/ }),

/***/ "./src/app/Services/userappinstnce/userappinstance.service.ts":
/*!********************************************************************!*\
  !*** ./src/app/Services/userappinstnce/userappinstance.service.ts ***!
  \********************************************************************/
/*! exports provided: UserappinstanceService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserappinstanceService", function() { return UserappinstanceService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");





let UserappinstanceService = class UserappinstanceService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_4__["Urls"]();
        this.baseUrl = this.url.baseUrl;
    }
    getUserAppInstances() {
        const url = this.baseUrl + '/api/userappinstance/Get_Instances';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserAppInstancesPageSize(page, size) {
        const url = this.baseUrl + '/api/userappinstance/Get_Instances/' + page + '/' + size;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserAppInstancesByUser(userId) {
        const url = this.baseUrl + '/api/userappinstance/Get_InstancesByUserId/' + userId;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserAppInstancesByGroup(groupId) {
        groupId = groupId.replace('/', '');
        const url = this.baseUrl + '/api/userappinstance/Get_InstancesByGroupId/' + groupId;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    postAppInstance(inst) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.post(this.baseUrl + '/api/userappinstance', inst, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    putAppInstance(inst) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.baseUrl + '/api/userappinstance/' + inst.Id, inst, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    deleteAppInstance(id) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.delete(this.baseUrl + '/api/userappinstance/' + id, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError));
    }
    handleError(error) {
        console.error('error', error);
        return error;
    }
};
UserappinstanceService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
UserappinstanceService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UserappinstanceService);



/***/ }),

/***/ "./src/app/Services/users/users.service.ts":
/*!*************************************************!*\
  !*** ./src/app/Services/users/users.service.ts ***!
  \*************************************************/
/*! exports provided: UsersService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UsersService", function() { return UsersService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let UsersService = class UsersService {
    constructor(httpclient) {
        this.httpclient = httpclient;
        this.url = new src_app_Models_Urls__WEBPACK_IMPORTED_MODULE_3__["Urls"]();
        this.usmUrl = this.url.usmUrl;
    }
    getExternalUsers() {
        const url = this.usmUrl + '/api/externalusers';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getExternalUserById(userId) {
        const url = this.usmUrl + '/api/externalusers/' + userId;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUser(empId, uid, email, phone) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/users/' + uid + '/' + empId + '/' + email + '/' + phone + '/';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserInfo(uid, empid, email, phone) {
        // tslint:disable-next-line: max-line-length
        const url = this.url.usmUrl + '/api/users/ ' + uid + '/' + empid + '/' + email + '/' + phone + '/';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getOrganisations() {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/organisations';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserByEmployeeIds(empId) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/users/0/' + empId;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserByUserIds(uId) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/users/' + uId + '/0';
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    checkUser(orgid, eid, email, phone, pass, pin) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/users/' + orgid + '/' + eid + '/' + email + '/' + phone + '/' + pass + '/' + pin;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserRoles(uid, gid) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/userroles/' + uid + '/' + gid;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    getUserGroupsByGroupIdUserId(orgid, gid, uid) {
        // tslint:disable-next-line: max-line-length
        const url = this.usmUrl + '/api/usergroups/Get_ByUserId/' + orgid + '/' + gid + '/' + uid;
        return this.httpclient.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(// Log the result or error
        // Log the result or error
        error => this.handleError));
    }
    putUser(id, upt) {
        // const body = JSON.stringify(inst);
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/json'
            })
        };
        return this.httpclient.put(this.usmUrl + '/api/users/' + id, upt, options)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(this.handleError));
    }
    handleError(error) {
        console.log(error);
        throw error;
        return error;
    }
};
UsersService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
UsersService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UsersService);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("#home {\n  height: 25px;\n  width: 25px;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#homeicon {\n  /*margin: -15px,-25px,0px,0px;*/\n  margin-left: -25px;\n  margin-top: -25px;\n}\n\n.spacer {\n    flex: 1;\n  }\n\n.toolbar {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    background-color: #1976d2;\n    color: white;\n    font-weight: 600;\n    position: relative;\n    top: 0;\n    z-index: 5;\n  }\n\n.toolbar span {\n    margin: 15px;\n}\n\n.toolbar button {\n    margin: 15px;\n}\n\n#accounticon {\n   width: 30px;\n   height: 30px;\n   margin-left: 5px;\n   margin-right: 0px;\n   margin-top: -10px;\n   margin-bottom: -5px;\n }\n\n#settingsicon {\n  width: 25px;\n  height: 25;\n  margin-left: -20px;\n  margin-right: 0px;\n  margin-top: -10px;\n  margin-bottom: -5px;\n}\n\n.nav-link #name {\n  color: white;\n}\n\n#accountbutton {\n  background-color: transparent;\n  align-content: center;\n  text-align: center;\n  align-items: center;\n  border-color: transparent;\n  color:white;\n  margin-right: -15px;\n}\n\n#settingsbutton {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n#para {\n  align-content: center;\n  align-items: center;\n}\n\n.cont{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header{\n  flex-shrink: 0;\n  flex-grow: 0;\n  background: #039be5;\n  width: 100%;\n}\n\n.content{\n  flex-shrink: 1;\n  flex-grow: 1;\n  position: relative;\n  overflow-y: auto;\n}\n\n@-webkit-keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n@keyframes ui-progress-spinner-color {\n  100%,\n  0% {\n      stroke: #0057e7;\n  }\n  40% {\n      stroke: #0057e7;\n  }\n  66% {\n      stroke: #0057e7;\n  }\n  80%,\n  90% {\n      stroke: #0057e7;\n  }\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Services_file_file_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Services/file/file.service */ "./src/app/Services/file/file.service.ts");
/* harmony import */ var _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var _Services_users_users_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Services/users/users.service */ "./src/app/Services/users/users.service.ts");
/* harmony import */ var _Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Services/portal-info/portal-info.service */ "./src/app/Services/portal-info/portal-info.service.ts");
/* harmony import */ var _Models_Urls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Models/KeyValue */ "./src/app/Models/KeyValue.ts");
/* harmony import */ var _Models_variables__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _Models_User__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Models/User */ "./src/app/Models/User.ts");
/* harmony import */ var _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Services/groups/groups.service */ "./src/app/Services/groups/groups.service.ts");
/* harmony import */ var _Services_image_image_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./Services/image/image.service */ "./src/app/Services/image/image.service.ts");
/* harmony import */ var _Services_language_language_service__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./Services/language/language.service */ "./src/app/Services/language/language.service.ts");
/* harmony import */ var _Services_permission_permission_service__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Services/permission/permission.service */ "./src/app/Services/permission/permission.service.ts");























let AppComponent = class AppComponent {
    constructor(
    // private keycloakService: KeycloakService,
    router, translate, portalinfo, titleService, userService, confirmationService, cookieService, usersService, auth, language, fb, imageService, permService, groupService, domSanitizer, authService, keycloakService, fileService) {
        this.router = router;
        this.translate = translate;
        this.portalinfo = portalinfo;
        this.titleService = titleService;
        this.userService = userService;
        this.confirmationService = confirmationService;
        this.cookieService = cookieService;
        this.usersService = usersService;
        this.auth = auth;
        this.language = language;
        this.fb = fb;
        this.imageService = imageService;
        this.permService = permService;
        this.groupService = groupService;
        this.domSanitizer = domSanitizer;
        this.authService = authService;
        this.keycloakService = keycloakService;
        this.fileService = fileService;
        this.load = true;
        this.instances = [];
        this.urls = new _Models_Urls__WEBPACK_IMPORTED_MODULE_6__["Urls"]();
        this.isVisible = false;
        this.pop = true;
        this.appicon = document.querySelector('#appicon');
        if ('serviceWorker' in navigator) {
            caches.keys().then(function (cacheNames) {
                cacheNames.forEach(function (cacheName) {
                    caches.delete(cacheName);
                });
            });
        }
        auth.clear();
        translate.addLangs(['English', 'French']);
        translate.setDefaultLang('English');
        let browserLang = translate.getBrowserLang();
        if (localStorage.getItem('language') !== null) {
            browserLang = localStorage.getItem('language');
        }
        translate.use(browserLang.match(/English|French/) ? browserLang : 'English');
        // this.setLastLogin();
        router.navigateByUrl('/');
    }
    setLastLogin2() {
        const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
        const va = localStorage.getItem('eu');
        const eu = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
        const usr = JSON.parse(eu);
        const upt = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["UserUpdater"]();
        upt.Id = usr.userId;
        upt.Values = [];
        const llogin = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["KeyValue"]();
        llogin.Key = 'lst_login';
        upt.Values.push(llogin);
        // tslint:disable-next-line: deprecation
        this.userService.putUser(upt.Id, upt).subscribe((res) => {
        }, err => {
            this.handleError(err);
        });
    }
    ngOnInit() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (localStorage.getItem('portal-title') === null) {
                // tslint:disable-next-line: deprecation
                this.portalinfo.getPortalInfo().subscribe((res) => {
                    // tslint:disable-next-line: prefer-for-of
                    for (let i = 0; i < res.length; i++) {
                        this.title = res[i].portalTitle;
                        localStorage.setItem('portal-title', res[i].portalTitle);
                        localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
                        localStorage.setItem('headercolor', res[i].portalHeaderColor);
                        this.titleService.setTitle(res[i].portalTitle);
                    }
                });
            }
            else {
                this.title = localStorage.getItem('portal-title');
                this.titleService.setTitle(this.title);
            }
            // this.router.navigateByUrl('/home');
            yield this.getImages();
            yield this.setIcon();
            yield this.getUser();
        });
    }
    getImages() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.load = true;
            const res = yield this.imageService.getImages().toPromise()
                .catch(err => this.handleError(err));
            if (res !== null) {
                for (const img of res) {
                    if (img.name === 'icon') {
                        if (img.img === undefined || img.img === null || img.img === '') {
                            this.icon = null;
                        }
                        else {
                            this.icon = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                        }
                    }
                    else if (img.name === 'image') {
                        //  const image = this.domSanitizer.bypassSecurityTrustUrl(img.img);
                    }
                }
            }
        });
    }
    setIcon() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const file = yield this.fileService.getFiles(1, 1, ' ', 'portal-icon', 'portal-bucket', ' ', ' ')
                .toPromise().catch(err => this.handleError(err));
            if (file !== undefined && file !== null && file.length > 0) {
                const furl = yield this.fileService.getFile('portal-bucket', file[0].fileId)
                    .toPromise().catch(err => this.handleError(err));
                if (furl !== null && furl.url !== null) {
                    this.appicon.href = furl.url;
                }
            }
            this.loading = false;
        });
    }
    getUser() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const eml = (yield this.keycloakService.loadUserProfile()).email;
            const ress = yield this.userService.getUser(0, 0, eml, null).toPromise().catch(err => this.handleError(err));
            // Replace the user id with the users user id later
            const lang = yield this.language.getLanguage(1).toPromise().catch(err => this.handleError(err));
            if (lang.userId > 0) {
                const pass = 'ranitessarldev2019';
                // const enclanguage = lang.lang;
                const enclanguage = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].encrypt(lang.lang, pass).toString();
                const dom = src_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].domain;
                this.cookieService.set('goepla-portal-language', enclanguage, 1000, '/', dom, false, 'Lax');
                localStorage.setItem('language', lang.lang);
            }
            if (ress !== undefined && ress !== null && ress.userId > 0) {
                const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
                const oid = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].encrypt(JSON.stringify(ress.organisationId), v.pass).toString();
                const uid = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].encrypt(JSON.stringify(ress.userId), v.pass).toString();
                localStorage.setItem('oi', oid);
                localStorage.setItem('ui', uid);
                yield this.getGroups();
            }
            else {
                this.loading = false;
                this.pop = true;
                // this.router.navigateByUrl('/unauthorizeduser');
                // tslint:disable-next-line: deprecation
                this.translate.get('GENERAL.USERNOTFOUND').subscribe((resp) => {
                    this.confirm(resp);
                });
            }
        });
    }
    getGroups() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
            const va = localStorage.getItem('ui');
            const ui = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
            const uid = +ui;
            let mygroups = '';
            let username = '';
            let groupids = '';
            const usergroups = yield this.groupService.getUserGroups(0, uid).toPromise()
                .catch(err => this.handleError(err));
            if (usergroups != null && usergroups.length > 0) {
                for (const val of usergroups) {
                    groupids += val.groupId + ':';
                    const group = yield this.groupService.getGroupById(val.groupId).toPromise()
                        .catch(err => this.handleError(err));
                    if (group != null && group.length > 0) {
                        mygroups += group[0].groupName + ':';
                    }
                }
            }
            const gs = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].encrypt(mygroups, v.pass);
            localStorage.setItem('mg', gs);
            // localStorage.setItem('my-groups', mygroups);
            const user = yield this.userService.getUserInfo(uid, 0, ' ', ' ').toPromise()
                .catch(err => this.handleError(err));
            if (user != null && user.firstName != null && user.lastName != null) {
                username = user.firstName + ' ' + user.lastName;
            }
            // localStorage.setItem('user-name', username);
            // localStorage.setItem('user-group-ids', groupids);
            yield this.getPermissions(user, groupids);
        });
    }
    getPermissions(user, groupids) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const permissions = [];
            // const groupids = localStorage.getItem('user-group-ids');
            if (groupids != null) {
                const gids = groupids.split(':');
                if (gids !== undefined && gids !== null && gids.length > 0) {
                    for (const id of gids) {
                        if (id !== '') {
                            const perms = yield this.permService.getUserPermissions(0, id, ' ').toPromise()
                                .catch(err => this.handleError(err));
                            if (perms != null && perms.length > 0) {
                                for (const perm of perms) {
                                    // localStorage.setItem(perm.perm, perm.perm);
                                    permissions.push(perm.perm);
                                }
                            }
                        }
                    }
                }
            }
            const usr = new _Models_User__WEBPACK_IMPORTED_MODULE_18__["User"]();
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
            const us = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].encrypt(JSON.stringify(user), v.pass);
            localStorage.setItem('eu', us);
            yield this.setLastLogin();
            this.pop = false;
            this.authService.login(usr);
            // window.location.reload();
            this.router.navigateByUrl('/home');
            this.loading = false;
        });
    }
    setLastLogin() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const v = new _Models_variables__WEBPACK_IMPORTED_MODULE_15__["Variables"]();
            const va = localStorage.getItem('eu');
            const eu = crypto_js__WEBPACK_IMPORTED_MODULE_16__["AES"].decrypt(va, v.pass).toString(crypto_js__WEBPACK_IMPORTED_MODULE_16__["enc"].Utf8);
            const usr = JSON.parse(eu);
            const upt = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["UserUpdater"]();
            upt.Id = usr.userId;
            upt.Values = [];
            const llogin = new _Models_KeyValue__WEBPACK_IMPORTED_MODULE_14__["KeyValue"]();
            llogin.Key = 'lst_login';
            upt.Values.push(llogin);
            yield this.userService.putUser(upt.Id, upt).toPromise().catch(err => this.handleError(err));
        });
    }
    gotoAccount() {
        window.open(this.urls.keycloakUrl + '/auth/realms/GoeplaRealm/account');
    }
    gotoLanguage() {
        this.router.navigateByUrl('/language');
    }
    logout() {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        this.cookieService.delete('goepla-portal-login');
        // this.keycloakService.logout(this.urls.appUrl + '/');
    }
    loadUserProfile() {
        /*this.keycloakService.loadUserProfile().then((user) => {
          this.fullName = user.firstName + ' ' + user.lastName;
        });*/
    }
    gotoManage() {
        this.router.navigateByUrl('/manage');
    }
    confirm(msg) {
        this.confirmationService.confirm({
            message: msg,
            accept: () => {
                // Actual logic to perform a confirmation
                this.auth.logout();
            },
            reject: (type) => {
                this.auth.logout();
            }
        });
    }
    handleError(err) {
        console.log(err);
        this.loading = false;
        localStorage.setItem('oi', '');
        localStorage.setItem('ui', '');
        return;
    }
    unloadHandler(event) {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        this.cookieService.delete('goepla-portal-login');
    }
    beforeUnloadHandler(event) {
        localStorage.clear();
        this.cookieService.delete('goepla-portal-organisation-id');
        this.cookieService.delete('goepla-portal-user-id');
        this.cookieService.delete('goepla-portal-language');
        this.cookieService.delete('goepla-portal-login');
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_11__["TranslateService"] },
    { type: _Services_portal_info_portal_info_service__WEBPACK_IMPORTED_MODULE_5__["PortalInfoService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__["Title"] },
    { type: _Services_users_users_service__WEBPACK_IMPORTED_MODULE_4__["UsersService"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_12__["ConfirmationService"] },
    { type: ngx_cookie_service__WEBPACK_IMPORTED_MODULE_3__["CookieService"] },
    { type: _Services_users_users_service__WEBPACK_IMPORTED_MODULE_4__["UsersService"] },
    { type: _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: _Services_language_language_service__WEBPACK_IMPORTED_MODULE_21__["LanguageService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_17__["FormBuilder"] },
    { type: _Services_image_image_service__WEBPACK_IMPORTED_MODULE_20__["ImageService"] },
    { type: _Services_permission_permission_service__WEBPACK_IMPORTED_MODULE_22__["PermissionService"] },
    { type: _Services_groups_groups_service__WEBPACK_IMPORTED_MODULE_19__["GroupsService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__["DomSanitizer"] },
    { type: _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: keycloak_angular__WEBPACK_IMPORTED_MODULE_9__["KeycloakService"] },
    { type: _Services_file_file_service__WEBPACK_IMPORTED_MODULE_1__["FileService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["HostListener"])('window:unload', ['$event'])
], AppComponent.prototype, "unloadHandler", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["HostListener"])('window:beforeunload', ['$event'])
], AppComponent.prototype, "beforeUnloadHandler", null);
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_8__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: HttpLoaderFactory, AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpLoaderFactory", function() { return HttpLoaderFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Components_change_pin_change_pin_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Components/change-pin/change-pin.component */ "./src/app/Components/change-pin/change-pin.component.ts");
/* harmony import */ var _Components_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Components/change-password/change-password.component */ "./src/app/Components/change-password/change-password.component.ts");
/* harmony import */ var _Components_unauthorized_user_unauthorized_user_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Components/unauthorized-user/unauthorized-user.component */ "./src/app/Components/unauthorized-user/unauthorized-user.component.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Services/auth/auth.service */ "./src/app/Services/auth/auth.service.ts");
/* harmony import */ var _Components_login_login_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Components/login/login.component */ "./src/app/Components/login/login.component.ts");
/* harmony import */ var _Components_upload_icon_upload_icon_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Components/upload-icon/upload-icon.component */ "./src/app/Components/upload-icon/upload-icon.component.ts");
/* harmony import */ var _Components_icons_icons_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Components/icons/icons.component */ "./src/app/Components/icons/icons.component.ts");
/* harmony import */ var _Components_null_null_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Components/null/null.component */ "./src/app/Components/null/null.component.ts");
/* harmony import */ var _Components_notification_notification_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Components/notification/notification.component */ "./src/app/Components/notification/notification.component.ts");
/* harmony import */ var _Components_home1_home1_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Components/home1/home1.component */ "./src/app/Components/home1/home1.component.ts");
/* harmony import */ var _Components_language_language_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Components/language/language.component */ "./src/app/Components/language/language.component.ts");
/* harmony import */ var _Components_app_detail_app_detail_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Components/app-detail/app-detail.component */ "./src/app/Components/app-detail/app-detail.component.ts");
/* harmony import */ var _Components_create_app_create_app_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Components/create-app/create-app.component */ "./src/app/Components/create-app/create-app.component.ts");
/* harmony import */ var _Components_instance_detail_instance_detail_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Components/instance-detail/instance-detail.component */ "./src/app/Components/instance-detail/instance-detail.component.ts");
/* harmony import */ var _Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Services/userappinstnce/userappinstance.service */ "./src/app/Services/userappinstnce/userappinstance.service.ts");
/* harmony import */ var _Components_manage_instances_manage_instances_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Components/manage-instances/manage-instances.component */ "./src/app/Components/manage-instances/manage-instances.component.ts");
/* harmony import */ var _Helpers_Data__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Helpers/Data */ "./src/app/Helpers/Data.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _Interceptors_httpconfig_interceptor__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Interceptors/httpconfig.interceptor */ "./src/app/Interceptors/httpconfig.interceptor.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var keycloak_angular__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! keycloak-angular */ "./node_modules/keycloak-angular/fesm2015/keycloak-angular.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _ngx_translate_http_loader__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @ngx-translate/http-loader */ "./node_modules/@ngx-translate/http-loader/fesm2015/ngx-translate-http-loader.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _Components_create_instance_create_instance_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./Components/create-instance/create-instance.component */ "./src/app/Components/create-instance/create-instance.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _Components_manage_manage_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./Components/manage/manage.component */ "./src/app/Components/manage/manage.component.ts");
/* harmony import */ var _Components_manage_apps_manage_apps_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Components/manage-apps/manage-apps.component */ "./src/app/Components/manage-apps/manage-apps.component.ts");
/* harmony import */ var _Models_Urls__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./Models/Urls */ "./src/app/Models/Urls.ts");
/* harmony import */ var _Components_portal_info_portal_info_component__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Components/portal-info/portal-info.component */ "./src/app/Components/portal-info/portal-info.component.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _Helpers_route_reuse_strategy__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Helpers/route-reuse.strategy */ "./src/app/Helpers/route-reuse.strategy.ts");
/* harmony import */ var _Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./Services/auth-guard/auth-guard.service */ "./src/app/Services/auth-guard/auth-guard.service.ts");
/* harmony import */ var primeng_accordion__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! primeng/accordion */ "./node_modules/primeng/fesm2015/primeng-accordion.js");
/* harmony import */ var primeng_toolbar__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! primeng/toolbar */ "./node_modules/primeng/fesm2015/primeng-toolbar.js");
/* harmony import */ var primeng_inputtext__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! primeng/inputtext */ "./node_modules/primeng/fesm2015/primeng-inputtext.js");
/* harmony import */ var primeng_dialog__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! primeng/dialog */ "./node_modules/primeng/fesm2015/primeng-dialog.js");
/* harmony import */ var primeng_button__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! primeng/button */ "./node_modules/primeng/fesm2015/primeng-button.js");
/* harmony import */ var primeng_menubar__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! primeng/menubar */ "./node_modules/primeng/fesm2015/primeng-menubar.js");
/* harmony import */ var primeng_splitbutton__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! primeng/splitbutton */ "./node_modules/primeng/fesm2015/primeng-splitbutton.js");
/* harmony import */ var primeng_panel__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! primeng/panel */ "./node_modules/primeng/fesm2015/primeng-panel.js");
/* harmony import */ var primeng_radiobutton__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! primeng/radiobutton */ "./node_modules/primeng/fesm2015/primeng-radiobutton.js");
/* harmony import */ var primeng_table__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! primeng/table */ "./node_modules/primeng/fesm2015/primeng-table.js");
/* harmony import */ var primeng_dropdown__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! primeng/dropdown */ "./node_modules/primeng/fesm2015/primeng-dropdown.js");
/* harmony import */ var primeng_message__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! primeng/message */ "./node_modules/primeng/fesm2015/primeng-message.js");
/* harmony import */ var primeng_messages__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! primeng/messages */ "./node_modules/primeng/fesm2015/primeng-messages.js");
/* harmony import */ var primeng_confirmdialog__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! primeng/confirmdialog */ "./node_modules/primeng/fesm2015/primeng-confirmdialog.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var primeng_progressspinner__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! primeng/progressspinner */ "./node_modules/primeng/fesm2015/primeng-progressspinner.js");
/* harmony import */ var primeng_picklist__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! primeng/picklist */ "./node_modules/primeng/fesm2015/primeng-picklist.js");
/* harmony import */ var primeng_card__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! primeng/card */ "./node_modules/primeng/fesm2015/primeng-card.js");
/* harmony import */ var primeng_scrollpanel__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! primeng/scrollpanel */ "./node_modules/primeng/fesm2015/primeng-scrollpanel.js");
/* harmony import */ var primeng_menu__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! primeng/menu */ "./node_modules/primeng/fesm2015/primeng-menu.js");
/* harmony import */ var primeng_colorpicker__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! primeng/colorpicker */ "./node_modules/primeng/fesm2015/primeng-colorpicker.js");
/* harmony import */ var ngx_cookie_service__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ngx-cookie-service */ "./node_modules/ngx-cookie-service/ngx-cookie-service.js");
/* harmony import */ var angular_oauth2_oidc__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! angular-oauth2-oidc */ "./node_modules/angular-oauth2-oidc/fesm2015/angular-oauth2-oidc.js");
/* harmony import */ var detect_browser__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! detect-browser */ "./node_modules/detect-browser/es/index.js");
/* harmony import */ var _Models_variables__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./Models/variables */ "./src/app/Models/variables.ts");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");










































 // accordion and accordion tab






















Object(_angular_core__WEBPACK_IMPORTED_MODULE_20__["enableProdMode"])();
const keycloakService = new keycloak_angular__WEBPACK_IMPORTED_MODULE_26__["KeycloakService"]();
function HttpLoaderFactory(httpClient) {
    return new _ngx_translate_http_loader__WEBPACK_IMPORTED_MODULE_29__["TranslateHttpLoader"](httpClient);
}
// Detect browser
// https://www.npmjs.com/package/detect-browser
// const { detect } = require('detect-browser');



const browser = Object(detect_browser__WEBPACK_IMPORTED_MODULE_64__["detect"])();
let AppModule = class AppModule {
    constructor(router, translate, auth) {
        this.router = router;
        this.translate = translate;
        this.auth = auth;
        this.urls = new _Models_Urls__WEBPACK_IMPORTED_MODULE_36__["Urls"]();
        this.variables = new _Models_variables__WEBPACK_IMPORTED_MODULE_65__["Variables"]();
        // router.navigateByUrl('/');
        localStorage.setItem('oi', '');
        localStorage.setItem('ui', '');
        // keycloakService.isLoggedIn().then(async (res) => {
        //   console.log(await keycloakService.isLoggedIn())
        //   console.log(res)
        //   if (res === true) {
        //     console.log(res)
        //     const url = new Urls();
        //     keycloakService.logout(url.appUrl + '/');
        //   }
        // });
    }
    ngDoBootstrap(app) {
        localStorage.setItem('browser', 'true');
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].useKeycloak === 'true' || src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].useKeycloak === 'false') {
            keycloakService
                .init({
                config: {
                    url: this.urls.keycloakUrl + '/auth',
                    realm: this.variables.realm,
                    clientId: this.variables.clientid
                },
                initOptions: {
                    onLoad: 'login-required',
                    checkLoginIframe: false,
                    promiseType: 'legacy'
                },
                enableBearerInterceptor: true,
                bearerPrefix: 'Bearer',
                bearerExcludedUrls: [
                    '/assets',
                    '/clients/public'
                ]
            })
                .then(() => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                localStorage.setItem('oi', '');
                localStorage.setItem('ui', '');
                app.bootstrap(_app_component__WEBPACK_IMPORTED_MODULE_24__["AppComponent"]);
                _angular_service_worker__WEBPACK_IMPORTED_MODULE_66__["ServiceWorkerModule"].register('ngsw-worker.js', { enabled: src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production });
            }))
                .catch(error => console.error('[ngDoBootstrap] init Keycloak failed', error));
        }
        else {
            localStorage.setItem('browser', 'true');
            if (this.auth.isLoggedIn() === true) {
                app.bootstrap(_app_component__WEBPACK_IMPORTED_MODULE_24__["AppComponent"]);
            }
            else {
                localStorage.setItem('oi', '');
                localStorage.setItem('ui', '');
                app.bootstrap(_Components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"]);
                localStorage.clear();
                this.router.navigateByUrl('/login');
            }
        }
    }
    handleError(err) {
        console.log(err);
    }
};
AppModule.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_31__["Router"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_28__["TranslateService"] },
    { type: _Services_auth_auth_service__WEBPACK_IMPORTED_MODULE_5__["AuthService"] }
];
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_20__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_24__["AppComponent"],
            _Components_home1_home1_component__WEBPACK_IMPORTED_MODULE_11__["Home1Component"],
            _Components_create_instance_create_instance_component__WEBPACK_IMPORTED_MODULE_32__["CreateInstanceComponent"],
            _Components_manage_manage_component__WEBPACK_IMPORTED_MODULE_34__["ManageComponent"],
            _Components_instance_detail_instance_detail_component__WEBPACK_IMPORTED_MODULE_15__["InstanceDetailComponent"],
            _Components_manage_apps_manage_apps_component__WEBPACK_IMPORTED_MODULE_35__["ManageAppsComponent"],
            _Components_manage_instances_manage_instances_component__WEBPACK_IMPORTED_MODULE_17__["ManageInstancesComponent"],
            _Components_create_app_create_app_component__WEBPACK_IMPORTED_MODULE_14__["CreateAppComponent"],
            _Components_app_detail_app_detail_component__WEBPACK_IMPORTED_MODULE_13__["AppDetailComponent"],
            _Components_language_language_component__WEBPACK_IMPORTED_MODULE_12__["LanguageComponent"],
            _Components_portal_info_portal_info_component__WEBPACK_IMPORTED_MODULE_37__["PortalInfoComponent"],
            _Components_notification_notification_component__WEBPACK_IMPORTED_MODULE_10__["NotificationComponent"],
            _Components_null_null_component__WEBPACK_IMPORTED_MODULE_9__["NullComponent"],
            _Components_icons_icons_component__WEBPACK_IMPORTED_MODULE_8__["IconsComponent"],
            _Components_upload_icon_upload_icon_component__WEBPACK_IMPORTED_MODULE_7__["UploadIconComponent"],
            _Components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"],
            _Components_unauthorized_user_unauthorized_user_component__WEBPACK_IMPORTED_MODULE_3__["UnauthorizedUserComponent"],
            _Components_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_2__["ChangePasswordComponent"],
            _Components_change_pin_change_pin_component__WEBPACK_IMPORTED_MODULE_1__["ChangePinComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_19__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_23__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_25__["BrowserAnimationsModule"],
            keycloak_angular__WEBPACK_IMPORTED_MODULE_26__["KeycloakAngularModule"],
            angular_oauth2_oidc__WEBPACK_IMPORTED_MODULE_63__["OAuthModule"].forRoot(),
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatMenuModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSidenavModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatListModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_21__["HttpClientModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatAutocompleteModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatButtonToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatChipsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatCommonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatDatepickerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatDividerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatExpansionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatGridListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatLineModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatMenuModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatNativeDateModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatOptionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatProgressSpinnerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatPseudoCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatRadioModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatRippleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSelectModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSidenavModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSlideToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSliderModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSnackBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatSortModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatStepperModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_30__["MatTooltipModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_27__["FlexLayoutModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_33__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_33__["ReactiveFormsModule"],
            primeng_accordion__WEBPACK_IMPORTED_MODULE_41__["AccordionModule"],
            primeng_panel__WEBPACK_IMPORTED_MODULE_48__["PanelModule"],
            primeng_button__WEBPACK_IMPORTED_MODULE_45__["ButtonModule"],
            primeng_radiobutton__WEBPACK_IMPORTED_MODULE_49__["RadioButtonModule"],
            primeng_toolbar__WEBPACK_IMPORTED_MODULE_42__["ToolbarModule"],
            primeng_splitbutton__WEBPACK_IMPORTED_MODULE_47__["SplitButtonModule"],
            primeng_table__WEBPACK_IMPORTED_MODULE_50__["TableModule"],
            primeng_dropdown__WEBPACK_IMPORTED_MODULE_51__["DropdownModule"],
            primeng_inputtext__WEBPACK_IMPORTED_MODULE_43__["InputTextModule"],
            primeng_messages__WEBPACK_IMPORTED_MODULE_53__["MessagesModule"],
            primeng_message__WEBPACK_IMPORTED_MODULE_52__["MessageModule"],
            primeng_confirmdialog__WEBPACK_IMPORTED_MODULE_54__["ConfirmDialogModule"],
            primeng_menubar__WEBPACK_IMPORTED_MODULE_46__["MenubarModule"],
            primeng_inputtext__WEBPACK_IMPORTED_MODULE_43__["InputTextModule"],
            primeng_progressspinner__WEBPACK_IMPORTED_MODULE_56__["ProgressSpinnerModule"],
            primeng_picklist__WEBPACK_IMPORTED_MODULE_57__["PickListModule"],
            primeng_card__WEBPACK_IMPORTED_MODULE_58__["CardModule"],
            primeng_dialog__WEBPACK_IMPORTED_MODULE_44__["DialogModule"],
            primeng_scrollpanel__WEBPACK_IMPORTED_MODULE_59__["ScrollPanelModule"],
            primeng_menu__WEBPACK_IMPORTED_MODULE_60__["MenuModule"],
            primeng_colorpicker__WEBPACK_IMPORTED_MODULE_61__["ColorPickerModule"],
            _ngx_translate_core__WEBPACK_IMPORTED_MODULE_28__["TranslateModule"].forRoot({
                loader: {
                    provide: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_28__["TranslateLoader"],
                    useFactory: HttpLoaderFactory,
                    deps: [_angular_common_http__WEBPACK_IMPORTED_MODULE_21__["HttpClient"]]
                }
            }),
            _angular_router__WEBPACK_IMPORTED_MODULE_31__["RouterModule"].forRoot([
                { path: 'unsupported-browser', component: _Components_null_null_component__WEBPACK_IMPORTED_MODULE_9__["NullComponent"] },
                { path: 'home', redirectTo: 'home/', pathMatch: 'full' },
                { path: 'home/:name', component: _Components_home1_home1_component__WEBPACK_IMPORTED_MODULE_11__["Home1Component"] },
                { path: 'manage', component: _Components_manage_manage_component__WEBPACK_IMPORTED_MODULE_34__["ManageComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'manageinstances', component: _Components_manage_instances_manage_instances_component__WEBPACK_IMPORTED_MODULE_17__["ManageInstancesComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'createinstance', component: _Components_create_instance_create_instance_component__WEBPACK_IMPORTED_MODULE_32__["CreateInstanceComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'instancedetail', component: _Components_instance_detail_instance_detail_component__WEBPACK_IMPORTED_MODULE_15__["InstanceDetailComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'manageapps', component: _Components_manage_apps_manage_apps_component__WEBPACK_IMPORTED_MODULE_35__["ManageAppsComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'createapp', component: _Components_create_app_create_app_component__WEBPACK_IMPORTED_MODULE_14__["CreateAppComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'appdetail', component: _Components_app_detail_app_detail_component__WEBPACK_IMPORTED_MODULE_13__["AppDetailComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'language', component: _Components_language_language_component__WEBPACK_IMPORTED_MODULE_12__["LanguageComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'portalinfo', component: _Components_portal_info_portal_info_component__WEBPACK_IMPORTED_MODULE_37__["PortalInfoComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'icons', component: _Components_icons_icons_component__WEBPACK_IMPORTED_MODULE_8__["IconsComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'uploadicon', component: _Components_upload_icon_upload_icon_component__WEBPACK_IMPORTED_MODULE_7__["UploadIconComponent"], canActivate: [_Services_auth_guard_auth_guard_service__WEBPACK_IMPORTED_MODULE_40__["AuthGuardService"]] },
                { path: 'login', component: _Components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"] },
                { path: 'unauthorizeduser', component: _Components_unauthorized_user_unauthorized_user_component__WEBPACK_IMPORTED_MODULE_3__["UnauthorizedUserComponent"] },
                { path: 'change-password', component: _Components_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_2__["ChangePasswordComponent"] },
                { path: 'change-pin', component: _Components_change_pin_change_pin_component__WEBPACK_IMPORTED_MODULE_1__["ChangePinComponent"] }
            ])
        ],
        providers: [
            ngx_cookie_service__WEBPACK_IMPORTED_MODULE_62__["CookieService"],
            primeng_api__WEBPACK_IMPORTED_MODULE_55__["ConfirmationService"],
            _Components_home1_home1_component__WEBPACK_IMPORTED_MODULE_11__["Home1Component"],
            _app_component__WEBPACK_IMPORTED_MODULE_24__["AppComponent"],
            [{
                    provide: _angular_router__WEBPACK_IMPORTED_MODULE_31__["RouteReuseStrategy"],
                    useClass: _Helpers_route_reuse_strategy__WEBPACK_IMPORTED_MODULE_39__["CacheRouteReuseStrategy"]
                }],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_19__["Title"],
            {
                provide: keycloak_angular__WEBPACK_IMPORTED_MODULE_26__["KeycloakService"],
                useValue: keycloakService
            },
            _Helpers_Data__WEBPACK_IMPORTED_MODULE_18__["Data"],
            _Services_userappinstnce_userappinstance_service__WEBPACK_IMPORTED_MODULE_16__["UserappinstanceService"],
            {
                provide: _angular_common__WEBPACK_IMPORTED_MODULE_38__["LocationStrategy"],
                useClass: _angular_common__WEBPACK_IMPORTED_MODULE_38__["HashLocationStrategy"]
            },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_21__["HTTP_INTERCEPTORS"], useClass: _Interceptors_httpconfig_interceptor__WEBPACK_IMPORTED_MODULE_22__["HttpConfigInterceptor"], multi: true }
        ],
        // bootstrap: [AppComponent],
        entryComponents: [
            _app_component__WEBPACK_IMPORTED_MODULE_24__["AppComponent"],
            _Components_null_null_component__WEBPACK_IMPORTED_MODULE_9__["NullComponent"],
            _Components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"]
        ]
    })
], AppModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    // production: false,
    // keycloakUrl: 'http://localhost:8080',
    // // baseUrl: 'http://144.91.108.116:3001',
    // baseUrl: 'http://169.254.80.80:3001',
    // // baseUrl: 'https://localhost:44321',
    // appUrl: 'http://localhost:4220',
    // usmUrl: 'http://169.254.80.80:3011',
    // // usmUrl: 'http://144.91.108.116:3011',
    // // usmUrl: 'https://localhost:44328',
    // domain: 'localhost',
    // useKeycloak: 'false',
    // realm: 'GoeplaRealm',
    // clientid: 'GoeplaClient',
    // flmApiUrl: 'http://localhost:3081'
    production: true,
    keycloakUrl: window["env"]["KEYCLOAKURL"] || "default",
    baseUrl: window["env"]["APIURL"] || "default",
    appUrl: window["env"]["APPURL"] || "default",
    usmUrl: window["env"]["USMURL"] || "default",
    domain: window["env"]["DOMAIN"] || "default",
    useKeycloak: window["env"]["USEKEYCLOAK"] || "default",
    realm: window["env"]["REALM"] || "default",
    clientid: window["env"]["CLIENTID"] || "default",
    flmApiUrl: window["env"]["FLMAPIURL"] || "default"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /app/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map